var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// index.ts
import { AppContext, Graphql } from "@hc/graphql";

// graphql/crud.ts
import { CrudSchema } from "@hc/graphql";
var WndlCrudSchema = class extends CrudSchema {
  static {
    __name(this, "WndlCrudSchema");
  }
  constructor(registry) {
    super(registry);
  }
  get budget() {
    return this.registry.collections.budget;
  }
  get budgetFee() {
    return this.registry.collections.budget_fee;
  }
  get businessArea() {
    return this.registry.collections.business_area;
  }
  get businessAreaCategory() {
    return this.registry.collections.business_area_category;
  }
  get company() {
    return this.registry.collections.company;
  }
  get companyAddress() {
    return this.registry.collections.company_address;
  }
  get companyBankAccount() {
    return this.registry.collections.company_bank_account;
  }
  get companyManager() {
    return this.registry.collections.company_manager;
  }
  get companyRelation() {
    return this.registry.collections.company_relation;
  }
  get companyVatNumber() {
    return this.registry.collections.company_vat_number;
  }
  get contentArticle() {
    return this.registry.collections.content_article;
  }
  get contentCategory() {
    return this.registry.collections.content_category;
  }
  get contentPage() {
    return this.registry.collections.content_page;
  }
  get contract() {
    return this.registry.collections.contract;
  }
  get country() {
    return this.registry.collections.country;
  }
  get currency() {
    return this.registry.collections.currency;
  }
  get currencyRate() {
    return this.registry.collections.currency_rate;
  }
  get invoice() {
    return this.registry.collections.invoice;
  }
  get invoiceDeposit() {
    return this.registry.collections.invoice_deposit;
  }
  get office() {
    return this.registry.collections.office;
  }
  get officeManager() {
    return this.registry.collections.office_manager;
  }
  get preset() {
    return this.registry.collections.preset;
  }
  get project() {
    return this.registry.collections.project;
  }
  get projectGroup() {
    return this.registry.collections.project_group;
  }
  get projectGroupManager() {
    return this.registry.collections.project_group_manager;
  }
  get projectManager() {
    return this.registry.collections.project_manager;
  }
  get service() {
    return this.registry.collections.service;
  }
  get serviceGroup() {
    return this.registry.collections.service_group;
  }
  get serviceInvoice() {
    return this.registry.collections.service_invoice;
  }
  get systemActivity() {
    return this.registry.collections.system_activity;
  }
  get systemMigrations() {
    return this.registry.collections.system_migrations;
  }
  get systemMigrationsLock() {
    return this.registry.collections.system_migrations_lock;
  }
  get systemWebhook() {
    return this.registry.collections.system_webhook;
  }
  get tax() {
    return this.registry.collections.tax;
  }
  get taxFederation() {
    return this.registry.collections.tax_federation;
  }
  get userAccount() {
    return this.registry.collections.user_account;
  }
  get userAccountGroup() {
    return this.registry.collections.user_account_group;
  }
  get userBookmark() {
    return this.registry.collections.user_bookmark;
  }
  get userGroup() {
    return this.registry.collections.user_group;
  }
};

// locales/de.json
var de_default = {
  invoice: {
    "invoice-inclusion-note": "(Bei Zahlungen bitte immer Rechnungsnummer angeben)",
    "tax-address": "Steueradresse",
    "invoice-number": "Rechnungsnummer",
    "credit-invoice-number": "Gutschrift",
    "vat-id": "Umsatzsteuer-Id",
    "for-invoice-number": "f\xFCr die Rechnung",
    "deposit-invoice-number": "Deposit Rechnungsnummer",
    "commission-overview": "Kommissionsrechnung",
    "credit-note-number": "Stornorechnung",
    "client-number": "Kundennummer",
    "reference-number": "Referenznummer",
    "place-of-event": "Veranstaltungsort",
    "date-of-event": "Veranstaltungsdatum",
    "project-name": "Projekt",
    "budget-name": "Budget",
    "purchase-number": "Bestellnummer",
    sum: {
      final: "Summe Service",
      cancelation: "Summe Stornobetrag",
      deposit: "Deposit Summe",
      provision: "Summe",
      credit: "Gutschrift Summe"
    },
    due: {
      final: "Zahlbetrag",
      cancelation: "Stornobetrag",
      deposit: "Zahlbetrag",
      provision: "Zahlbetrag",
      credit: "Zahlbetrag"
    },
    deposit: "Einzahlung",
    table: {
      "net-heading": "Nettobetrag",
      "tax-type-heading": "USt in %",
      "tax-amount-heading": "USt Betrag",
      "gross-heading": "Bruttobetrag",
      quantity: "Anzahl",
      description: "Beschreibung"
    },
    "rcv-note": "Lieferort au\xDFerhalb des Landes, ggf. umsatzsteuerpflichtiger Kunde (Art. 44/196 EG-Mehrwertsteuerrichtlinie)",
    "toms-note": "Margenregelung f\xFCr Reiseveranstalter gem\xE4\xDF Artikel 306 - 310 EU-Mehrwertsteuerrichtlinie 2006/112 anwendbar.",
    "czech-general-note": "Note for the Czech Republic: Zvl\xE1\u0161tn\xED re\u017Eim \u2013 cestovn\xED slu\u017Eba \u2013 Special scheme \u2013 travel service.",
    "austria-electronic-note": "Diese Elektronische Rechnung wurde auf Grundlage des \xA7 1 Abs. 1 E-Rechnung-UStV ohne digitale Signatur versandt, da wir davon ausgehen, dass in Ihrem Unternehmen ein innerbetriebliches Steuerungsverfahren existiert und Eingangsrechnungen vor Zahlung kontrolliert werden. Damit entf\xE4llt die bisher vorgesehene technisch aufwendige Pr\xFCfung der Signatur, die Archivierungspflicht ver\xE4ndert sich nicht.\nRechtliche Informationen zu diesem Thema entnehmen Sie bitte der URL http://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=20003090",
    "spain-sucoe-note": "Ums\xE4tze, die nach den Vorschriften \xFCber den Ort der Besteuerung nicht im spanischen MwSt.-Gebiet get\xE4tigt werden (Artikel 69.1 des spanischen MwSt.-Gesetzes).",
    "spain-rcv-zero-vat-note-1": "Unterliegt nicht der spanischen Mehrwertsteuer gem\xE4\xDF Art. 69 1. 1\xBA des Mehrwertsteuergesetzes 37/1992.",
    "spain-rcv-zero-vat-note-2": "Nicht mehrwertsteuerpflichtig gem\xE4\xDF Art. 44 der Richtlinie 2006/112/EG des Rates vom 28. November 2006.",
    "spain-rcv-non-zero-vat-note": "Es gilt Artikel 44/196 der EG-Mehrwertsteuerrichtlinie. Die gesamte Mehrwertsteuer ist enthalten.",
    "austria-toms-note": "TOMS (tour operator margin scheme) Margenbesteuerung gem\xE4\xDF \xA7 23 UStG zur Anwendung.",
    "thank-you": "Danke f\xFCr Ihr entgegengebrachtes Vertrauen und dass Sie unseren Service nutzen!",
    "transfer-note": {
      amount: "{amount}",
      dueDate: "{due_date}",
      final: "Bitte \xFCberweisen Sie den offenen Betrag von {amount} bis zum {dueDate} auf unser unten angef\xFChrtes Konto. Bitte geben Sie bei der \xDCberweisung die Rechnungsnummer an. Alle Leistungen werden laut Angebot oder Budget abgerechnet. Bankgeb\xFChren m\xFCssen vom Zahler getragen werden.",
      deposit: "Bitte \xFCberweisen Sie den Betrag von {amount} bis zum {dueDate} auf unser unten angef\xFChrtes Konto. Bitte beachten Sie, dass die Mehrwertsteuer erst in der finalen Rechnung ausgewiesen wird. Alle Leistungen werden gem\xE4\xDF Angebot oder Budget berechnet. Bankgeb\xFChren m\xFCssen vom Zahler getragen werden.",
      provision: "Bitte \xFCberweisen Sie den Betrag von {amount} bis zum {dueDate} auf unser unten angef\xFChrtes Konto. Bankgeb\xFChren m\xFCssen vom Zahler getragen werden.",
      refund: "Bitte geben Sie Ihre Bankdaten an, um gegebenenfalls Geld zur\xFCckzuzahlen."
    },
    provision: {
      header: "Aufgrund vertraglicher Vereinbarung machen wir folgende Provision geltend:",
      position: "{quantity}x {service} \xE0 {net}, {description}",
      fixed: "{provision} Kommission",
      item: "{provision} Kommission pro Einheit",
      percent: "{provision} Kommission von {total_net}"
    },
    "send-to-client": {
      subject: "[{company}] Rechnung - {invoice} / {project}",
      layout: "Hallo!\n\n{message}\n\nMit freundlichen Gr\xFC\xDFen,\nIhr {company} Team",
      "message-final": "Das war es dann. Vielen Dank f\xFCr die Zusammenarbeit. Anbei finden Sie die Rechnung {invoice} f\xFCr Ihr Projekt {project}.\n\nWir bedanken uns f\xFCr Ihr Vertrauen in unsere Leistungen und w\xFCrden uns \xFCber p\xFCnktliche Bezahlung freuen.\n\nWussten Sie schon, dass wir an 12 Standorten in sieben L\xE4ndern Europas vertreten sind. Wir w\xFCrden uns freuen auch dort mit Ihnen zusammen zu arbeiten.",
      "message-deposit": "Anbei finden Sie im Anhang die vereinbarte Deposit Rechnung {invoice}.",
      "message-provision": "Anbei finden Sie im Anhang die vereinbarte Kommissionsrechnung {invoice}.",
      "message-credit": "Anbei finden Sie im Anhang die vereinbarte Kredit Rechnung {invoice}.",
      "message-cancelation": "Anbei finden Sie im Anhang die vereinbarte Stornierungs Rechnung {invoice}."
    }
  },
  budget: {
    "project-name": "Projekt",
    "budget-name": "Budget",
    "project-city-country": "Stadt, Land",
    "project-reference": "Projektreferenz",
    "start-date": "Startdatum",
    "end-date": "Enddatum",
    "number-of-participants": "Teilnehmerzahl",
    date: "Datum",
    currency: "W\xE4hrung",
    status: "Status",
    item: "Service",
    remarks: "Bemerkungen",
    description: "Beschreibung",
    "item-gross": "Einzelpreis (Brutto)",
    "item-net": "Einzelpreis (Netto)",
    "item-price": "Preis",
    "subtotal-net": "Summe (Netto)",
    "subtotal-gross": "Zwischensumme (Brutto)",
    quantity: "Menge",
    factor: "Faktor",
    category: "Kategorie",
    tax: "Steuer",
    "tax-category": "Steuer",
    "tax-in-percentage": "Steuer %",
    "tax-amount": "Steuerbetrag",
    "total-gross-amount": "GP (Brutto)",
    "grand-total": "Gesamtbetrag",
    "grand-total-buy": "Gesamtbetrag (EK)",
    subtotal: "Zwischensumme",
    "subtotal-buy": "Zwischensumme (EK)",
    "event-management": "Event Management",
    contingency: {
      title: "Notfallregel",
      description: 'Die Notfallregel zielt darauf ab, unvorhergesehene Kosten zu decken, die w\xE4hrend Ihrer Veranstaltung auftreten k\xF6nnen, um eine Anpassung des Bestellbetrags zu vermeiden.\nDiese "Sicherheitsmarge" wird aus dem endg\xFCltigen Kostenblatt entfernt, das an die tats\xE4chlichen endg\xFCltigen Kosten angepasst wird.'
    },
    terms: {
      "no-participants": "Die oben angegebenen Raten sind g\xFCltig f\xFCr das Jahr {currentYear}.",
      "with-participants": "Die oben angegebenen Raten sind g\xFCltig f\xFCr das Jahr {currentYear} und {participantCount} Personen.",
      "in-case-of-change": "Sollte sich der Umfang oder die Teilnehmerzahl ver\xE4ndern, behalten wir uns das Recht vor, die Preise entsprechend anzupassen.\r\nSollte es \xC4nderungen bei den Steuern oder dem Finanzkodex geben, behalten wir uns das Recht vor, die Raten und/oder die Steuern dementsprechend anzupassen.\r\nDurch die aktuelle Inflationsrate k\xF6nnen die Preise kurzfristigen \xC4nderungen unterliegen, wor\xFCber wir rechtzeitig informieren. Das Angebot ist freibleibend und h\xE4ngt von der tats\xE4chlichen Verf\xFCgbarkeit ab."
    },
    "provision-amount": "Kommissionsbetrag",
    provision: "Kommission",
    "buy-price-label": "EK",
    "sell-price-label": "VK",
    "airbus-purchase-order-note": "Bitte die Bestellpositionen einzeln nach unterschiedlichen Steuers\xE4tzen im Einkaufswagen einstellen:",
    "send-to-client": {
      subject: "[{company}] Budget - {budget} / {project}",
      message: "Guten Tag!\n\nGeschafft! Hier ist die Budget-\xDCbersicht f\xFCr Ihr Project {project}.\n\nWir haben noch mehr Ideen und freuen uns, von Ihnen zu h\xF6ren.\n\nMit freundlichen Gr\xFC\xDFen,\nIhr {company} Team"
    },
    "deposit-services": {
      "total-gross-amount": "Gesamtsumme (Brutto)",
      "deposit-amount": "Deposit",
      "deposit-percentage": "Deposit (%)"
    }
  },
  contract: {
    label: "Vertrag zum Projekt",
    agbLink: "https://time-change.com/agbs",
    dueDate: "{due_date}",
    "project-name": "Projekt",
    "project-reference": "Projektreferenz",
    "place-of-event": "Veranstaltungsort",
    "participant-count": "Teilnehmerzahl",
    "confirmation-note": "Hiermit beauftrage ich die {issuer} auf Grundlage des obigen Angebots unter Einbeziehung der AGB.",
    "start-date": "Startdatum",
    "end-date": "Enddatum",
    "company-stamp": "Namen/Position des Unterzeichnenden der {company}",
    "place-date": "Ort, Datum",
    signature: "Unterschrift",
    "budget-name": "Budget",
    between: "Vereinbarung zwischen:",
    "issuer-label": "Auftragnehmer",
    "recipient-label": "Auftraggeber",
    "place-issue-date": "Ort, Ausstellungsdatum",
    tos: "Unser Angebot ist bis zu unserer Gegenzeichnung freibleibend. Unsere Leistungen und Lieferungen erfolgen ausschlie\xDFlich auf der Grundlage unserer Allgemeinen Gesch\xE4ftsbedingungen (\u201EAGB\u201C), die sie unter {agbLink} finden, sowie etwaiger hiergegen\xFCber vorrangiger individueller Vereinbarungen.",
    offer: {
      headline: "FREIBLEIBENDES ANGEBOT bis zum {offer_validity_date}",
      text: "Wir bedanken uns f\xFCr Ihr Interesse und unterbreiten Ihnen folgendes Angebot f\xFCr Ihre gesch\xE4ftliche Veranstaltung:"
    },
    "payment-break-down": {
      "line-1": "Es ist eine Rechnungstellung nach Ma\xDFgabe der nachfolgend beschriebenen Staffelung vereinbart:",
      "line-2": "{amount}% unmittelbar nach Vertragsschluss",
      "line-3": "{amount}% zum {date}"
    },
    bank: {
      note: "Die vereinbarte Verg\xFCtung wird mit Vertragsschluss f\xE4llig und ist innerhalb der vereinbarten Frist, sp\xE4testens aber innerhalb von 14 Werktagen ab Rechnungseingang bei Ihnen ohne Abzug auf folgendes Konto zu zahlen:",
      "account-holder": "Kontoinhaber",
      "institute-name": "Kreditinstitut",
      iban: "IBAN",
      bic: "BIC/SWIFT"
    },
    "send-to-client": {
      subject: "[{company}] Contract - {budget} / {project}",
      message: "Hallo,\n\nanbei finden Sie den Vertrag zu unserem gemeinsamen Projekt \u201E{project}\u201C.\n\nIm Folgenden sind die Unterzeichner des Vertrags aufgef\xFChrt.\n\nName: {issuer_name}\nEmail: {issuer_email}\n\nName: {recipient_name}\nEmail: {recipient_email}\n\nBitte unterzeichnen Sie den Vertrag bis zum {offer_validity_date}.\n\nVielen Dank f\xFCr Ihren Auftrag und auf gute Zusammenarbeit.\n\nMit freundlichen Gr\xFC\xDFen,\nIhr {company} Team"
    }
  }
};

// locales/en.json
var en_default = {
  invoice: {
    "invoice-inclusion-note": "(for payments please always quote invoice no)",
    "tax-address": "Tax Adress",
    "invoice-number": "Invoice Number",
    "credit-invoice-number": "Credit Note",
    "vat-id": "VAT No.",
    "credit-note-number": "Cancellation Invoice",
    "for-invoice-number": "for Invoice",
    "deposit-invoice-number": "Deposit Invoice Number",
    "commission-overview": "Commission Invoice",
    "client-number": "Client Number",
    "reference-number": "Reference Number",
    "place-of-event": "Place of Event",
    "date-of-event": "Date of Event",
    "project-name": "Project",
    "budget-name": "Budget",
    "purchase-number": "Purchase Number",
    sum: {
      final: "Sum of Services",
      cancelation: "Sum Cancellation",
      deposit: "Deposit Sum",
      provision: "Sum",
      credit: "Credit Sum"
    },
    due: {
      final: "Amount due",
      cancelation: "Cancellation Amount",
      deposit: "Deposit Amount",
      provision: "Commission Amount",
      credit: "Credit Amount"
    },
    deposit: "Deposit",
    table: {
      "net-heading": "Amount Net",
      "tax-type-heading": "VAT in %",
      "tax-amount-heading": "VAT Amount",
      "gross-heading": "Amount Gross",
      quantity: "Quantity",
      description: "Description"
    },
    "rcv-note": "Place of supply is outside the country, customer liable to account for VAT (Art. 44/196 EC VAT Directive).",
    "toms-note": "Tour Operator Margin Scheme applicable, according to articles 306 \u2013 310 EU VAT Directive 2006/11.",
    "czech-general-note": "Note for the Czech Republic: Zvl\xE1\u0161tn\xED re\u017Eim \u2013 cestovn\xED slu\u017Eba \u2013 Special scheme \u2013 travel service.",
    "austria-electronic-note": "This electronic invoice was sent without digital signature on the basis of code 1 Abs. 1 E-Rechnung-UStV.\nWe assume that your business uses an existing inner control procedure and incoming invoices are verified prior to payment execution.\nBased on these procedures the expensive audit procedure of the digital signature is obsolete. Nevertheless, the obligation to archive such documents remains unchanged.\nLegal information concerning this item can be found at this URL (in German only) http://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=20003090",
    "spain-sucoe-note": "Transaction non-subject within the Spanish VAT territory according to the VAT location rules (Article 69.1 of the Spanish VAT Law)",
    "spain-rcv-zero-vat-note-1": "No subject to the Spanish VAT according to art. 69 One. 1\xBA of the VAT law 37/1992.",
    "spain-rcv-zero-vat-note-2": "No subject to the Spanish VAT according to art.44 Council Directive 2006/112/EC of 28 November 2006.",
    "spain-rcv-non-zero-vat-note": "Article 44/196 EC VAT Directive applicable. All VAT is included.",
    "austria-toms-note": "TOMS (tour operator margin scheme) Margin taxation according to \xA7 23 UStG (Austrian Tax Law) applies.",
    "thank-you": "Thank you for using our services!",
    "transfer-note": {
      amount: "{amount}",
      dueDate: "{due_date}",
      final: "Please transfer the outstanding balance of {amount} without deduction to us by {dueDate}. Please use the bank account listed below. Please always state the invoice number. All services as written and quoted in the appendix. Bank charges must be covered by the payer.",
      deposit: "The deposit amount of {amount} is payable to us by {dueDate}. Please note that VAT will only be listed in the final invoice. All services as written and quoted in the appendix. Bank charges must be covered by the payer.",
      provision: "The amount of {amount} is payable to us by {dueDate}. Bank charges must be covered by the payer.",
      refund: "Please provide your banking details to pay back funds if applicable."
    },
    provision: {
      header: "According to contractual agreement, we are invoicing the below commission:",
      position: "{quantity}x {service} \xE0 {net}, {description}",
      fixed: "{provision} commission",
      item: "{provision} commission per Item",
      percent: "{provision} commission of {total_net}"
    },
    "send-to-client": {
      subject: "[{company}] Invoice - {invoice} / {project}",
      layout: "Hello!\n\n{message}\n\nKind regards,\nyour {company} team",
      "message-final": "It's a wrap. Thanks for the cooperation. Please find enclosed your invoice {invoice} from {company} for your project {project}.\n\nWe truly value your business and appreciate your timely payment. Please keep in mind that we have 12 offices in seven countries all over Europe. We would love to work with you there as well.",
      "message-deposit": "Please find attached the agreed deposit invoice {invoice}.",
      "message-credit": "Please find attached the agreed credit invoice {invoice}.",
      "message-cancelation": "Please find attached the agreed cancelation invoice {invoice}."
    }
  },
  budget: {
    "project-name": "Project",
    "budget-name": "Budget",
    "project-city-country": "City & Country of Project",
    "project-reference": "Project Reference",
    "start-date": "Start Date",
    "end-date": "End Date",
    "number-of-participants": "No. of Participants",
    date: "Date",
    currency: "Currency",
    status: "Status",
    item: "Item",
    remarks: "Remarks",
    description: "Description",
    "item-gross": "Price (Gross)",
    "item-net": "Price (Net)",
    "item-price": "Price",
    "subtotal-net": "Subtotal (Net)",
    "subtotal-gross": "Subtotal (Gross)",
    quantity: "Qty",
    factor: "Fct",
    category: "Category",
    tax: "Tax",
    "tax-category": "Tax",
    "tax-in-percentage": "Tax %",
    "tax-amount": "Tax Amount",
    "total-gross-amount": "Total (Gross)",
    "grand-total": "Grand Total",
    "grand-total-buy": "Grand Total (Buy)",
    subtotal: "Subtotal",
    "subtotal-buy": "Subtotal (Buy)",
    "event-management": "Event Management",
    contingency: {
      title: "Contingency Rule",
      description: 'The Contingency rule aims to cover unforeseen costs that could appear during your event, in order to avoid an adjustment of the Purchase Order amount.\nThis "safety margin" will be removed from the final cost sheet that is adjusted to the actual final expenses.'
    },
    terms: {
      "no-participants": "The above rates are valid for the year {currentYear}.",
      "with-participants": "The above rates are valid for the year {currentYear} and {participantCount} persons.",
      "in-case-of-change": "Should the scope of the project or number of participants change, we reserve the right to adjust our prices accordingly.\r\nShould there also be any change in tax or financial codes in general that effect this project we reserve the right to adjust our rates and/or VAT/tax amounts accordingly.\r\nDue to current inflation uncertainty, prices may increase going forward: If that happens the new prices will be sent to you. The offer is subject to change and depends on actual availability."
    },
    "provision-amount": "Commission Amount",
    provision: "Commission",
    "buy-price-label": "BUY",
    "sell-price-label": "SELL",
    "airbus-purchase-order-note": "Please set the order items individually according to different tax rates in the shopping cart:",
    "send-to-client": {
      subject: "[{company}] Budget - {budget} / {project}",
      message: "Hello!\n\nAlmost done! Here is your budget overview for your project {project}.\n\nWe have much more ideas and love to hear back from you.\n\nKind regards,\nyour {company} team"
    },
    "deposit-services": {
      "total-gross-amount": "Total (Gross)",
      "deposit-amount": "Deposit Amount",
      "deposit-percentage": "Deposit (%)"
    }
  },
  contract: {
    label: "Contract for the project",
    agbLink: "https://time-change.com/gtcs",
    dueDate: "{due_date}",
    "project-name": "Project",
    "project-reference": "Project Reference",
    "place-of-event": "Place of Event",
    "participant-count": "No. of Participants",
    "confirmation-note": "I hereby instruct {issuer} on the basis of the above offer, including the GTCs.",
    "start-date": "Start Date",
    "end-date": "End Date",
    "company-stamp": "Name/position of the signatory of {company}",
    "place-date": "Place, Date",
    signature: "Signature",
    "budget-name": "Budget",
    between: "Agreement between:",
    "issuer-label": "Contractor",
    "recipient-label": "Principal",
    "place-issue-date": "Place, Issue Date",
    tos: 'Our offer is subject to change until we have countersigned it. Our services and deliveries are provided exclusively on the basis of our General Terms and Conditions ("GTC"), which can be found at {agbLink}, as well as any individual agreements that take precedence over them.',
    offer: {
      headline: "NON-BINDING OFFER until {offer_validity_date}",
      text: "We thank you for your interest and would like to submit the following offer for your business event:"
    },
    "payment-break-down": {
      "line-1": "Invoicing is agreed in accordance with the scale described below:",
      "line-2": "{amount}% immediately after conclusion of the contract",
      "line-3": "{amount}% until {date}"
    },
    bank: {
      note: "The agreed remuneration shall become due upon conclusion of the contract and shall be paid to the following account without deduction within the agreed period, but at the latest within 14 working days of receipt of the invoice by you:",
      "account-holder": "Account Holder",
      "institute-name": "Bank Name",
      iban: "IBAN",
      bic: "BIC/SWIFT"
    },
    "send-to-client": {
      subject: "[{company}] Contract - {budget} / {project}",
      message: "Hello,\n\nenclosed you will find the contract to our joint project \u201E{project}\u201C.\n\nFollowing are the signing participants of the contract.\n\nName: {issuer_name}\nEmail: {issuer_email}\n\nName: {recipient_name}\nEmail: {recipient_email}\n\nPlease sign the contract by {offer_validity_date}.\n\nThank you for your order and I look forward to a good cooperation.\n\nYours sincerely,\n{company} team"
    }
  }
};

// crud/forms/index.ts
var forms_exports = {};
__export(forms_exports, {
  BUDGET_CONFIRMED_FORM: () => BUDGET_CONFIRMED_FORM,
  BUDGET_CREATE_FORM: () => BUDGET_CREATE_FORM,
  BUDGET_EDIT_FORM: () => BUDGET_EDIT_FORM,
  BUDGET_FEE_CONFIRMED_FORM: () => BUDGET_FEE_CONFIRMED_FORM,
  BUDGET_FEE_FORM: () => BUDGET_FEE_FORM,
  BUDGET_FORM: () => BUDGET_FORM,
  BUSINESS_AREA: () => BUSINESS_AREA,
  BUSINESS_AREA_CATEGORY: () => BUSINESS_AREA_CATEGORY,
  COMPANY_ADDRESS_FORM: () => COMPANY_ADDRESS_FORM,
  COMPANY_BANK_ACCOUNT_FORM: () => COMPANY_BANK_ACCOUNT_FORM,
  COMPANY_FORM: () => COMPANY_FORM,
  COMPANY_MANAGER_FORM: () => COMPANY_MANAGER_FORM,
  COMPANY_RELATION_FORM: () => COMPANY_RELATION_FORM,
  COMPANY_VAT_NUMBER_FORM: () => COMPANY_VAT_NUMBER_FORM,
  CONTENT_ARTICLE_FORM: () => CONTENT_ARTICLE_FORM,
  CONTENT_CATEGORY_FORM: () => CONTENT_CATEGORY_FORM,
  CONTENT_PAGE_FORM: () => CONTENT_PAGE_FORM,
  CONTRACT_CONFIRMED_FORM: () => CONTRACT_CONFIRMED_FORM,
  CONTRACT_CREATE_FORM: () => CONTRACT_CREATE_FORM,
  CONTRACT_DRAFT_FORM: () => CONTRACT_DRAFT_FORM,
  CONTRACT_FORM: () => CONTRACT_FORM,
  CONTRACT_SENT_FORM: () => CONTRACT_SENT_FORM,
  CONTRACT_SIGNED_FORM: () => CONTRACT_SIGNED_FORM,
  COUNTRY_FORM: () => COUNTRY_FORM,
  CURRENCY_FORM: () => CURRENCY_FORM,
  CURRENCY_RATE_FORM: () => CURRENCY_RATE_FORM,
  INVOICE_CANCELED_FORM: () => INVOICE_CANCELED_FORM,
  INVOICE_CONFIRMED_FORM: () => INVOICE_CONFIRMED_FORM,
  INVOICE_CREATE_FORM: () => INVOICE_CREATE_FORM,
  INVOICE_DEPOSIT_FORM: () => INVOICE_DEPOSIT_FORM,
  INVOICE_DRAFT_FORM: () => INVOICE_DRAFT_FORM,
  INVOICE_EDIT_DRAFT_FORM: () => INVOICE_EDIT_DRAFT_FORM,
  INVOICE_FORM: () => INVOICE_FORM,
  INVOICE_REQUESTED_FORM: () => INVOICE_REQUESTED_FORM,
  OFFICE_FORM: () => OFFICE_FORM,
  OFFICE_MANAGER_FORM: () => OFFICE_MANAGER_FORM,
  PROJECT_COMPLETED_FORM: () => PROJECT_COMPLETED_FORM,
  PROJECT_CONFIRMED_FORM: () => PROJECT_CONFIRMED_FORM,
  PROJECT_CREATE_FORM: () => PROJECT_CREATE_FORM,
  PROJECT_EDIT_FORM: () => PROJECT_EDIT_FORM,
  PROJECT_FORM: () => PROJECT_FORM,
  PROJECT_GROUP_FORM: () => PROJECT_GROUP_FORM,
  PROJECT_GROUP_MANAGER_FORM: () => PROJECT_GROUP_MANAGER_FORM,
  PROJECT_MANAGER_FORM: () => PROJECT_MANAGER_FORM,
  PROJECT_PENDING_FORM: () => PROJECT_PENDING_FORM,
  PROJECT_REQUESTED_FORM: () => PROJECT_REQUESTED_FORM,
  SERVICE_COMMISSIONED_FORM: () => SERVICE_COMMISSIONED_FORM,
  SERVICE_CONFIRMED_FORM: () => SERVICE_CONFIRMED_FORM,
  SERVICE_FORM: () => SERVICE_FORM,
  SERVICE_GROUP_FORM: () => SERVICE_GROUP_FORM,
  SERVICE_INVOICE_FORM: () => SERVICE_INVOICE_FORM,
  TAX_FEDERATION_FORM: () => TAX_FEDERATION_FORM,
  TAX_FORM: () => TAX_FORM,
  USER_ACCOUNT_FORM: () => USER_ACCOUNT_FORM,
  USER_GROUP_FORM: () => USER_GROUP_FORM
});

// crud/forms/country.ts
import { Joi } from "@hc/graphql";
var COUNTRY_FORM = Joi.object({
  name: Joi.string().required(),
  code: Joi.string().alphanum().min(2).max(2).required(),
  currency_id: Joi.join().collection("currency").required(),
  tax_federation_id: Joi.join().collection("tax_federation").optional().allow(null),
  standard_tax_rate_id: Joi.join().collection("tax").constrain({
    country_id: "=id"
  }).optional().allow(null)
});
var TAX_FORM = Joi.object({
  country_id: Joi.join().collection("country").required(),
  percent: Joi.number().required()
});
var TAX_FEDERATION_FORM = Joi.object({
  name: Joi.string().required(),
  code: Joi.string().alphanum().min(2).max(2).required()
});

// crud/forms/project.ts
import { Joi as Joi2 } from "@hc/graphql";

// constants.ts
var constants_exports = {};
__export(constants_exports, {
  ACTIONS: () => ACTIONS,
  BUDGET_STATES: () => BUDGET_STATES,
  COMPANY_ADDRESS_TYPES: () => COMPANY_ADDRESS_TYPES,
  COMPANY_TYPES: () => COMPANY_TYPES,
  CONTRACT_SECTION_TYPES: () => CONTRACT_SECTION_TYPES,
  CONTRACT_STATES: () => CONTRACT_STATES,
  DISCOUNT_TYPES: () => DISCOUNT_TYPES,
  DISCOUNT_TYPES_SHORT: () => DISCOUNT_TYPES_SHORT,
  GERMAN_COUNTRIES: () => GERMAN_COUNTRIES,
  INVOICE_ATTACHMENT_POLICY: () => INVOICE_ATTACHMENT_POLICY,
  INVOICE_STATES: () => INVOICE_STATES,
  INVOICE_TYPES: () => INVOICE_TYPES,
  LANGUAGES: () => LANGUAGES,
  PROJECT_STATES: () => PROJECT_STATES,
  SERVICE_BUY_TAX_TYPES: () => SERVICE_BUY_TAX_TYPES,
  SERVICE_CATEGORIES: () => SERVICE_CATEGORIES,
  SERVICE_CATEGORY_ICONS: () => SERVICE_CATEGORY_ICONS,
  SERVICE_LABELS: () => SERVICE_LABELS,
  SERVICE_SELL_TAX_TYPES: () => SERVICE_SELL_TAX_TYPES,
  SERVICE_TAX_TYPES: () => SERVICE_TAX_TYPES,
  USER_ROLES: () => USER_ROLES
});
var PROJECT_STATES = [
  "requested",
  "pending",
  "confirmed",
  "canceled",
  "completed"
];
var INVOICE_TYPES = [
  "deposit",
  "final",
  "provision",
  "cancelation",
  "credit"
];
var INVOICE_STATES = [
  "draft",
  "requested",
  "confirmed",
  "canceled",
  "sent"
];
var INVOICE_ATTACHMENT_POLICY = {
  allowedExtensions: [
    ".pdf",
    ".doc",
    ".docx"
  ],
  maxFiles: 5,
  maxFileBytes: 10 * 1024 * 1024,
  maxTotalBytes: 20 * 1024 * 1024
};
var CONTRACT_STATES = [
  "draft",
  "confirmed",
  "sent",
  "signed",
  "canceled"
];
var CONTRACT_SECTION_TYPES = [
  "footer",
  "body"
];
var BUDGET_STATES = [
  "draft",
  "confirmed",
  "rejected",
  "sent"
];
var SERVICE_SELL_TAX_TYPES = {
  vat: "VAT",
  rcv: "RCV",
  toms: "TOMS"
};
var SERVICE_BUY_TAX_TYPES = {
  none: "None",
  vat: "VAT",
  rcv: "RCV",
  toms: "TOMS"
};
var SERVICE_TAX_TYPES = {
  sell: SERVICE_SELL_TAX_TYPES,
  buy: SERVICE_BUY_TAX_TYPES
};
var SERVICE_CATEGORIES = {
  accommodation: "Accommodation",
  meeting: "Meeting",
  transport: "Transportation",
  food: "Food & Beverages",
  activity: "Activity",
  inhouse: "Inhouse Services",
  staffInt: "Staff (Internal)",
  staffExt: "Staff (External)",
  rental: "Rental Equipment",
  tip: "TIP",
  other: "Other"
};
var SERVICE_CATEGORY_ICONS = {
  accommodation: "bed",
  meeting: "user-tie",
  transport: "bus",
  food: "utensils",
  inhouse: "house",
  activity: "hiking",
  staffInt: "users",
  staffExt: "users",
  rental: "boxes",
  other: "paperclip"
};
var LANGUAGES = {
  DE: "German",
  EN: "English"
};
var ACTIONS = {
  update: "updated",
  insert: "added",
  delete: "deleted"
};
var GERMAN_COUNTRIES = [
  "DE",
  "AT",
  "CH"
];
var DISCOUNT_TYPES = {
  percent: "Percent",
  item: "Fixed per Item",
  fixed: "Fixed"
};
var DISCOUNT_TYPES_SHORT = {
  percent: "%",
  item: "\u20AC/i",
  fixed: "\u20AC"
};
var COMPANY_TYPES = {
  client: "Client",
  supplier: "Supplier",
  owner: "Owner"
};
var COMPANY_ADDRESS_TYPES = {
  company: "Company",
  tax: "Tax",
  billing: "Billing"
};
var SERVICE_LABELS = [
  "sustainable"
];
var USER_ROLES = {
  user: "user",
  admin: "admin",
  manager: "manager"
};

// crud/forms/project.ts
var PROJECT_FORM = Joi2.form({
  name: Joi2.string().required(),
  client_id: Joi2.join().collection("company").required().meta({
    grid: 4
  }),
  start_date: Joi2.date().required().meta({
    grid: 4
  }),
  end_date: Joi2.date().required().meta({
    grid: 4
  }),
  manager_id: Joi2.join().collection("user_account").required().meta({
    grid: 4
  }),
  office_id: Joi2.join().collection("office").required().meta({
    grid: 4
  }),
  group_id: Joi2.join().allow(null).collection("project_group").meta({
    grid: 4
  }),
  currency_id: Joi2.join().collection("currency").required().meta({
    grid: 4
  }),
  vat_number_id: Joi2.join().allow(null).collection("company_vat_number").constrain({
    company_id: "=office.company_id",
    active: true
  }).meta({
    grid: 4
  }),
  bank_account_id: Joi2.join().allow(null).collection("company_bank_account").constrain({
    company_id: "=office.company_id"
  }).meta({
    grid: 4
  }),
  country_id: Joi2.join().collection("country").required().meta({
    grid: 4,
    label: "Country of event"
  }).meta({
    grid: 6
  }),
  city: Joi2.string().required().meta({
    grid: 4,
    label: "City of event"
  }).meta({
    grid: 6
  }),
  business_area_id: Joi2.join().required().collection("business_area").meta({
    grid: 6
  }).constrain({
    archived: false
  }),
  business_area_category_id: Joi2.join().allow(null).optional().collection("business_area_category").meta({
    grid: 6
  }).constrain({
    business_area_id: "=business_area_id"
  }),
  agency_id: Joi2.join().collection("company").allow(null).meta({
    grid: 6
  }),
  broker_id: Joi2.join().collection("company").allow(null).meta({
    grid: 6
  }),
  estimated_turnover: Joi2.price().required().meta({
    grid: 4
  }),
  estimated_costs: Joi2.price().required().meta({
    grid: 4
  }),
  participant_count: Joi2.number().integer().allow(null).allow("").meta({
    grid: 4
  }),
  issuer_address: Joi2.text().rows(6).allow(null).allow("").meta({
    grid: 6
  }),
  comment: Joi2.text().allow(null).allow("").optional().rows(6).meta({
    grid: 6
  }),
  send_invoice_text: Joi2.text().allow(null).allow("").optional().rows(6).meta({
    grid: 6,
    label: "Send Invoice Text"
  })
}).meta({
  currencySource: "currency.code"
}).calculated({
  reference: Joi2.string().required(),
  status: Joi2.enum().items(...PROJECT_STATES),
  charge_toms: Joi2.boolean().meta({
    grid: 4
  }),
  estimated_profits: Joi2.price().meta({
    grid: 4
  }),
  actual_turnover: Joi2.price().meta({
    grid: 4
  }),
  actual_cost: Joi2.price().meta({
    grid: 4
  }),
  earning_amount: Joi2.price().meta({
    grid: 4
  }),
  payment_amount: Joi2.price().meta({
    grid: 4
  }),
  invoiced_amount: Joi2.price().meta({
    grid: 4
  }),
  missing_amount: Joi2.price().meta({
    grid: 4
  }),
  open_amount: Joi2.price().meta({
    grid: 4
  }),
  provision_amount: Joi2.price().meta({
    grid: 4
  }),
  commission_amount: Joi2.price().meta({
    grid: 4
  }),
  commission_open: Joi2.price().meta({
    grid: 4
  }),
  client_country: Joi2.string().meta({
    readonly: true,
    grid: 4
  }),
  cancelation_reason: Joi2.text()
});
var PROJECT_CREATE_FORM = PROJECT_FORM.removeFields("reference", "status");
var PROJECT_EDIT_FORM = PROJECT_FORM.removeFields("reference", "status");
var PROJECT_REQUESTED_FORM = PROJECT_FORM.removeFields("reference", "status");
var PROJECT_CONFIRMED_FORM = PROJECT_FORM.removeFields("reference", "status").readonlyFields("office_id", "manager_id", "currency_id", "client_id", "start_date", "end_date", "country_id", "bank_account_id", "vat_number_id", "issuer_address");
var PROJECT_PENDING_FORM = PROJECT_CONFIRMED_FORM;
var PROJECT_COMPLETED_FORM = PROJECT_CONFIRMED_FORM;
var PROJECT_GROUP_FORM = Joi2.form({
  name: Joi2.string().required(),
  description: Joi2.text().rows(4).allow(null),
  invoice_user_confirmable: Joi2.boolean().default(false)
});

// crud/forms/budget.ts
import { Joi as Joi3 } from "@hc/graphql";
var BUDGET_FORM = Joi3.form({
  project_id: Joi3.join().collection("project").required(),
  name: Joi3.string().required().meta({
    grid: 6
  }),
  purchase_number: Joi3.string().allow(null).allow("").optional().meta({
    grid: 6
  }),
  country_id: Joi3.join().collection("country").allow(null).meta({
    grid: 6
  }),
  city: Joi3.string().allow("").allow(null).meta({
    grid: 6
  }),
  office_id: Joi3.join().collection("office").allow(null).meta({
    grid: 4
  }),
  bank_account_id: Joi3.join().collection("company_bank_account").allow(null).constrain({
    company_id: "=office.company_id"
  }).meta({
    grid: 4
  }),
  vat_number_id: Joi3.join().collection("company_vat_number").allow(null).constrain({
    company_id: "=office.company_id",
    active: true
  }).meta({
    grid: 4
  }),
  contingency_rate: Joi3.percent().required().default(0).meta({
    grid: 6
  }),
  description: Joi3.text().rows(4).allow(null).allow(""),
  footer: Joi3.text().rows(4).allow(null).allow(""),
  internal_remarks: Joi3.text().rows(4).allow(null).allow(""),
  issuer_address: Joi3.text().rows(6).allow(null).allow("").meta({
    grid: 6
  })
}).meta({
  currencySource: "project.currency.code"
}).calculated({
  status: Joi3.enum().items("draft", "confirmed", "rejected").required(),
  start_date: Joi3.date(),
  end_date: Joi3.date(),
  net_turnover: Joi3.price(),
  gross_turnover: Joi3.price(),
  actual_turnover: Joi3.price(),
  actual_cost: Joi3.price(),
  fees_amount: Joi3.price(),
  provision_amount: Joi3.price(),
  commission_amount: Joi3.price(),
  commission_open: Joi3.price(),
  earning_amount: Joi3.price(),
  invoiced_amount: Joi3.price(),
  payment_amount: Joi3.price(),
  missing_amount: Joi3.price(),
  open_amount: Joi3.price(),
  contingency_amount: Joi3.price(),
  send_history: Joi3.object()
});
var BUDGET_CREATE_FORM = BUDGET_FORM.removeFields("status");
var BUDGET_EDIT_FORM = BUDGET_FORM.removeFields("status");
var BUDGET_CONFIRMED_FORM = BUDGET_FORM.readonlyFields("office_id", "country_id", "bank_account_id", "vat_number_id", "issuer_address", "city");
var SERVICE_FORM = Joi3.form({
  budget_id: Joi3.join().collection("budget").required(),
  start_date: Joi3.date().required().meta({
    grid: 3
  }),
  end_date: Joi3.date().required().meta({
    grid: 3
  }),
  start_time: Joi3.time().optional().allow("").allow(null).meta({
    grid: 3
  }),
  end_time: Joi3.time().optional().allow("").allow(null).meta({
    grid: 3
  }),
  name: Joi3.string().required().meta({
    grid: 6
  }),
  group_id: Joi3.join().collection("service_group").constrain({
    budget_id: "=budget_id"
  }).allow(null).meta({
    grid: 6
  }),
  category: Joi3.enum().itemMap(SERVICE_CATEGORIES).required().meta({
    grid: 6
  }),
  supplier_id: Joi3.join().collection("company").allow(null).meta({
    grid: 6
  }),
  sell_price: Joi3.price().required().meta({
    grid: 2
  }),
  sell_quantity: Joi3.number().integer().min(0).required().meta({
    grid: 2
  }),
  sell_factor: Joi3.number().integer().min(0).required().meta({
    grid: 2
  }),
  sell_tax_type: Joi3.enum().itemMap(SERVICE_SELL_TAX_TYPES).required().meta({
    grid: 2
  }),
  sell_tax_rate: Joi3.percent().required().meta({
    grid: 2
  }),
  sell_price_display_gross: Joi3.boolean().meta({
    grid: 2
  }),
  buy_price: Joi3.price().required().meta({
    grid: 2
  }),
  buy_quantity: Joi3.number().integer().min(0).required().meta({
    grid: 2
  }),
  buy_factor: Joi3.number().integer().min(0).required().meta({
    grid: 2
  }),
  buy_tax_type: Joi3.enum().itemMap(SERVICE_BUY_TAX_TYPES).required().meta({
    grid: 2
  }),
  buy_tax_rate: Joi3.percent().required().meta({
    grid: 2
  }),
  buy_price_display_gross: Joi3.boolean().meta({
    grid: 2
  }),
  provision_rate: Joi3.number().integer().min(0).required().meta({
    grid: 3
  }),
  provision_type: Joi3.enum().itemMap(DISCOUNT_TYPES).default("percent").required().meta({
    grid: 3
  }),
  commission_rate: Joi3.number().integer().min(0).required().meta({
    grid: 3
  }),
  commission_type: Joi3.enum().itemMap(DISCOUNT_TYPES).default("percent").required().meta({
    grid: 3
  }),
  description: Joi3.text().rows(4).allow(null),
  internal_remarks: Joi3.text().rows(4).allow(null),
  labels: Joi3.checklist().labels(SERVICE_LABELS).default([])
}).meta({
  currencySource: "budget.project.currency.code"
}).calculated({
  sell_net: Joi3.price(),
  sell_item_gross: Joi3.price(),
  sell_gross: Joi3.price(),
  sell_tax_amount: Joi3.price(),
  buy_net: Joi3.price(),
  buy_item_gross: Joi3.price(),
  buy_gross: Joi3.price(),
  buy_tax_amount: Joi3.price(),
  provision_amount: Joi3.price(),
  commission_amount: Joi3.price(),
  margin_rate: Joi3.number().integer(),
  margin_amount: Joi3.price(),
  earning_amount: Joi3.price(),
  fixed_costs_amount: Joi3.price(),
  invoice_id: Joi3.number().integer(),
  remote_id: Joi3.string(),
  incoming_invoice_received_at: Joi3.date().meta({
    grid: 3
  }),
  incoming_invoice_received_by: Joi3.string().meta({
    grid: 3
  })
});
var SERVICE_CONFIRMED_FORM = SERVICE_FORM.readonlyFields("start_date", "end_date", "category", "sell_price", "sell_quantity", "sell_factor", "sell_tax_type", "sell_tax_rate", "provision_rate");
var SERVICE_COMMISSIONED_FORM = SERVICE_CONFIRMED_FORM.readonlyFields("supplier_id", "buy_price", "buy_quantity", "buy_factor", "buy_tax_type", "buy_tax_rate", "commission_rate");
var SERVICE_GROUP_FORM = Joi3.form({
  budget_id: Joi3.join().collection("budget").required(),
  name: Joi3.string().required(),
  description: Joi3.text().rows(4).allow(null),
  internal_remarks: Joi3.text().rows(4).allow(null),
  internal: Joi3.boolean().allow(null).optional(),
  labels: Joi3.checklist().labels(SERVICE_LABELS).default([])
});
var SERVICE_INVOICE_FORM = Joi3.form({
  service_id: Joi3.join().collection("service").required(),
  invoice_id: Joi3.join().collection("invoice").required(),
  amount: Joi3.number().meta({
    readonly: true,
    grid: 6
  })
});
var BUDGET_FEE_FORM = Joi3.form({
  budget_id: Joi3.join().collection("budget"),
  name: Joi3.string().required(),
  value: Joi3.number().required(),
  absolute: Joi3.boolean().optional().default(false),
  tax_rate: Joi3.percent().required(),
  description: Joi3.text().rows(4).allow(null).allow("")
});
var BUDGET_FEE_CONFIRMED_FORM = BUDGET_FEE_FORM.readonlyFields("name", "value", "absolute", "tax_rate", "description");

// crud/forms/invoice.ts
import { Joi as Joi4 } from "@hc/graphql";
var INVOICE_FORM = Joi4.form({
  project_id: Joi4.join().collection("project").required().meta({
    hidden: true
  }),
  budget_id: Joi4.join().collection("budget").constrain({
    project_id: "=id"
  }).required().meta({
    readonly: true
  }),
  reference: Joi4.string().required(),
  invoice_number: Joi4.string().required(),
  recipient_id: Joi4.join().collection("company").required().meta({
    grid: 12
  }),
  vat_id: Joi4.string().allow(null).allow("").optional().meta({
    grid: 3
  }),
  purchase_number: Joi4.string().allow(null).allow("").optional().meta({
    grid: 3
  }),
  booked_at: Joi4.date().meta({
    readonly: true,
    grid: 3
  }),
  payment_date: Joi4.date(),
  payment_amount: Joi4.price(),
  currency_id: Joi4.join().collection("currency").meta({
    grid: 6
  }),
  type: Joi4.enum().items(...INVOICE_TYPES).required().meta({
    grid: 6
  }),
  due_in: Joi4.number().integer().allow(null).optional().meta({
    grid: 4
  }),
  period_start: Joi4.date().required().meta({
    grid: 4
  }),
  period_end: Joi4.date().required().meta({
    grid: 4
  }),
  bank_account_id: Joi4.join().collection("company_bank_account").constrain({
    company_id: "=issuer_id"
  }).required().meta({
    grid: 6
  }),
  issuer_vat_number_id: Joi4.join().collection("company_vat_number").constrain({
    company_id: "=issuer_id"
  }).required().meta({
    grid: 6
  }),
  issuer_address: Joi4.text().rows(6).required().meta({
    grid: 6
  }),
  recipient_address: Joi4.text().rows(6).required().meta({
    grid: 6
  }),
  tax_address: Joi4.text().rows(6).required().meta({
    grid: 6
  }),
  fixed_data: Joi4.object().meta({
    hidden: true,
    list: false
  }),
  request_deposits: Joi4.array().meta({
    hidden: true
  }),
  issuer_company_emails: Joi4.string().meta({
    readonly: true
  }),
  recipient_company_emails: Joi4.string().meta({
    readonly: true
  }),
  positions: Joi4.array().min(1).meta({
    editor: "InvoicePositions"
  }).default([]).items(Joi4.object({
    quantity: Joi4.number().integer().min(1).required(),
    description: Joi4.string().allow(null).allow("").required(),
    net: Joi4.price().min(0).required(),
    gross: Joi4.price().required(),
    tax_type: Joi4.enum().itemMap(SERVICE_SELL_TAX_TYPES).required(),
    tax_rate: Joi4.number().integer().required()
  })),
  fees: Joi4.array().meta({
    editor: "InvoicePositions"
  }).default([]).items(Joi4.object({
    quantity: Joi4.number().integer().min(1).required(),
    description: Joi4.string().allow(null).allow("").required(),
    net: Joi4.price().min(0).required(),
    gross: Joi4.price().required(),
    tax_type: Joi4.enum().itemMap(SERVICE_SELL_TAX_TYPES).required(),
    tax_rate: Joi4.number().integer().required()
  })),
  issue_date: Joi4.date().required().meta({
    grid: 6
  }),
  due_date: Joi4.date().required().meta({
    grid: 6
  }),
  toms_tax_amount: Joi4.price().meta({
    hidden: true
  }),
  total_net: Joi4.price().required().meta({
    grid: 4
  }),
  total_tax: Joi4.price().required().meta({
    grid: 4
  }),
  total_gross: Joi4.price().required().meta({
    grid: 4
  }),
  total_discount: Joi4.price(),
  total_fees: Joi4.price(),
  final_invoice_id: Joi4.join().collection("invoice").required(),
  cancelation_id: Joi4.join().collection("invoice").required(),
  issuer_id: Joi4.join().collection("company").required()
}).meta({
  currencySource: "currency.code"
}).calculated({
  external: Joi4.boolean(),
  status: Joi4.enum().items(...INVOICE_STATES).required(),
  send_history: Joi4.object()
});
var INVOICE_DRAFT_FORM = INVOICE_FORM.removeFields("external", "status", "reference", "invoice_number", "total_net", "total_gross", "total_tax", "total_discount", "total_fees", "issue_date", "due_date", "payment_date", "payment_amount", "final_invoice_id", "cancelation_id", "issuer_id");
var INVOICE_CREATE_FORM = INVOICE_DRAFT_FORM.fork("type", (schema) => schema.deny("cancelation"));
var INVOICE_CONFIRMED_FORM = INVOICE_DRAFT_FORM.removeFields("type", "currency_id", "recipient_id", "bank_account_id", "purchase_number", "period_start", "period_end", "issuer_address", "issuer_vat_number_id", "recipient_address", "tax_address", "positions", "fees", "due_in", "vat_id", "total_discount");
var INVOICE_EDIT_DRAFT_FORM = INVOICE_DRAFT_FORM.readonlyFields("type");
var INVOICE_REQUESTED_FORM = INVOICE_CONFIRMED_FORM;
var INVOICE_CANCELED_FORM = INVOICE_CONFIRMED_FORM;
var INVOICE_DEPOSIT_FORM = Joi4.form({
  invoice_id: Joi4.join().collection("invoice").required(),
  deposit_invoice_id: Joi4.join().collection("invoice").required()
});

// crud/forms/currency.ts
import { Joi as Joi5 } from "@hc/graphql";
var CURRENCY_FORM = Joi5.object({
  name: Joi5.string().required(),
  code: Joi5.string().alphanum().min(3).max(3).required()
});
var CURRENCY_RATE_FORM = Joi5.object({
  currency_id: Joi5.join().collection("currency").required(),
  date: Joi5.date().required(),
  rate: Joi5.number().required()
});

// crud/forms/company.ts
import { Joi as Joi6 } from "@hc/graphql";
var COMPANY_FORM = Joi6.form({
  name: Joi6.string().required().meta({
    grid: 10
  }),
  type: Joi6.enum().itemMap(COMPANY_TYPES).meta({
    grid: 2
  }),
  country_id: Joi6.join().collection("country").required().meta({
    grid: 6
  }),
  language: Joi6.enum().itemMap(LANGUAGES).required().meta({
    grid: 6
  }),
  phone: Joi6.phone().allow(null).allow("").optional().meta({
    grid: 6
  }),
  website: Joi6.string().uri().allow(null).allow("").optional().meta({
    grid: 6
  }),
  brand_name: Joi6.string().allow(null).allow("").optional().meta({
    grid: 6
  }),
  logo_url: Joi6.string().allow(null).allow("").optional().meta({
    grid: 6
  }),
  main_bank_account_id: Joi6.join().collection("company_bank_account").constrain({
    company_id: "=id"
  }).optional().allow(null).meta({
    grid: 6
  }),
  main_vat_number_id: Joi6.join().collection("company_vat_number").constrain({
    company_id: "=id",
    active: true
  }).optional().allow(null).meta({
    grid: 6
  }),
  primary: Joi6.color().allow(null).allow("").optional().meta({
    grid: 6
  }),
  primary_text: Joi6.color().allow(null).allow("").optional().meta({
    grid: 6
  }),
  secondary: Joi6.color().allow(null).allow("").optional().meta({
    grid: 6
  }),
  secondary_text: Joi6.color().allow(null).allow("").optional().meta({
    grid: 6
  }),
  additional_document_recipient: Joi6.string().allow(null).allow("").optional().meta({
    grid: 6
  }),
  invoice_reviewer_addresses: Joi6.array().default([]).optional().allow(null).meta({
    grid: 6
  }),
  invoice_due_additional_months: Joi6.number().integer().allow(null).min(0).meta({
    grid: 6
  }),
  invoice_due_day_of_month: Joi6.number().integer().allow(null).min(0).meta({
    grid: 6
  }),
  hubspot_id: Joi6.string().allow(null).allow("").optional().meta({
    readonly: true
  }),
  accounting_client_id: Joi6.string().allow(null).allow("").optional().meta({
    readonly: true
  }),
  accounting_currency_id: Joi6.join().collection("currency").allow(null).optional().meta({
    readonly: true
  })
}).calculated({
  emails: Joi6.string()
});
var COMPANY_ADDRESS_FORM = Joi6.object({
  company_id: Joi6.join().collection("company").required(),
  type: Joi6.enum().itemMap(COMPANY_ADDRESS_TYPES),
  email: Joi6.string().email({
    tlds: false
  }).allow(null).allow("").optional(),
  street: Joi6.string().required(),
  additional: Joi6.string().optional().allow(null).allow(""),
  city: Joi6.string().required(),
  zip: Joi6.string().required(),
  country_id: Joi6.join().collection("country").required()
});
var OFFICE_FORM = Joi6.object({
  company_id: Joi6.join().collection("company").required(),
  country_id: Joi6.join().collection("country").required(),
  currency_id: Joi6.join().collection("currency").required().allow(null).optional(),
  name: Joi6.string().required(),
  code: Joi6.string().required(),
  address_id: Joi6.join().collection("company_address").constrain({
    company_id: "=company_id"
  }).required(),
  invoice_address: Joi6.text().rows(4).required(),
  invoice_footer_legal: Joi6.text().rows(4).required(),
  invoice_footer_tax: Joi6.text().rows(4).required()
});
var COMPANY_BANK_ACCOUNT_FORM = Joi6.object({
  company_id: Joi6.join().collection("company").required(),
  name: Joi6.string().required(),
  account_holder: Joi6.string().required(),
  bank_name: Joi6.string().required(),
  iban: Joi6.string().required(),
  bic: Joi6.string().required()
});
var COMPANY_VAT_NUMBER_FORM = Joi6.object({
  company_id: Joi6.join().collection("company").required(),
  value: Joi6.string().required().meta({
    grid: 8
  }),
  active: Joi6.boolean().required().default(true).meta({
    grid: 4
  }),
  description: Joi6.text().required().default("")
});
var COMPANY_RELATION_FORM = Joi6.object({
  company_id: Joi6.join().collection("company").required(),
  target_id: Joi6.join().collection("company").required(),
  relation: Joi6.enum().items("debitor", "creditor").required(),
  value: Joi6.string().required()
});

// crud/forms/user.ts
import { Joi as Joi7 } from "@hc/graphql";
var USER_ACCOUNT_FORM = Joi7.object({
  id: Joi7.number().integer(),
  first_name: Joi7.string().required(),
  last_name: Joi7.string().required(),
  email: Joi7.string().email({
    tlds: false
  }).required(),
  code: Joi7.string().alphanum().min(3).max(3).required(),
  role: Joi7.enum().itemMap(USER_ROLES).required()
});
var USER_GROUP_FORM = Joi7.object({
  id: Joi7.number().integer(),
  name: Joi7.string().required()
});
var PROJECT_GROUP_MANAGER_FORM = Joi7.object({
  user_id: Joi7.join().collection("user_account").required(),
  group_id: Joi7.join().collection("project_group").required()
});
var PROJECT_MANAGER_FORM = Joi7.object({
  user_id: Joi7.join().collection("user_account").required(),
  project_id: Joi7.join().collection("project").required()
});
var COMPANY_MANAGER_FORM = Joi7.object({
  user_id: Joi7.join().collection("user_account").required(),
  company_id: Joi7.join().collection("company").required()
});
var OFFICE_MANAGER_FORM = Joi7.object({
  user_id: Joi7.join().collection("user_account").required(),
  office_id: Joi7.join().collection("office").required()
});

// crud/forms/content.ts
import { Joi as Joi8 } from "@hc/graphql";
var CONTENT_CATEGORY_FORM = Joi8.object({
  title: Joi8.string().required(),
  slug: Joi8.string().required(),
  teaser: Joi8.text().rows(4).required(),
  content: Joi8.text().rows(12).required()
});
var CONTENT_ARTICLE_FORM = Joi8.object({
  title: Joi8.string().required(),
  slug: Joi8.string().required(),
  teaser: Joi8.text().rows(4).required(),
  content: Joi8.text().rows(12).required(),
  category_id: Joi8.join().collection("content_category").required()
});
var CONTENT_PAGE_FORM = Joi8.object({
  title: Joi8.string().required(),
  slug: Joi8.string().required(),
  teaser: Joi8.text().rows(4).required(),
  content: Joi8.text().rows(12).required()
});

// crud/forms/contract.ts
import { Joi as Joi9 } from "@hc/graphql";
var CONTRACT_FORM = Joi9.form({
  project_id: Joi9.join().collection("project").required().meta({
    hidden: true
  }),
  budget_id: Joi9.join().collection("budget").required(),
  offer_validity_date: Joi9.date().meta({
    grid: 6
  }),
  issue_date: Joi9.date().meta({
    readonly: true,
    grid: 6
  }),
  name: Joi9.string().required(),
  envelope_id: Joi9.string().required(),
  issuer_id: Joi9.join().collection("user_account").required().meta({
    grid: 6
  }),
  recipient_id: Joi9.join().collection("company").required().meta({
    grid: 6
  }),
  recipient_name: Joi9.string().required().meta({
    grid: 6
  }),
  recipient_email: Joi9.string().email({
    tlds: false
  }).required().meta({
    grid: 6
  }),
  issuer_address: Joi9.text().rows(6).required().meta({
    grid: 6
  }),
  recipient_address: Joi9.text().rows(6).required().meta({
    grid: 6
  }),
  fixed_data: Joi9.object().meta({
    hidden: true,
    list: false
  }),
  payments: Joi9.array().default([
    {
      amount: 100,
      date: null
    }
  ]).items(Joi9.object({
    date: Joi9.date().required(),
    amount: Joi9.percent().required()
  }))
}).calculated({
  status: Joi9.enum().items(...CONTRACT_STATES).required()
});
var CONTRACT_DRAFT_FORM = CONTRACT_FORM.removeFields("status", "envelope_id");
var CONTRACT_CREATE_FORM = CONTRACT_DRAFT_FORM.removeFields("status", "envelope_id");
var CONTRACT_CONFIRMED_FORM = CONTRACT_DRAFT_FORM.removeFields("name", "budget_id", "envelope_id", "recipient_id", "status", "issuer_id", "recipient_name", "recipient_email", "issuer_address", "recipient_address", "issue_date", "offer_validity_date", "payments");
var CONTRACT_SENT_FORM = CONTRACT_CONFIRMED_FORM;
var CONTRACT_SIGNED_FORM = CONTRACT_SENT_FORM;

// crud/forms/business_area.ts
import { Joi as Joi10 } from "@hc/graphql";
var BUSINESS_AREA = Joi10.form({
  name: Joi10.string().required(),
  fixed_costs_rate: Joi10.percent().required(),
  profit_treshold_rate: Joi10.percent().required(),
  archived: Joi10.boolean().default(false).required()
});
var BUSINESS_AREA_CATEGORY = Joi10.form({
  name: Joi10.string().required(),
  archived: Joi10.boolean().default(false).required(),
  business_area_id: Joi10.join().required().collection("business_area")
});

// crud/collections/index.ts
var collections_exports = {};
__export(collections_exports, {
  Budget: () => Budget,
  BudgetFee: () => BudgetFee,
  BusinessArea: () => BusinessArea,
  BusinessAreaCategory: () => BusinessAreaCategory,
  Company: () => Company,
  CompanyAddress: () => CompanyAddress,
  CompanyBankAccount: () => CompanyBankAccount,
  CompanyManager: () => CompanyManager,
  CompanyRelation: () => CompanyRelation,
  CompanyVatNumber: () => CompanyVatNumber,
  ContentArticle: () => ContentArticle,
  ContentCategory: () => ContentCategory,
  ContentPage: () => ContentPage,
  Contract: () => Contract,
  Country: () => Country,
  Currency: () => Currency,
  CurrencyRate: () => CurrencyRate,
  Invoice: () => Invoice,
  InvoiceDeposit: () => InvoiceDeposit,
  Office: () => Office,
  OfficeManager: () => OfficeManager,
  Project: () => Project,
  ProjectGroup: () => ProjectGroup,
  ProjectGroupManager: () => ProjectGroupManager,
  ProjectManager: () => ProjectManager,
  Service: () => Service,
  ServiceGroup: () => ServiceGroup,
  ServiceInvoice: () => ServiceInvoice,
  SystemActivity: () => SystemActivity,
  SystemWebhook: () => SystemWebhook,
  Tax: () => Tax,
  TaxFederation: () => TaxFederation,
  UserAccount: () => UserAccount,
  UserGroup: () => UserGroup
});

// crud/actions/budget.ts
import gql from "graphql-tag";

// crud/actions/change_status.ts
import { CrudWorkflowAction } from "@hc/graphql";
var ChangeStatusAction = class extends CrudWorkflowAction {
  static {
    __name(this, "ChangeStatusAction");
  }
  constructor(options = {}) {
    super(options);
  }
  buildActionParams(model) {
    if (this.options.buildActionParams) return this.options.buildActionParams(model);
    if (!this.options.status) return null;
    else return {
      status: this.options.status
    };
  }
  isActive(model) {
    if (this.options.isActive) return this.options.isActive(model);
    return model.status != this.options.status;
  }
};

// crud/actions/budget.ts
import { CrudWorkflowAction as CrudWorkflowAction2 } from "@hc/graphql";
var confirm = new CrudWorkflowAction2({
  name: "confirm",
  isActive: /* @__PURE__ */ __name((budget) => budget.status == "draft", "isActive"),
  mutation: gql`
    mutation($id: Int!) {
      result: budget_confirm(id: $id){
        result
      }
    }
  `
});
var reject = new ChangeStatusAction({
  name: "reject",
  status: "rejected",
  isActive: /* @__PURE__ */ __name((budget) => budget.status == "confirmed", "isActive")
});
var reset = new ChangeStatusAction({
  name: "reset",
  status: "draft"
});
var serviceInvoice = new CrudWorkflowAction2({
  name: "serviceInvoice",
  group: "budgetInvoice",
  label: "Service Invoice",
  dialog: "BudgetServiceInvoiceModal",
  successDialog: "BudgetWorkflowShowInvoiceModal",
  isActive: /* @__PURE__ */ __name((model) => model.status == "confirmed", "isActive"),
  mutation: gql`
    mutation($id: Int!, $params: budget_service_invoice_input!) {
      result: budget_serviceInvoice(id: $id, params: $params){
        invoice_id
        service_ids
      }
    }
  `
});
var depositInvoice = new CrudWorkflowAction2({
  name: "depositInvoice",
  group: "budgetInvoice",
  label: "Deposit Invoice",
  dialog: "BudgetDepositInvoiceModal",
  successDialog: "BudgetWorkflowShowInvoiceModal",
  isActive: /* @__PURE__ */ __name((model) => model.status == "confirmed", "isActive"),
  mutation: gql`
    mutation($id: Int!, $params: budget_deposit_invoice_input!) {
      result: budget_depositInvoice(id: $id, params: $params){
        invoice_id
      }
    }
  `
});
var provisionInvoice = new CrudWorkflowAction2({
  name: "provisionInvoice",
  group: "budgetInvoice",
  label: "Provision Invoice",
  dialog: "BudgetProvisionInvoiceModal",
  successDialog: "BudgetWorkflowShowInvoiceModal",
  isActive: /* @__PURE__ */ __name((model) => model.status == "confirmed", "isActive"),
  mutation: gql`
    mutation($id: Int!, $params: budget_provision_invoice_input!) {
      result: budget_provisionInvoice(id: $id, params: $params){
        invoice_id
      }
    }
  `
});
var clone = new CrudWorkflowAction2({
  name: "clone",
  group: "clone",
  label: "Clone",
  dialog: "BudgetCloneModal",
  successDialog: "CrudWorkflowCloneSuccessModal",
  // buildActionParams: (budget: Budget) => { return {name: budget.name + ' (cloned)'}},
  mutation: gql`
    mutation($id: Int!, $params: budget_clone_params!) {
      result: budget_clone(id: $id, params: $params){
        objects_created
      }
    }
  `
});
var copyServices = new CrudWorkflowAction2({
  name: "copyServices",
  group: "clone",
  dialog: "BudgetCopyServicesModal",
  successDialog: "BudgetWorkflowCopyServicesSuccessModal",
  mutation: gql`
    mutation($id: Int!, $params: budget_copy_services_params!) {
      result: budget_copyServices(id: $id, params: $params){
        objects_created
      }
    }
  `
});
var destroy = new CrudWorkflowAction2({
  name: "destroy",
  label: "Delete",
  dialog: "BudgetDeleteModal",
  successDialog: "BudgetWorkflowDeleteSuccessModal",
  mutation: gql`
    mutation($id: Int!) {
      result: budget_destroy(id: $id){
        result {
          deleted_object_id
          description
        }
      }
    }
  `
});
var serviceContract = new CrudWorkflowAction2({
  name: "serviceContract",
  group: "budgetInvoice",
  label: "Service Contract",
  dialog: "BudgetServiceContractModal",
  successDialog: "BudgetWorkflowShowContractModal",
  isActive: /* @__PURE__ */ __name((model) => model.status == "confirmed", "isActive"),
  mutation: gql`
    mutation($id: Int!, $params: budget_service_contract_input!) {
      result: budget_serviceContract(id: $id, params: $params){
        contract_id
      }
    }
  `
});
var sendToClient = new CrudWorkflowAction2({
  name: "sendToClient",
  label: "Send To Client",
  dialog: "BudgetSendToClientModal",
  isActive: /* @__PURE__ */ __name((model) => true, "isActive"),
  mutation: gql`
    mutation($id: Int!, $params: budget_send_to_client!) {
      result: budget_sendToClient(id: $id, params: $params){
        id result
      }
    }
  `
});

// crud/collections/common.ts
var PROJECT_JOIN_IGNORE = [
  "client.main_bank_account",
  "client.currency",
  "client.country.tax_federation",
  "client.country.standard_tax_rate",
  "agency.main_bank_account",
  "agency.currency",
  "agency.country.tax_federation",
  "agency.country.standard_tax_rate",
  "broker.main_bank_account",
  "broker.currency",
  "broker.country.tax_federation",
  "broker.country.standard_tax_rate",
  "office.country",
  "office.address.company",
  "office.company.country.currency",
  "office.company.country.tax_federation",
  "office.company.country.standard_tax_rate",
  //'office.company.main_bank_account',
  "office.company.accounting_currency"
];
var BUDGET_JOIN_IGNORE = [
  "project.client.main_bank_account",
  "project.client.currency",
  "project.client.country.tax_federation",
  "project.client.country.standard_tax_rate",
  "project.agency.main_bank_account",
  "project.agency.currency",
  "project.agency.country.tax_federation",
  "project.agency.country.standard_tax_rate",
  "project.broker.main_bank_account",
  "project.broker.currency",
  "project.broker.country.tax_federation",
  "project.broker.country.standard_tax_rate",
  "project.office.country",
  "project.office.address.company",
  "project.office.company.country.currency",
  "project.office.company.country.tax_federation",
  "project.office.company.country.standard_tax_rate",
  //'project.office.company.main_bank_account',
  "project.office.company.accounting_currency"
];
var INVOICE_JOIN_IGNORE = [
  "budget",
  "project",
  "issuer",
  "recipient",
  "bank_account",
  "cancelation",
  "final_invoice"
];
var COMPANY_JOIN_IGNORE = [
  "main_bank_account",
  "main_vat_number",
  "country.currency",
  "country.tax_federation",
  "country.standard_tax_rate"
];
var SERVICE_JOIN_IGNORE = [
  "group",
  "budget",
  "supplier",
  "invoice",
  "provision_invoice"
];
var SERVICE_GROUP_JOIN_IGNORE = [
  "budget"
];
var OFFICE_JOIN_IGNORE = [
  "country",
  "address.company",
  "company.country.currency",
  "company.country.tax_federation",
  "company.country.standard_tax_rate",
  "company.main_bank_account",
  "company.main_vat_number",
  "company.accounting_currency"
];

// crud/collections/budget.ts
var Budget = {
  title: "Budgets",
  objectTitle: "${name}",
  parent: "project",
  searchFields: [
    "name"
  ],
  list: {
    fields: [
      "name",
      "status",
      "office",
      "city",
      "country",
      "start_date",
      "end_date",
      "purchase_number",
      "earning_amount",
      "actual_turnover",
      "actual_cost",
      "invoiced_amount",
      "payment_amount",
      "missing_amount",
      "open_amount",
      "commission_amount",
      "commission_open",
      "provision_amount",
      "sort_index",
      "project",
      "vat_number"
    ]
  },
  view: {
    fields: [
      "-description",
      "-footer",
      "-internal_remarks",
      "-issuer_address",
      "-send_history"
    ]
  },
  workflow: {
    actions: [
      confirm,
      serviceInvoice,
      provisionInvoice,
      depositInvoice,
      serviceContract,
      clone,
      copyServices,
      reject,
      reset,
      destroy,
      sendToClient
    ]
  },
  joins: {
    project: {
      collection: "project",
      default: true,
      ignoreJoins: [
        ...PROJECT_JOIN_IGNORE
      ]
    },
    office: {
      collection: "office",
      default: true,
      ignoreJoins: [
        ...OFFICE_JOIN_IGNORE
      ]
    },
    country: {
      collection: "country",
      default: true
    },
    vat_number: {
      collection: "company_vat_number"
    },
    bank_account: {
      collection: "company_bank_account"
    }
  },
  relations: {
    services: {
      collection: "service",
      title: "Services"
    },
    groups: {
      collection: "service_group",
      title: "Service Groups"
    },
    fees: {
      collection: "budget_fee",
      type: "array",
      title: "Fees",
      key: "budget_id"
    },
    invoices: {
      collection: "invoice",
      title: "Invoices"
    },
    contracts: {
      collection: "contract",
      type: "array",
      title: "Contracts",
      key: "budget_id"
    }
  },
  components: {
    form: {
      header: [
        "BudgetFormDefaults"
      ]
    },
    view: {
      main: [
        "BudgetCrudView"
      ],
      footer: []
    }
  }
};
var Service = {
  title: "Services",
  parent: "budget",
  objectTitle: /* @__PURE__ */ __name((o) => `${o.name}`, "objectTitle"),
  fields: [
    "start_date",
    "end_date",
    "start_time",
    "end_time",
    "name",
    "status",
    "category",
    "buy_price",
    "buy_quantity",
    "buy_factor",
    "commission_type",
    "commission_rate",
    "commission_amount",
    "buy_net",
    "buy_tax_type",
    "buy_tax_rate",
    "buy_tax_amount",
    "buy_item_gross",
    "buy_gross",
    "sell_price",
    "sell_quantity",
    "sell_factor",
    "provision_type",
    "provision_rate",
    "provision_amount",
    "sell_net",
    "sell_tax_type",
    "sell_tax_rate",
    "sell_tax_amount",
    "sell_item_gross",
    "sell_gross",
    "margin_rate",
    "margin_amount",
    "fixed_costs_amount",
    "earning_amount",
    "sort_index",
    "incoming_invoice_received_at",
    "incoming_invoice_received_by"
  ],
  view: {
    fields: [
      "-description",
      "-internal_remarks"
    ]
  },
  list: {
    fields: [
      "group",
      "supplier",
      "invoice",
      "provision_invoice"
    ]
  },
  joins: {
    group: {
      collection: "service_group",
      ignoreJoins: [
        ...SERVICE_GROUP_JOIN_IGNORE
      ]
    },
    budget: {
      collection: "budget",
      ignoreJoins: [
        ...BUDGET_JOIN_IGNORE
      ],
      default: true
    },
    supplier: {
      collection: "company"
    },
    invoice: {
      collection: "invoice",
      ignoreJoins: [
        ...INVOICE_JOIN_IGNORE
      ]
    },
    provision_invoice: {
      collection: "invoice",
      ignoreJoins: [
        ...INVOICE_JOIN_IGNORE
      ]
    }
  },
  relations: {
    service_invoices: {
      title: "Service Invoice",
      collection: "service_invoice",
      hidden: true
    }
  },
  components: {
    view: {
      main: [
        "CrudObjectAttributes",
        "CrudObjectAdditionalInfo"
      ]
    },
    form: {
      header: [
        "ServiceFormDefaults"
      ],
      fields: [
        "ServiceFormFields"
      ]
    }
  }
};
var ServiceGroup = {
  title: "Service Groups",
  objectTitle: /* @__PURE__ */ __name((o) => `${o.name}`, "objectTitle"),
  parent: "budget",
  searchFields: [
    "name"
  ],
  fields: [
    "name",
    "internal",
    "sort_index"
  ],
  view: {
    fields: [
      "-description",
      "-internal_remarks"
    ]
  },
  list: {
    modalForms: false
  },
  joins: {
    budget: {
      collection: "budget",
      ignoreJoins: [
        "project"
      ]
    }
  },
  relations: {
    services: {
      collection: "service",
      type: "array",
      key: "group_id",
      title: "Services"
    }
  },
  components: {
    view: {
      main: [
        "CrudObjectAttributes",
        "CrudObjectAdditionalInfo"
      ]
    }
  }
};
var ServiceInvoice = {
  title: "ServiceInvoice",
  fields: [
    "invoice_id",
    "service_id",
    "amount"
  ],
  parent: "invoice",
  joins: {
    invoice: {
      collection: "invoice",
      ignoreJoins: [
        ...INVOICE_JOIN_IGNORE
      ]
    },
    service: {
      collection: "service",
      ignoreJoins: [
        ...SERVICE_JOIN_IGNORE
      ]
    }
  }
};
var BudgetFee = {
  title: "Fees",
  parent: "budget",
  fields: [
    "name",
    "status",
    "value",
    "absolute",
    "tax_rate"
  ],
  view: {
    fields: [
      "-description"
    ]
  },
  objectTitle: /* @__PURE__ */ __name((o) => `${o.name}`, "objectTitle"),
  joins: {
    budget: {
      collection: "budget",
      ignoreJoins: [
        ...BUDGET_JOIN_IGNORE
      ]
    }
  },
  components: {
    view: {
      main: [
        "CrudObjectAttributes",
        "CrudObjectAdditionalInfo"
      ]
    }
  }
};

// crud/collections/company.ts
var Company = {
  title: "Companies",
  objectTitle: "${name}",
  searchFields: [
    "name"
  ],
  fields: [
    "type",
    "name",
    "phone",
    "website",
    "language",
    "emails"
  ],
  list: {
    fields: [
      "main_vat_number",
      "country"
    ]
  },
  view: {
    fields: [
      "emails"
    ]
  },
  components: {
    form: {
      main: [
        "CompanyFormDefaults"
      ]
    },
    page: {
      content: {
        create: "CompanyCreateForm"
      }
    }
  },
  relations: {
    offices: {
      collection: "office",
      title: "Offices"
    },
    projects: {
      collection: "project",
      title: "Client Projects",
      key: "client_id"
    },
    issued_invoices: {
      collection: "invoice",
      key: "issuer_id",
      title: "Issued Invoices"
    },
    received_invoices: {
      collection: "invoice",
      key: "recipient_id",
      title: "Received Invoices"
    },
    relations: {
      collection: "company_relation",
      key: "company_id",
      title: "Relations"
    },
    reverse_relations: {
      collection: "company_relation",
      key: "target_id",
      title: "Reverse Relations"
    },
    company_managers: {
      collection: "company_manager",
      type: "array",
      title: "Managers",
      key: "company_id"
    },
    addresses: {
      collection: "company_address",
      title: "Addresses"
    },
    bank_accounts: {
      collection: "company_bank_account",
      title: "Bank Accounts"
    },
    vat_numbers: {
      collection: "company_vat_number",
      title: "Vat Numbers"
    }
  },
  joins: {
    country: {
      collection: "country"
    },
    main_bank_account: {
      collection: "company_bank_account",
      ignoreJoins: [
        "company"
      ]
    },
    main_vat_number: {
      collection: "company_vat_number",
      ignoreJoins: [
        "company"
      ],
      default: true
    },
    accounting_currency: {
      collection: "currency"
    }
  }
};
var Office = {
  title: "Offices",
  objectTitle: /* @__PURE__ */ __name((office) => `${office.code} ${office.company.name}`, "objectTitle"),
  parent: "company",
  searchFields: [
    "name",
    "code",
    "company.name"
  ],
  list: {
    fields: [
      "name",
      "code",
      "currency",
      "address",
      "country"
    ]
  },
  view: {
    fields: [
      "-invoice_address",
      "-invoice_footer_legal",
      "-invoice_footer_tax"
    ]
  },
  joins: {
    company: {
      collection: "company",
      default: true
    },
    country: {
      collection: "country"
    },
    currency: {
      collection: "currency"
    },
    address: {
      collection: "company_address"
    }
  },
  relations: {
    projects: {
      collection: "project",
      type: "array",
      key: "office_id",
      title: "Projects"
    },
    office_managers: {
      collection: "office_manager",
      type: "array",
      title: "Managers",
      key: "office_id"
    }
  },
  components: {
    view: {
      main: [
        "OfficeCalendar"
      ],
      sidebar: [
        "CrudObjectAttributes"
      ]
    }
  }
};
var CompanyAddress = {
  title: "Addresses",
  parent: "company",
  searchFields: [
    "street",
    "city"
  ],
  objectTitle: /* @__PURE__ */ __name((o) => `${o.street}, ${o.zip || "?"} ${o.city}, ${o.country.name}`, "objectTitle"),
  list: {
    fields: [
      "type",
      "email",
      "street",
      "city",
      "zip",
      "country"
    ],
    modalForms: false
  },
  joins: {
    company: {
      collection: "company"
    },
    country: {
      collection: "country",
      default: true
    }
  }
};
var CompanyBankAccount = {
  title: "Bank Accounts",
  objectTitle: /* @__PURE__ */ __name((o) => `${o.name}: ${o.iban}`, "objectTitle"),
  parent: "company",
  searchFields: [
    "name",
    "company.name",
    "bank_name"
  ],
  fields: [
    "name",
    "account_holder",
    "bank_name ",
    "iban",
    "bic"
  ],
  joins: {
    company: {
      collection: "company",
      ignoreJoins: COMPANY_JOIN_IGNORE,
      default: true
    }
  }
};
var CompanyVatNumber = {
  title: "Company Vat Numbers",
  objectTitle: /* @__PURE__ */ __name((o) => o.value, "objectTitle"),
  parent: "company",
  searchFields: [
    "value",
    "company.name"
  ],
  fields: [
    "value",
    "description",
    "active",
    "validation"
  ],
  view: {
    fields: [
      "-validation"
    ]
  },
  list: {
    fields: [
      "-validation"
    ]
  },
  components: {
    view: {
      main: [
        "CrudObjectAttributes",
        "CompanyVatNumberValidationStatus"
      ]
    }
  },
  joins: {
    company: {
      collection: "company",
      ignoreJoins: COMPANY_JOIN_IGNORE
    }
  }
};
var CompanyRelation = {
  title: "Company Relations",
  objectTitle: /* @__PURE__ */ __name((o) => `${o.target.name} is ${o.type} of ${o.company.name}`, "objectTitle"),
  parent: "company",
  fields: [
    "relation",
    "value"
  ],
  list: {
    fields: [
      "target",
      "relation",
      "company",
      "value"
    ]
  },
  joins: {
    company: {
      collection: "company",
      default: true
    },
    target: {
      collection: "company",
      default: true
    }
  }
};

// crud/collections/country.ts
var Country = {
  title: "Countries",
  objectTitle: /* @__PURE__ */ __name((o) => `${o.name} (${o.code})`, "objectTitle"),
  searchFields: [
    "name",
    "code"
  ],
  list: {
    fields: [
      "name",
      "code",
      "standard_tax_rate"
    ]
  },
  joins: {
    currency: {
      collection: "currency"
    },
    tax_federation: {
      collection: "tax_federation"
    },
    standard_tax_rate: {
      collection: "tax",
      ignoreJoins: [
        "country"
      ]
    }
  },
  relations: {
    taxes: {
      collection: "tax",
      title: "Taxes"
    }
  }
};
var Tax = {
  parent: "country",
  title: "Taxes",
  objectTitle: /* @__PURE__ */ __name((o) => `${o.percent}% ${o.country ? "(" + o.country.code + ")" : ""}`, "objectTitle"),
  searchFields: [
    "country.code"
  ],
  fields: [
    "percent"
  ],
  joins: {
    country: {
      collection: "country",
      ignoreJoins: [
        "standard_tax_rate"
      ],
      default: true
    }
  }
};
var TaxFederation = {
  title: "Tax Federations",
  objectTitle: /* @__PURE__ */ __name((o) => `${o.name}`, "objectTitle"),
  fields: [
    "name"
  ],
  relations: {
    countries: {
      collection: "country",
      title: "Countries",
      key: "tax_federation_id"
    }
  }
};

// crud/collections/currency.ts
var Currency = {
  title: "Currencies",
  objectTitle: "${name} (${code})",
  fields: [
    "name",
    "code"
  ],
  relations: {
    currency_rates: {
      collection: "currency_rate",
      title: "Rates"
    }
  }
};
var CurrencyRate = {
  title: "Currency Rates",
  objectTitle: "${date} (${rate})",
  parent: "currency",
  fields: [
    "date",
    "rate"
  ],
  list: {
    fields: [
      "currency"
    ]
  },
  joins: {
    currency: {
      collection: "currency"
    }
  }
};

// crud/actions/invoice.ts
import gql2 from "graphql-tag";
import { CrudWorkflowAction as CrudWorkflowAction3 } from "@hc/graphql";
var reset2 = new CrudWorkflowAction3({
  name: "reset",
  mutation: gql2`
    mutation($id: Int!) {
      result: invoice_reset(id: $id){
        id result
      }
    }
  `
});
var confirm2 = new CrudWorkflowAction3({
  name: "confirm",
  confirmable: false,
  dialog: "InvoiceConfirmModal",
  isActive: /* @__PURE__ */ __name((model) => model.type != "cancelation" && model.status == "draft" || model.status === "requested", "isActive"),
  mutation: gql2`
    mutation($id: Int!, $params: invoice_confirm!) {
      result: invoice_confirm(id: $id, params: $params){
        id result
      }
    }
  `
});
var cancel = new CrudWorkflowAction3({
  name: "cancel",
  dialog: "InvoiceCancelModal",
  isActive: /* @__PURE__ */ __name((model) => model.type != "cancelation" && model.status == "confirmed" && !model.payment_date && !model.final_invoice_id, "isActive"),
  mutation: gql2`
    mutation($id: Int!, $params: invoice_cancel!) {
      result: invoice_cancel(id: $id, params: $params){
        id result objects_created
      }
    }
  `
});
var markAsPaid = new CrudWorkflowAction3({
  name: "markAsPaid",
  label: "Mark as paid",
  dialog: "InvoicePaymentDetailsModal",
  isActive: /* @__PURE__ */ __name((model) => model.type != "cancelation" && model.status == "confirmed" && !model.payment_date, "isActive"),
  mutation: gql2`
    mutation($id: Int!, $params: invoice_mark_as_paid!) {
      result: invoice_markAsPaid(id: $id, params: $params){
        id result
      }
    }
  `
});
var sendToClient2 = new CrudWorkflowAction3({
  name: "sendToClient",
  label: "Send To Client",
  dialog: "InvoiceSendToClientModal",
  isActive: /* @__PURE__ */ __name((model) => model.status == "confirmed" || model.status == "canceled", "isActive"),
  mutation: gql2`
    mutation($id: Int!, $params: invoice_send_to_client!) {
      result: invoice_sendToClient(id: $id, params: $params){
        id result
      }
    }
  `
});
var removePayment = new CrudWorkflowAction3({
  name: "removePayment",
  label: "Remove Payment",
  isActive: /* @__PURE__ */ __name((model) => model.payment_date, "isActive"),
  mutation: gql2`
    mutation($id: Int!) {
      result: invoice_removePayment(id: $id) {
        id result
      }
    }
  `
});

// crud/collections/invoice.ts
var Invoice = {
  title: "Invoices",
  parent: "budget",
  objectTitle: /* @__PURE__ */ __name((o) => `${o.reference} (${o.status})`, "objectTitle"),
  fields: [
    "status",
    "type",
    "invoice_number",
    "reference",
    "debitor_number",
    "issue_date",
    "due_date",
    "period_start",
    "period_end",
    "payment_date",
    "payment_amount",
    "positions",
    "toms_tax_amount",
    "total_tax",
    "total_net",
    "total_discount",
    "total_fees",
    "total_gross",
    "external",
    "cancelation_reason",
    "booked_at"
  ],
  searchFields: [
    "reference",
    "invoice_number",
    "recipient.name"
  ],
  view: {
    fields: [
      "debitor_number",
      "-external",
      "-positions",
      "-fees",
      "-issuer_address",
      "-recipient_address",
      "-tax_address",
      "-billing_address",
      "toms_tax_amount",
      "cancelation",
      "project",
      "-send_history"
    ]
  },
  list: {
    fields: [
      "currency",
      "-positions",
      "-fees",
      "budget",
      "project",
      "issuer",
      "issuer_company_emails",
      "recipient",
      "recipient_company_emails",
      "external",
      "purchase_number"
    ]
  },
  workflow: {
    actions: [
      confirm2,
      markAsPaid,
      cancel,
      reset2,
      sendToClient2,
      removePayment
    ]
  },
  joins: {
    recipient: {
      collection: "company"
    },
    project: {
      collection: "project",
      ignoreJoins: [
        ...PROJECT_JOIN_IGNORE
      ]
    },
    currency: {
      collection: "currency"
    },
    issuer: {
      collection: "company",
      ignoreJoins: [
        ...COMPANY_JOIN_IGNORE
      ]
    },
    budget: {
      collection: "budget",
      ignoreJoins: [
        "project",
        "country.tax_federation",
        "country.standard_tax_rate",
        "office.currency",
        "office.address.country.currency",
        "office.address.country.tax_federation",
        "office.address.country.standard_tax_rate",
        "vat_number.company",
        "bank_account.company"
      ]
    },
    bank_account: {
      collection: "company_bank_account"
    },
    issuer_vat_number: {
      collection: "company_vat_number"
    },
    cancelation: {
      collection: "invoice",
      foreignKey: "cancelation_id",
      ignoreJoins: [
        ...INVOICE_JOIN_IGNORE
      ]
    },
    final_invoice: {
      collection: "invoice",
      foreignKey: "final_invoice_id",
      ignoreJoins: [
        ...INVOICE_JOIN_IGNORE
      ]
    },
    requester: {
      collection: "user_account",
      foreignKey: "requested_by_id"
    }
  },
  relations: {
    service_invoices: {
      title: "Service Invoice",
      collection: "service_invoice",
      hidden: true
    }
  },
  facets: {
    year: {
      type: "year_of_date",
      target: "issue_date",
      title: "Issue Year",
      default: "first"
    },
    issuer: {
      type: "join",
      target: "issuer"
    }
  },
  components: {
    view: {
      main: [
        "CrudObjectAttributes",
        "InvoiceCrudView"
      ],
      sidebar: []
    },
    form: {
      main: [
        "InvoiceFormDefaults"
      ],
      fields: [
        "InvoiceFormFields"
      ]
    }
  }
};
var InvoiceDeposit = {
  title: "InvoiceDeposit",
  fields: [
    "invoice_id",
    "deposit_invoice_id"
  ],
  parent: "invoice",
  joins: {
    invoice: {
      collection: "invoice",
      foreignKey: "invoice_id",
      ignoreJoins: [
        ...INVOICE_JOIN_IGNORE
      ]
    },
    deposit_invoice: {
      collection: "invoice",
      foreignKey: "deposit_invoice_id",
      ignoreJoins: [
        ...INVOICE_JOIN_IGNORE
      ]
    }
  }
};

// crud/actions/project.ts
import gql3 from "graphql-tag";
import { CrudWorkflowAction as CrudWorkflowAction4 } from "@hc/graphql";
var confirm3 = new CrudWorkflowAction4({
  name: "confirm",
  isActive: /* @__PURE__ */ __name((project) => project.status == "requested", "isActive"),
  mutation: gql3`
    mutation($id: Int!) {
      result: project_confirm(id: $id){
        result
      }
    }
  `
});
var complete = new ChangeStatusAction({
  name: "complete",
  status: "completed",
  isActive: /* @__PURE__ */ __name((project) => project.status == "confirmed" && project.actual_turnover > 0 && project.open_amount <= 0, "isActive")
});
var forceComplete = new ChangeStatusAction({
  name: "forceComplete",
  label: "Force Complete",
  status: "completed",
  isActive: /* @__PURE__ */ __name((project) => project.status == "confirmed" && !complete.isActive(project), "isActive")
});
var cancel2 = new CrudWorkflowAction4({
  name: "cancel",
  dialog: "ProjectCancelModal",
  isActive: /* @__PURE__ */ __name((project) => project.status != "canceled", "isActive"),
  mutation: gql3`
    mutation($id: Int!, $params: project_cancel_params!) {
      result: project_cancel(id: $id, params: $params){
        result
      }
    }
  `
});
var restart = new CrudWorkflowAction4({
  name: "restart",
  isActive: /* @__PURE__ */ __name((model) => model.status != "requested", "isActive"),
  mutation: gql3`
    mutation($id: Int!) {
      result: project_restart(id: $id){
        result
      }
    }
  `
});
var clone2 = new CrudWorkflowAction4({
  name: "clone",
  dialog: "ProjectCloneModal",
  successDialog: "CrudWorkflowCloneSuccessModal",
  mutation: gql3`
        mutation($id: Int!, $params: project_clone_params!) {
            result: project_clone(id: $id, params: $params){
                objects_created
            }
        }
    `
});
var reset3 = new CrudWorkflowAction4({
  name: "reset",
  mutation: gql3`
    mutation($id: Int!) {
      result: project_reset(id: $id){
        result
      }
    }
  `
});
var destroy2 = new CrudWorkflowAction4({
  name: "destroy",
  label: "Delete",
  dialog: "ProjectDeleteModal",
  successDialog: "ProjectWorkflowDeleteSuccessModal",
  mutation: gql3`
    mutation($id: Int!) {
      result: project_destroy(id: $id){
        result {
          deleted_object_id
          description
        }
      }
    }
  `
});

// crud/collections/project.ts
var Project = {
  title: "Projects",
  //parent: 'group',
  objectTitle: /* @__PURE__ */ __name((o) => `${o.name}${o.reference ? " (" + o.reference + ")" : ""}`, "objectTitle"),
  searchFields: [
    "name",
    "reference",
    "business_area.name",
    "city",
    "client.name",
    "country.name",
    "office.name"
  ],
  form: {
    parentEditable: true
  },
  list: {
    fields: [
      "name",
      "reference",
      "status",
      "cancelation_reason",
      "group",
      "start_date",
      "end_date",
      "client",
      "client_country",
      "office",
      "manager",
      "country",
      "currency",
      "business_area",
      "business_area_category",
      "charge_toms",
      "agency",
      "broker",
      "estimated_turnover",
      "estimated_costs",
      "estimated_profits",
      "earning_amount",
      "actual_turnover",
      "actual_cost",
      "invoiced_amount",
      "payment_amount",
      "missing_amount",
      "open_amount",
      "commission_amount",
      "commission_open",
      "provision_amount"
    ]
  },
  view: {
    fields: [
      "-charge_toms",
      "-comment"
    ]
  },
  workflow: {
    actions: [
      confirm3,
      complete,
      forceComplete,
      cancel2,
      clone2,
      restart,
      reset3,
      destroy2
    ]
  },
  joins: {
    manager: {
      collection: "user_account"
    },
    client: {
      collection: "company"
    },
    office: {
      collection: "office"
    },
    currency: {
      collection: "currency",
      default: true
    },
    country: {
      collection: "country"
    },
    group: {
      collection: "project_group"
    },
    agency: {
      collection: "company"
    },
    broker: {
      collection: "company"
    },
    business_area_category: {
      collection: "business_area_category"
    },
    business_area: {
      collection: "business_area",
      foreignKey: "business_area_id"
    },
    bank_account: {
      collection: "company_bank_account"
    },
    vat_number: {
      collection: "company_vat_number"
    }
  },
  relations: {
    budgets: {
      collection: "budget",
      title: "Budgets",
      type: "array"
    },
    invoices: {
      collection: "invoice",
      title: "Invoices",
      type: "array",
      key: "project_id"
    },
    contracts: {
      collection: "contract",
      title: "Contracts",
      type: "array",
      key: "project_id",
      readonly: true
    },
    project_managers: {
      collection: "project_manager",
      type: "array",
      title: "Managers",
      key: "project_id"
    }
  },
  facets: {
    year: {
      type: "year_of_date",
      target: "start_date",
      title: "Year",
      default: /* @__PURE__ */ __name((values) => (/* @__PURE__ */ new Date()).getFullYear().toString(), "default")
    },
    office: {
      type: "join",
      target: "office"
    }
  },
  components: {
    view: {
      main: [
        "ProjectCrudView"
      ],
      sidebar: []
    },
    form: {
      header: [
        "ProjectFormDefaults"
      ]
    }
  }
};
var ProjectGroup = {
  title: "Groups",
  fields: [
    "name"
  ],
  view: {
    fields: [
      "-description"
    ]
  },
  objectTitle: /* @__PURE__ */ __name((o) => `${o.name}`, "objectTitle"),
  relations: {
    projects: {
      collection: "project",
      type: "array",
      title: "Projects",
      key: "group_id"
    },
    project_group_managers: {
      collection: "project_group_manager",
      type: "array",
      title: "Managers",
      key: "group_id"
    }
  },
  components: {
    view: {
      main: [
        "GroupCrudView",
        "CrudObjectAdditionalInfo"
      ],
      sidebar: [
        "CrudObjectAttributes"
      ]
    }
  }
};

// crud/collections/user.ts
var UserAccount = {
  title: "User Accounts",
  objectTitle: /* @__PURE__ */ __name((o) => `${o.email} (${o.code})`, "objectTitle"),
  fields: [
    "email",
    "first_name",
    "last_name",
    "code",
    "role"
  ],
  relations: {
    projects: {
      collection: "project",
      key: "manager_id",
      title: "Projects"
    },
    company_managers: {
      collection: "company_manager",
      key: "user_id",
      title: "Managed Companies"
    },
    office_managers: {
      collection: "office_manager",
      key: "user_id",
      title: "Managed Offices"
    },
    project_managers: {
      collection: "project_manager",
      key: "user_id",
      title: "Managed Projects"
    },
    project_group_managers: {
      collection: "project_group_manager",
      key: "user_id",
      title: "Managed Groups"
    }
  }
};
var UserGroup = {
  title: "User Groups",
  fields: [
    "name",
    "grants"
  ],
  objectTitle: "${name}"
};
var ProjectManager = {
  title: "Project Managers",
  parent: "project",
  objectTitle: /* @__PURE__ */ __name((m) => `${m.user.email}`, "objectTitle"),
  list: {
    fields: [
      "user",
      "project"
    ]
  },
  joins: {
    user: {
      collection: "user_account",
      foreignKey: "user_id",
      default: true
    },
    project: {
      collection: "project",
      foreignKey: "project_id",
      ignoreJoins: [
        ...PROJECT_JOIN_IGNORE
      ]
    }
  }
};
var ProjectGroupManager = {
  title: "Group Managers",
  parent: "group",
  list: {
    fields: [
      "user",
      "group"
    ]
  },
  joins: {
    user: {
      collection: "user_account",
      foreignKey: "user_id"
    },
    group: {
      collection: "project_group",
      foreignKey: "group_id"
    }
  }
};
var CompanyManager = {
  title: "Company Managers",
  parent: "company",
  list: {
    fields: [
      "user",
      "company"
    ]
  },
  joins: {
    user: {
      collection: "user_account",
      foreignKey: "user_id"
    },
    company: {
      collection: "company",
      foreignKey: "company_id"
    }
  }
};
var OfficeManager = {
  title: "Office Managers",
  parent: "office",
  list: {
    fields: [
      "user",
      "office"
    ]
  },
  joins: {
    user: {
      collection: "user_account",
      foreignKey: "user_id"
    },
    office: {
      collection: "office",
      foreignKey: "office_id"
    }
  }
};

// crud/collections/system.ts
var SystemActivity = {
  title: "System Activities",
  hidden: true,
  schema: "system",
  fields: [
    "account_type",
    "account_id",
    "action",
    "target_type",
    "target_title",
    "target_id",
    "changes",
    "data",
    "account_type"
  ],
  list: {
    fields: [
      "account_type",
      "account_id",
      "action",
      "target_type",
      "target_title",
      "target_id"
    ]
  },
  timestampFields: [
    "created_at"
  ],
  facets: {
    year: {
      type: "year_of_date",
      target: "created_at",
      title: "Year",
      default: /* @__PURE__ */ __name((values) => (/* @__PURE__ */ new Date()).getFullYear().toString(), "default")
    },
    action: {
      target: "action",
      title: "Action",
      type: "value"
    },
    target: {
      target: "target_type",
      title: "Target",
      type: "value"
    }
  }
};
var SystemWebhook = {
  title: "System Webhook",
  hidden: true,
  idType: "uuid",
  schema: "system",
  fields: [
    "name",
    "status",
    "bucket"
  ],
  facets: {
    year: {
      type: "year_of_date",
      target: "created_at",
      title: "Year",
      default: /* @__PURE__ */ __name((values) => (/* @__PURE__ */ new Date()).getFullYear().toString(), "default")
    },
    name: {
      target: "name",
      type: "value"
    },
    status: {
      target: "status",
      type: "value"
    },
    bucket: {
      target: "bucket",
      type: "value"
    }
  }
};

// crud/collections/content.ts
var ContentCategory = {
  title: "Categories",
  objectTitle: "${title} (Category)",
  fields: [
    "title",
    "slug"
  ]
};
var ContentArticle = {
  title: "Articles",
  objectTitle: /* @__PURE__ */ __name((o) => o.title, "objectTitle"),
  fields: [
    "title",
    "slug"
  ]
};
var ContentPage = {
  title: "Pages",
  objectTitle: /* @__PURE__ */ __name((o) => o.title, "objectTitle"),
  fields: [
    "title",
    "slug"
  ]
};

// crud/actions/contract.ts
import gql4 from "graphql-tag";
import { CrudWorkflowAction as CrudWorkflowAction5 } from "@hc/graphql";
var confirm4 = new CrudWorkflowAction5({
  name: "confirm",
  label: "Confirm",
  dialog: "ContractConfirmModal",
  isActive: /* @__PURE__ */ __name((contract) => contract.status === "draft", "isActive"),
  mutation: gql4`
    mutation($id: Int!, $params: contract_confirm!) {
      result: contract_confirm(id: $id, params: $params){
        id result
      }
    }
  `
});
var cancel3 = new CrudWorkflowAction5({
  name: "cancel",
  isActive: /* @__PURE__ */ __name((contract) => contract.status == "sent", "isActive"),
  dialog: "ContractCancelModal",
  mutation: gql4`
    mutation($id: Int!, , $params: contract_cancel_params!) {
      result: contract_cancel(id: $id, params: $params){
        result
      }
    }
  `
});
var clone3 = new CrudWorkflowAction5({
  name: "clone",
  isActive: /* @__PURE__ */ __name((contract) => contract.status == "canceled", "isActive"),
  dialog: "ContractCloneModal",
  successDialog: "CrudWorkflowCloneSuccessModal",
  mutation: gql4`
    mutation($id: Int!, $params: contract_clone_params!) {
      result: contract_clone(id: $id, params: $params){
        objects_created
      }
    }
  `
});
var manualSigning = new CrudWorkflowAction5({
  name: "manualSigning",
  label: "Manual Signing",
  dialog: "ContractManualSigningModal",
  isActive: /* @__PURE__ */ __name((contract) => contract.status === "sent", "isActive"),
  mutation: gql4`
    mutation($id: Int!, $params: contract_manual_signing_params!) {
      result: contract_manualSigning(id: $id, params: $params){
        id result
      }
    }
  `
});

// crud/collections/contract.ts
var Contract = {
  title: "Contracts",
  parent: "budget",
  objectTitle: /* @__PURE__ */ __name((o) => `${o.name} (${o.status})`, "objectTitle"),
  fields: [
    "status",
    "recipient_address",
    "cancelation_reason"
  ],
  searchFields: [
    "name",
    "status"
  ],
  view: {
    fields: [
      "name",
      "status",
      "issue_date",
      "offer_validity_date",
      "issuer_address",
      "recipient_email",
      "recipient_name",
      "recipient_address",
      "-payments",
      "-envelope_id",
      "-issuer_address",
      "-recipient_address"
    ]
  },
  list: {
    fields: [
      "name",
      "status",
      "issue_date",
      "offer_validity_date",
      "issuer",
      "recipient_email",
      "recipient_name",
      "status",
      "-payments",
      "-envelope_id"
    ]
  },
  workflow: {
    actions: [
      confirm4,
      cancel3,
      clone3,
      manualSigning
    ]
  },
  joins: {
    recipient: {
      collection: "company"
    },
    issuer: {
      collection: "user_account"
    },
    budget: {
      collection: "budget",
      ignoreJoins: [
        ...BUDGET_JOIN_IGNORE
      ]
    },
    project: {
      collection: "project",
      ignoreJoins: [
        ...PROJECT_JOIN_IGNORE
      ],
      skip: true
    }
  },
  components: {
    view: {
      main: [
        "CrudObjectAttributes",
        "ContractCrudView"
      ]
    },
    form: {
      main: [
        "ContractFormDefaults"
      ],
      fields: [
        "ContractFormPaymentDatesField"
      ]
    }
  }
};

// crud/collections/business_area.ts
var BusinessArea = {
  title: "Business Area",
  searchFields: [
    "name"
  ],
  objectTitle: /* @__PURE__ */ __name((o) => `${o.name}`, "objectTitle"),
  objectBadges: /* @__PURE__ */ __name((o) => o.archived ? [
    {
      name: "archived",
      value: "Archived"
    }
  ] : [], "objectBadges"),
  list: {
    fields: [
      "name",
      "archived",
      "fixed_costs_rate",
      "profit_treshold_rate"
    ]
  },
  relations: {
    projects: {
      collection: "project",
      title: "Projects",
      key: "business_area_id"
    },
    categories: {
      collection: "business_area_category",
      title: "Categories",
      key: "business_area_id"
    }
  }
};
var BusinessAreaCategory = {
  title: "Business Area Category",
  parent: "business_area",
  objectTitle: /* @__PURE__ */ __name((o) => `${o.name}`, "objectTitle"),
  objectBadges: /* @__PURE__ */ __name((o) => o.archived ? [
    {
      name: "archived",
      value: "Archived"
    }
  ] : [], "objectBadges"),
  searchFields: [
    "name"
  ],
  list: {
    fields: [
      "name",
      "archived",
      "business_area"
    ]
  },
  joins: {
    business_area: {
      collection: "business_area",
      default: true
    }
  }
};

// graphql/query.ts
var query_exports = {};
__export(query_exports, {
  COMPANY_ADDRESSES: () => COMPANY_ADDRESSES,
  COMPANY_ADDRESS_FIELDS: () => COMPANY_ADDRESS_FIELDS,
  COMPANY_FIELDS: () => COMPANY_FIELDS,
  CONTENT_ARTICLE_CATEGORY_FIELDS: () => CONTENT_ARTICLE_CATEGORY_FIELDS,
  CONTENT_ARTICLE_FIELDS: () => CONTENT_ARTICLE_FIELDS,
  CONTENT_CATEGORY_FIELDS: () => CONTENT_CATEGORY_FIELDS,
  CONTENT_PAGE_FIELDS: () => CONTENT_PAGE_FIELDS,
  DIAMANT_ACCOUNT_FIELDS: () => DIAMANT_ACCOUNT_FIELDS,
  DIAMANT_ACCOUNT_TAB_FIELDS: () => DIAMANT_ACCOUNT_TAB_FIELDS,
  DIAMANT_CUSTOMER_FIELDS: () => DIAMANT_CUSTOMER_FIELDS,
  DIAMANT_CUSTOMER_TAB_FIELDS: () => DIAMANT_CUSTOMER_TAB_FIELDS,
  DIAMANT_INVOICE_OI_FIELDS: () => DIAMANT_INVOICE_OI_FIELDS,
  DIAMANT_INVOICE_POSTING_FIELDS: () => DIAMANT_INVOICE_POSTING_FIELDS,
  DIAMANT_INVOICE_STATUS_FIELDS: () => DIAMANT_INVOICE_STATUS_FIELDS,
  DIAMANT_PROOF_OF_SETTLEMENT: () => DIAMANT_PROOF_OF_SETTLEMENT,
  GQL_COMPANIES: () => GQL_COMPANIES,
  GQL_COMPANY: () => GQL_COMPANY,
  GQL_COMPANY_ADDRESSES: () => GQL_COMPANY_ADDRESSES,
  GQL_COMPANY_CREATE: () => GQL_COMPANY_CREATE,
  GQL_COMPANY_DELETE: () => GQL_COMPANY_DELETE,
  GQL_COMPANY_UPDATE: () => GQL_COMPANY_UPDATE,
  GQL_CONTENT_ARTICLE_CATEGORY: () => GQL_CONTENT_ARTICLE_CATEGORY,
  GQL_CONTENT_ARTICLE_LIST: () => GQL_CONTENT_ARTICLE_LIST,
  GQL_CONTENT_CATEGORY_LIST: () => GQL_CONTENT_CATEGORY_LIST,
  GQL_CONTENT_PAGE: () => GQL_CONTENT_PAGE,
  GQL_CONTENT_PAGE_LIST: () => GQL_CONTENT_PAGE_LIST,
  GQL_DIAMANT_ACCOUNTS: () => GQL_DIAMANT_ACCOUNTS,
  GQL_DIAMANT_CUSTOMERS: () => GQL_DIAMANT_CUSTOMERS,
  GQL_DIAMANT_INVOICE_STATUS: () => GQL_DIAMANT_INVOICE_STATUS,
  GQL_DIAMANT_INVOICE_STATUS_BATCH: () => GQL_DIAMANT_INVOICE_STATUS_BATCH,
  GQL_DIAMANT_OIS: () => GQL_DIAMANT_OIS,
  GQL_FACETS: () => GQL_FACETS,
  GQL_INVOICE: () => GQL_INVOICE,
  GQL_INVOICE_LIST: () => GQL_INVOICE_LIST,
  GQL_OBJECT_BOOKMARK: () => GQL_OBJECT_BOOKMARK,
  GQL_PROJECT: () => GQL_PROJECT,
  GQL_PROJECT_CALENDAR: () => GQL_PROJECT_CALENDAR,
  GQL_PROJECT_COUNT: () => GQL_PROJECT_COUNT,
  GQL_PROJECT_COUNT_FEED: () => GQL_PROJECT_COUNT_FEED,
  GQL_PROJECT_CREATE: () => GQL_PROJECT_CREATE,
  GQL_PROJECT_FEED: () => GQL_PROJECT_FEED,
  GQL_PROJECT_LIST: () => GQL_PROJECT_LIST,
  GQL_PROJECT_UPDATE: () => GQL_PROJECT_UPDATE,
  GQL_PROJECT_VIEW: () => GQL_PROJECT_VIEW,
  GQL_USER_ACCOUNTS_BY_EMAIL: () => GQL_USER_ACCOUNTS_BY_EMAIL,
  GQL_USER_ACCOUNT_BY_ID: () => GQL_USER_ACCOUNT_BY_ID,
  GQL_USER_BOOKMARK_CREATE: () => GQL_USER_BOOKMARK_CREATE,
  GQL_USER_BOOKMARK_DELETE: () => GQL_USER_BOOKMARK_DELETE,
  GQL_USER_BOOKMARK_LIST: () => GQL_USER_BOOKMARK_LIST,
  INVOICE_FIELDS: () => INVOICE_FIELDS,
  PROJECT_BASE: () => PROJECT_BASE,
  PROJECT_BUDGETS: () => PROJECT_BUDGETS,
  PROJECT_RELATIONS_LINE: () => PROJECT_RELATIONS_LINE,
  PROJECT_SERVICES: () => PROJECT_SERVICES,
  USERGROUPS: () => USERGROUPS,
  USERPROFILE: () => USERPROFILE,
  USER_BOOKMARK_FIELDS: () => USER_BOOKMARK_FIELDS
});
import gql5 from "graphql-tag";
var COMPANY_ADDRESS_FIELDS = gql5`
    fragment company_address_fields on company_address {
  id
  type
  street
  zip
  city
  additional
  country {
    id
    name
    code
  }
}
    `;
var COMPANY_ADDRESSES = gql5`
    fragment company_addresses on company {
  addresses {
    ...company_address_fields
  }
}
    ${COMPANY_ADDRESS_FIELDS}`;
var COMPANY_FIELDS = gql5`
    fragment company_fields on company {
  id
  type
  name
}
    `;
var CONTENT_ARTICLE_FIELDS = gql5`
    fragment content_article_fields on content_article {
  id
  slug
  title
  teaser
  content
}
    `;
var CONTENT_ARTICLE_CATEGORY_FIELDS = gql5`
    fragment content_article_category_fields on content_article {
  category {
    id
    title
    teaser
    content
  }
}
    `;
var CONTENT_CATEGORY_FIELDS = gql5`
    fragment content_category_fields on content_category {
  id
  title
  teaser
  content
}
    `;
var CONTENT_PAGE_FIELDS = gql5`
    fragment content_page_fields on content_page {
  id
  title
  teaser
  content
}
    `;
var DIAMANT_INVOICE_POSTING_FIELDS = gql5`
    fragment diamant_invoice_posting_fields on diamant_invoice_posting_result {
  account
  class
  contra_account
  credit
  fc_credit
  debit
  fc_debit
  currency
  posting_period
  entry_from
  entry_on
  internal_trans_number
  key
  posting_amount
  text
  trans_date
  trans_number
  trans_type
}
    `;
var DIAMANT_PROOF_OF_SETTLEMENT = gql5`
    fragment diamant_proof_of_settlement on diamant_invoice_proof_of_settlement {
  account
  amount
  fc_amount
  charging_off_case
  date
  key
  posting_period
  settlement_no
  settlement_on
  settlement_with
  trans_date
  trans_number
  trans_type
  user
}
    `;
var DIAMANT_INVOICE_OI_FIELDS = gql5`
    fragment diamant_invoice_oi_fields on diamant_invoice_oi_result {
  account
  class
  contra_account
  credit
  fc_credit
  debit
  fc_debit
  currency
  posting_period
  entry_from
  entry_on
  internal_trans_number
  key
  posting_amount
  text
  trans_date
  trans_number
  trans_type
  proofs_of_settlement {
    ...diamant_proof_of_settlement
  }
}
    ${DIAMANT_PROOF_OF_SETTLEMENT}`;
var DIAMANT_INVOICE_STATUS_FIELDS = gql5`
    fragment diamant_invoice_status_fields on diamant_invoice_status {
  invoice_number
  booked
  payed
  inconsistent
  debtor_postings {
    ...diamant_invoice_posting_fields
  }
  ledger_account_postings {
    ...diamant_invoice_posting_fields
  }
  debtor_ois {
    ...diamant_invoice_oi_fields
  }
}
    ${DIAMANT_INVOICE_POSTING_FIELDS}
${DIAMANT_INVOICE_OI_FIELDS}`;
var DIAMANT_CUSTOMER_FIELDS = gql5`
    fragment diamant_customer_fields on diamant_customer_result {
  account_no
  address
  balance_amount
  designation
  key
  text
  vat_id
}
    `;
var DIAMANT_CUSTOMER_TAB_FIELDS = gql5`
    fragment diamant_customer_tab_fields on diamant_customer_tab_result {
  customers {
    ...diamant_customer_fields
  }
}
    ${DIAMANT_CUSTOMER_FIELDS}`;
var DIAMANT_ACCOUNT_FIELDS = gql5`
    fragment diamant_account_fields on diamant_account_result {
  account_no
  designation
  key
  text
}
    `;
var DIAMANT_ACCOUNT_TAB_FIELDS = gql5`
    fragment diamant_account_tab_fields on diamant_account_tab_result {
  accounts {
    ...diamant_account_fields
  }
}
    ${DIAMANT_ACCOUNT_FIELDS}`;
var INVOICE_FIELDS = gql5`
    fragment invoice_fields on invoice {
  id
  type
  invoice_number
  reference
  billing_address
  tax_address
  total_net
  total_tax
  total_gross
  due_date
  issue_date
  positions
  recipient {
    id
    name
  }
  currency {
    id
    name
    code
  }
  project {
    id
    name
    reference
    currency {
      id
      code
    }
    office {
      id
      name
      company_id
      code
      invoice_address
      invoice_footer_tax
      invoice_footer_legal
      company {
        id
        name
      }
    }
  }
}
    `;
var PROJECT_BASE = gql5`
    fragment project_base on project {
  id
  name
  reference
  start_date
  end_date
  city
  participant_count
  manager_id
  business_area_id
  office_id
  client_id
  currency_id
  country_id
}
    `;
var PROJECT_RELATIONS_LINE = gql5`
    fragment project_relations_line on project {
  client {
    id
    name
  }
  office {
    id
    name
  }
  currency {
    id
    name
  }
  country {
    id
    name
  }
  business_area {
    id
    name
  }
  manager {
    id
    name
  }
  budgets {
    id
    name
  }
  invoices {
    id
    invoice_number
    reference
  }
}
    `;
var PROJECT_BUDGETS = gql5`
    fragment project_budgets on project {
  budgets {
    id
    name
    services_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;
var PROJECT_SERVICES = gql5`
    fragment project_services on project {
  budgets {
    name
    services {
      id
      name
      buy_net
      buy_gross
      buy_tax_amount
      buy_quantity
      sell_net
      sell_gross
      sell_tax_amount
      sell_quantity
      start_date
      end_date
    }
  }
}
    `;
var USERPROFILE = gql5`
    fragment UserProfile on user_account {
  id
  email
  first_name
  last_name
  role
}
    `;
var USERGROUPS = gql5`
    fragment UserGroups on user_account {
  user_account_groups {
    user_group {
      id
      name
    }
  }
}
    `;
var USER_BOOKMARK_FIELDS = gql5`
    fragment user_bookmark_fields on user_bookmark {
  object_id
  object_typename
  user_id
}
    `;
var GQL_COMPANIES = gql5`
    query companies {
  companies: company {
    ...company_fields
  }
}
    ${COMPANY_FIELDS}`;
var GQL_COMPANY = gql5`
    query company($id: Int!) {
  company: company_by_pk(id: $id) {
    ...company_fields
  }
}
    ${COMPANY_FIELDS}`;
var GQL_COMPANY_ADDRESSES = gql5`
    query company_addresses($company_id: Int!) {
  addresses: company_address(where: {company_id: {_eq: $company_id}}) {
    ...company_address_fields
  }
}
    ${COMPANY_ADDRESS_FIELDS}`;
var GQL_COMPANY_CREATE = gql5`
    mutation company_create($company: company_insert_input!) {
  insert_company(objects: [$company]) {
    returning {
      ...company_fields
    }
  }
}
    ${COMPANY_FIELDS}`;
var GQL_COMPANY_UPDATE = gql5`
    mutation company_update($id: Int!, $company: company_set_input!) {
  update_company(_set: $company, where: {id: {_eq: $id}}) {
    returning {
      ...company_fields
    }
  }
}
    ${COMPANY_FIELDS}`;
var GQL_COMPANY_DELETE = gql5`
    mutation company_delete($id: Int!) {
  delete_company(where: {id: {_eq: $id}}) {
    returning {
      ...company_fields
    }
  }
}
    ${COMPANY_FIELDS}`;
var GQL_CONTENT_CATEGORY_LIST = gql5`
    query content_category_list($offset: Int! = 0, $limit: Int! = 10) {
  categories: content_category(limit: $limit, offset: $offset) {
    ...content_category_fields
  }
}
    ${CONTENT_CATEGORY_FIELDS}`;
var GQL_CONTENT_ARTICLE_CATEGORY = gql5`
    query content_article_category($category_id: Int!, $offset: Int! = 0, $limit: Int! = 10, $order_by: [content_article_order_by!]) {
  articleCategory: content_category_by_pk(id: $category_id) {
    ...content_category_fields
    articles(limit: $limit, offset: $offset, order_by: $order_by) {
      ...content_article_fields
    }
  }
}
    ${CONTENT_CATEGORY_FIELDS}
${CONTENT_ARTICLE_FIELDS}`;
var GQL_CONTENT_ARTICLE_LIST = gql5`
    query content_article_list($offset: Int! = 0, $limit: Int! = 10, $order_by: [content_article_order_by!]) {
  articles: content_article(limit: $limit, offset: $offset, order_by: $order_by) {
    ...content_article_fields
    ...content_article_category_fields
  }
}
    ${CONTENT_ARTICLE_FIELDS}
${CONTENT_ARTICLE_CATEGORY_FIELDS}`;
var GQL_CONTENT_PAGE = gql5`
    query content_page($id: Int!) {
  page: content_page_by_pk(id: $id) {
    ...content_page_fields
  }
}
    ${CONTENT_PAGE_FIELDS}`;
var GQL_CONTENT_PAGE_LIST = gql5`
    query content_page_list($parent_id: Int, $offset: Int! = 0, $limit: Int! = 10) {
  pages: content_page(
    where: {parent_id: {_eq: $parent_id}}
    limit: $limit
    offset: $offset
  ) {
    ...content_page_fields
  }
}
    ${CONTENT_PAGE_FIELDS}`;
var GQL_DIAMANT_INVOICE_STATUS = gql5`
    query diamant_invoice_status($invoice_number: String!, $cache: Boolean!) {
  status: diamant_invoice_status(invoice_number: $invoice_number, cache: $cache) {
    ...diamant_invoice_status_fields
  }
}
    ${DIAMANT_INVOICE_STATUS_FIELDS}`;
var GQL_DIAMANT_INVOICE_STATUS_BATCH = gql5`
    query diamant_invoice_status_batch($invoice_numbers: [String!]!, $cache: Boolean!) {
  status: diamant_invoice_status_batch(
    invoice_numbers: $invoice_numbers
    cache: $cache
  ) {
    ...diamant_invoice_status_fields
  }
}
    ${DIAMANT_INVOICE_STATUS_FIELDS}`;
var GQL_DIAMANT_CUSTOMERS = gql5`
    query diamant_customers($account_number: String!, $client_id: String!) {
  customers: diamant_customers(
    account_number: $account_number
    client_id: $client_id
  ) {
    ...diamant_customer_tab_fields
  }
}
    ${DIAMANT_CUSTOMER_TAB_FIELDS}`;
var GQL_DIAMANT_ACCOUNTS = gql5`
    query diamant_accounts($account_number: String!, $client_id: String!) {
  accounts: diamant_accounts(
    account_number: $account_number
    client_id: $client_id
  ) {
    ...diamant_account_tab_fields
  }
}
    ${DIAMANT_ACCOUNT_TAB_FIELDS}`;
var GQL_DIAMANT_OIS = gql5`
    query diamant_ois($client_id: String!, $trans_type: String!) {
  diamant_ois(client_id: $client_id, trans_type: $trans_type) {
    ...diamant_invoice_oi_fields
  }
}
    ${DIAMANT_INVOICE_OI_FIELDS}`;
var GQL_FACETS = gql5`
    query facets($collection: String!) {
  facets(collection: $collection) {
    name
    title
    collection
    type
    target
    join
    default
    initial
    values {
      value
      label
    }
  }
}
    `;
var GQL_INVOICE_LIST = gql5`
    query invoice_list($offset: Int = 0, $limit: Int = 10, $order_by: [invoice_order_by!]) {
  invoices: invoice(limit: $limit, offset: $offset) {
    ...invoice_fields
  }
}
    ${INVOICE_FIELDS}`;
var GQL_INVOICE = gql5`
    query invoice($id: Int!) {
  invoice: invoice_by_pk(id: $id) {
    ...invoice_fields
  }
}
    ${INVOICE_FIELDS}`;
var GQL_PROJECT = gql5`
    query project($id: Int!) {
  project: project_by_pk(id: $id) {
    ...project_base
  }
}
    ${PROJECT_BASE}`;
var GQL_PROJECT_VIEW = gql5`
    query project_view($id: Int!) {
  project: project_by_pk(id: $id) {
    ...project_base
    ...project_relations_line
  }
}
    ${PROJECT_BASE}
${PROJECT_RELATIONS_LINE}`;
var GQL_PROJECT_COUNT = gql5`
    query project_count {
  project_aggregate {
    aggregate {
      count
    }
  }
}
    `;
var GQL_PROJECT_LIST = gql5`
    query project_list($offset: Int = 0, $limit: Int = 50, $order_by: [project_order_by!], $where: project_bool_exp) {
  projects: project(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    ...project_base
    ...project_relations_line
  }
}
    ${PROJECT_BASE}
${PROJECT_RELATIONS_LINE}`;
var GQL_PROJECT_CALENDAR = gql5`
    query project_calendar($where: project_bool_exp) {
  projects: project(where: $where) {
    id
    name
    reference
    start_date
    end_date
    status
    participant_count
    estimated_turnover
    actual_turnover
    business_area {
      id
      name
    }
    group {
      id
      name
    }
    manager {
      id
      code
      email
      name
    }
    office {
      id
      name
      code
    }
    country {
      id
      name
      code
    }
  }
}
    `;
var GQL_PROJECT_CREATE = gql5`
    mutation project_create($project: project_insert_input!) {
  project: insert_project(objects: [$project]) {
    returning {
      ...project_base
    }
  }
}
    ${PROJECT_BASE}`;
var GQL_PROJECT_UPDATE = gql5`
    mutation project_update($id: Int!, $project: project_set_input!) {
  project: update_project(_set: $project, where: {id: {_eq: $id}}) {
    returning {
      ...project_base
    }
  }
}
    ${PROJECT_BASE}`;
var GQL_PROJECT_FEED = gql5`
    subscription project_feed($order_by: [project_order_by!]) {
  projects: project(order_by: $order_by) {
    ...project_base
    ...project_relations_line
  }
}
    ${PROJECT_BASE}
${PROJECT_RELATIONS_LINE}`;
var GQL_PROJECT_COUNT_FEED = gql5`
    subscription project_count_feed {
  project_aggregate {
    aggregate {
      count
    }
  }
}
    `;
var GQL_USER_ACCOUNTS_BY_EMAIL = gql5`
    query user_accounts_by_email($email: String!) {
  user_accounts: user_account(where: {email: {_eq: $email}}) {
    ...UserProfile
    ...UserGroups
  }
}
    ${USERPROFILE}
${USERGROUPS}`;
var GQL_USER_ACCOUNT_BY_ID = gql5`
    query user_account_by_id($id: Int!) {
  user_account: user_account_by_pk(id: $id) {
    ...UserProfile
    ...UserGroups
  }
}
    ${USERPROFILE}
${USERGROUPS}`;
var GQL_USER_BOOKMARK_LIST = gql5`
    query user_bookmark_list($user_id: Int!) {
  user_bookmarks: user_bookmark(where: {user_id: {_eq: $user_id}}) {
    ...user_bookmark_fields
  }
}
    ${USER_BOOKMARK_FIELDS}`;
var GQL_OBJECT_BOOKMARK = gql5`
    query object_bookmark($object_id: Int!, $object_typename: String!, $user_id: Int!) {
  object_bookmark: user_bookmark(
    where: {object_id: {_eq: $object_id}, object_typename: {_eq: $object_typename}, user_id: {_eq: $user_id}}
  ) {
    ...user_bookmark_fields
  }
}
    ${USER_BOOKMARK_FIELDS}`;
var GQL_USER_BOOKMARK_CREATE = gql5`
    mutation user_bookmark_create($object_id: Int!, $object_typename: String!, $user_id: Int!) {
  insert_user_bookmark(
    objects: {object_id: $object_id, object_typename: $object_typename, user_id: $user_id}
  ) {
    returning {
      ...user_bookmark_fields
    }
  }
}
    ${USER_BOOKMARK_FIELDS}`;
var GQL_USER_BOOKMARK_DELETE = gql5`
    mutation user_bookmark_delete($object_id: Int!, $object_typename: String!, $user_id: Int!) {
  delete_user_bookmark(
    where: {object_id: {_eq: $object_id}, object_typename: {_eq: $object_typename}, user_id: {_eq: $user_id}}
  ) {
    returning {
      ...user_bookmark_fields
    }
  }
}
    ${USER_BOOKMARK_FIELDS}`;

// crud/access.ts
import { crudAccessRules } from "@hc/graphql";
crudAccessRules.USER_FULL_ACCESS = [
  "project",
  "budget",
  "service",
  "service_group",
  "project_group",
  "project_manager",
  "budget_fee",
  "project_group_manager",
  "invoice",
  "contract"
];
crudAccessRules.USER_NO_ACCESS = [
  "company_manager",
  "office_manager",
  "diamant"
];
crudAccessRules.CUSTOM_RULES = {
  messaging: {
    admin: {
      config: true
    },
    user: {
      config: true
    },
    manager: {
      config: true
    }
  },
  diamant: {
    admin: {
      index: true,
      read: true
    },
    user: {
      index: false,
      read: false
    },
    manager: {
      index: false,
      read: false
    }
  },
  invoice: {
    admin: {
      confirm: true,
      cancel: true,
      reset: true,
      markAsPaid: true,
      download: true,
      eDownload: true,
      sendToClient: true,
      removePayment: true
    },
    user: {
      index: true,
      read: true,
      confirm: true,
      cancel: false,
      reset: false,
      markAsPaid: true,
      download: true,
      destroy: true,
      sendToClient: true,
      removePayment: false
    },
    manager: {
      index: true,
      read: true,
      confirm: true,
      cancel: true,
      reset: false,
      markAsPaid: true,
      download: true,
      destroy: true,
      sendToClient: true,
      removePayment: true
    }
  },
  contract: {
    admin: {
      confirm: true,
      download: true,
      sendForSigning: true,
      pending: true,
      reset: true,
      markAsSigned: true,
      cancel: true,
      clone: true,
      manualSigning: true
    },
    user: {
      confirm: true,
      download: true,
      sendForSigning: false,
      pending: true,
      reset: false,
      markAsSigned: true,
      cancel: false,
      clone: true,
      manualSigning: false
    },
    manager: {
      confirm: true,
      download: true,
      sendForSigning: true,
      pending: true,
      reset: false,
      markAsSigned: true,
      cancel: true,
      clone: true,
      manualSigning: true
    }
  },
  project: {
    admin: {
      confirm: true,
      start: true,
      complete: true,
      forceComplete: true,
      cancel: true,
      clone: true,
      restart: true,
      reset: true,
      destroy: true
    },
    user: {
      confirm: true,
      start: true,
      complete: true,
      forceComplete: false,
      cancel: true,
      clone: true,
      restart: true,
      reset: false,
      destroy: true
    },
    manager: {
      confirm: true,
      start: true,
      complete: true,
      forceComplete: false,
      cancel: true,
      clone: true,
      restart: true,
      reset: false,
      destroy: true
    }
  },
  project_group: {
    admin: {},
    user: {
      create: false,
      update: false
    },
    manager: {
      create: false,
      update: false
    }
  },
  budget: {
    admin: {
      confirm: true,
      reject: true,
      reset: true,
      serviceInvoice: true,
      depositInvoice: true,
      provisionInvoice: true,
      clone: true,
      copyServices: true,
      download: true,
      export: true,
      downloadProvision: true,
      destroy: true,
      serviceContract: true,
      sendToClient: true
    },
    user: {
      index: true,
      confirm: true,
      reject: true,
      reset: false,
      serviceInvoice: true,
      depositInvoice: true,
      provisionInvoice: true,
      clone: true,
      copyServices: true,
      download: true,
      export: true,
      downloadProvision: true,
      destroy: true,
      serviceContract: true,
      sendToClient: true
    },
    manager: {
      index: true,
      confirm: true,
      reject: true,
      reset: false,
      serviceInvoice: true,
      depositInvoice: true,
      provisionInvoice: true,
      clone: true,
      copyServices: true,
      download: true,
      export: true,
      downloadProvision: true,
      destroy: true,
      serviceContract: true,
      sendToClient: true
    }
  },
  facets: {
    admin: {
      index: true
    },
    user: {
      index: true
    },
    manager: {
      index: true
    }
  },
  office: {
    manager: {
      update: true
    }
  },
  company: {
    manager: {
      update: true
    }
  },
  company_address: {
    manager: {
      update: true
    }
  },
  company_relation: {
    manager: {
      update: true
    }
  },
  company_vat_number: {
    manager: {
      update: true
    }
  },
  company_bank_account: {
    manager: {
      update: true
    }
  },
  office_manager: {
    manager: {
      index: true
    }
  },
  company_manager: {
    manager: {
      index: true
    }
  }
};

// graphql/types.ts
var BudgetConstraint = /* @__PURE__ */ (function(BudgetConstraint2) {
  BudgetConstraint2["BUDGET_PKEY"] = "budget_pkey";
  return BudgetConstraint2;
})({});
var BudgetFeeConstraint = /* @__PURE__ */ (function(BudgetFeeConstraint2) {
  BudgetFeeConstraint2["BUDGET_FEE_PKEY"] = "budget_fee_pkey";
  return BudgetFeeConstraint2;
})({});
var BudgetFeeSelectColumn = /* @__PURE__ */ (function(BudgetFeeSelectColumn2) {
  BudgetFeeSelectColumn2["ABSOLUTE"] = "absolute";
  BudgetFeeSelectColumn2["BUDGET_ID"] = "budget_id";
  BudgetFeeSelectColumn2["CREATED_AT"] = "created_at";
  BudgetFeeSelectColumn2["DESCRIPTION"] = "description";
  BudgetFeeSelectColumn2["ID"] = "id";
  BudgetFeeSelectColumn2["NAME"] = "name";
  BudgetFeeSelectColumn2["TAX_RATE"] = "tax_rate";
  BudgetFeeSelectColumn2["UPDATED_AT"] = "updated_at";
  BudgetFeeSelectColumn2["VALUE"] = "value";
  return BudgetFeeSelectColumn2;
})({});
var BudgetFeeSelectColumnBudgetFeeAggregateBoolExpBoolAndArgumentsColumns = /* @__PURE__ */ (function(BudgetFeeSelectColumnBudgetFeeAggregateBoolExpBoolAndArgumentsColumns2) {
  BudgetFeeSelectColumnBudgetFeeAggregateBoolExpBoolAndArgumentsColumns2["ABSOLUTE"] = "absolute";
  return BudgetFeeSelectColumnBudgetFeeAggregateBoolExpBoolAndArgumentsColumns2;
})({});
var BudgetFeeSelectColumnBudgetFeeAggregateBoolExpBoolOrArgumentsColumns = /* @__PURE__ */ (function(BudgetFeeSelectColumnBudgetFeeAggregateBoolExpBoolOrArgumentsColumns2) {
  BudgetFeeSelectColumnBudgetFeeAggregateBoolExpBoolOrArgumentsColumns2["ABSOLUTE"] = "absolute";
  return BudgetFeeSelectColumnBudgetFeeAggregateBoolExpBoolOrArgumentsColumns2;
})({});
var BudgetFeeUpdateColumn = /* @__PURE__ */ (function(BudgetFeeUpdateColumn2) {
  BudgetFeeUpdateColumn2["ABSOLUTE"] = "absolute";
  BudgetFeeUpdateColumn2["BUDGET_ID"] = "budget_id";
  BudgetFeeUpdateColumn2["CREATED_AT"] = "created_at";
  BudgetFeeUpdateColumn2["DESCRIPTION"] = "description";
  BudgetFeeUpdateColumn2["ID"] = "id";
  BudgetFeeUpdateColumn2["NAME"] = "name";
  BudgetFeeUpdateColumn2["TAX_RATE"] = "tax_rate";
  BudgetFeeUpdateColumn2["UPDATED_AT"] = "updated_at";
  BudgetFeeUpdateColumn2["VALUE"] = "value";
  return BudgetFeeUpdateColumn2;
})({});
var BudgetSelectColumn = /* @__PURE__ */ (function(BudgetSelectColumn2) {
  BudgetSelectColumn2["ACTUAL_COST"] = "actual_cost";
  BudgetSelectColumn2["BANK_ACCOUNT_ID"] = "bank_account_id";
  BudgetSelectColumn2["CITY"] = "city";
  BudgetSelectColumn2["COMMISSION_AMOUNT"] = "commission_amount";
  BudgetSelectColumn2["CONTINGENCY_AMOUNT"] = "contingency_amount";
  BudgetSelectColumn2["CONTINGENCY_RATE"] = "contingency_rate";
  BudgetSelectColumn2["COUNTRY_ID"] = "country_id";
  BudgetSelectColumn2["CREATED_AT"] = "created_at";
  BudgetSelectColumn2["DESCRIPTION"] = "description";
  BudgetSelectColumn2["EARNING_AMOUNT"] = "earning_amount";
  BudgetSelectColumn2["FEES_AMOUNT"] = "fees_amount";
  BudgetSelectColumn2["FOOTER"] = "footer";
  BudgetSelectColumn2["GROSS_TURNOVER"] = "gross_turnover";
  BudgetSelectColumn2["ID"] = "id";
  BudgetSelectColumn2["INTERNAL_REMARKS"] = "internal_remarks";
  BudgetSelectColumn2["INVOICED_AMOUNT"] = "invoiced_amount";
  BudgetSelectColumn2["ISSUER_ADDRESS"] = "issuer_address";
  BudgetSelectColumn2["MISSING_AMOUNT"] = "missing_amount";
  BudgetSelectColumn2["NAME"] = "name";
  BudgetSelectColumn2["NET_TURNOVER"] = "net_turnover";
  BudgetSelectColumn2["OFFICE_ID"] = "office_id";
  BudgetSelectColumn2["PAYMENT_AMOUNT"] = "payment_amount";
  BudgetSelectColumn2["PROJECT_ID"] = "project_id";
  BudgetSelectColumn2["PROVISION_AMOUNT"] = "provision_amount";
  BudgetSelectColumn2["PURCHASE_NUMBER"] = "purchase_number";
  BudgetSelectColumn2["REMOTE_ID"] = "remote_id";
  BudgetSelectColumn2["SEND_HISTORY"] = "send_history";
  BudgetSelectColumn2["SORT_INDEX"] = "sort_index";
  BudgetSelectColumn2["STATUS"] = "status";
  BudgetSelectColumn2["UPDATED_AT"] = "updated_at";
  BudgetSelectColumn2["VAT_NUMBER_ID"] = "vat_number_id";
  return BudgetSelectColumn2;
})({});
var BudgetUpdateColumn = /* @__PURE__ */ (function(BudgetUpdateColumn2) {
  BudgetUpdateColumn2["ACTUAL_COST"] = "actual_cost";
  BudgetUpdateColumn2["BANK_ACCOUNT_ID"] = "bank_account_id";
  BudgetUpdateColumn2["CITY"] = "city";
  BudgetUpdateColumn2["COMMISSION_AMOUNT"] = "commission_amount";
  BudgetUpdateColumn2["CONTINGENCY_AMOUNT"] = "contingency_amount";
  BudgetUpdateColumn2["CONTINGENCY_RATE"] = "contingency_rate";
  BudgetUpdateColumn2["COUNTRY_ID"] = "country_id";
  BudgetUpdateColumn2["CREATED_AT"] = "created_at";
  BudgetUpdateColumn2["DESCRIPTION"] = "description";
  BudgetUpdateColumn2["EARNING_AMOUNT"] = "earning_amount";
  BudgetUpdateColumn2["FEES_AMOUNT"] = "fees_amount";
  BudgetUpdateColumn2["FOOTER"] = "footer";
  BudgetUpdateColumn2["GROSS_TURNOVER"] = "gross_turnover";
  BudgetUpdateColumn2["ID"] = "id";
  BudgetUpdateColumn2["INTERNAL_REMARKS"] = "internal_remarks";
  BudgetUpdateColumn2["INVOICED_AMOUNT"] = "invoiced_amount";
  BudgetUpdateColumn2["ISSUER_ADDRESS"] = "issuer_address";
  BudgetUpdateColumn2["MISSING_AMOUNT"] = "missing_amount";
  BudgetUpdateColumn2["NAME"] = "name";
  BudgetUpdateColumn2["NET_TURNOVER"] = "net_turnover";
  BudgetUpdateColumn2["OFFICE_ID"] = "office_id";
  BudgetUpdateColumn2["PAYMENT_AMOUNT"] = "payment_amount";
  BudgetUpdateColumn2["PROJECT_ID"] = "project_id";
  BudgetUpdateColumn2["PROVISION_AMOUNT"] = "provision_amount";
  BudgetUpdateColumn2["PURCHASE_NUMBER"] = "purchase_number";
  BudgetUpdateColumn2["REMOTE_ID"] = "remote_id";
  BudgetUpdateColumn2["SEND_HISTORY"] = "send_history";
  BudgetUpdateColumn2["SORT_INDEX"] = "sort_index";
  BudgetUpdateColumn2["STATUS"] = "status";
  BudgetUpdateColumn2["UPDATED_AT"] = "updated_at";
  BudgetUpdateColumn2["VAT_NUMBER_ID"] = "vat_number_id";
  return BudgetUpdateColumn2;
})({});
var BusinessAreaCategoryConstraint = /* @__PURE__ */ (function(BusinessAreaCategoryConstraint2) {
  BusinessAreaCategoryConstraint2["BUSINESS_AREA_CATEGORY_PKEY"] = "business_area_category_pkey";
  return BusinessAreaCategoryConstraint2;
})({});
var BusinessAreaCategorySelectColumn = /* @__PURE__ */ (function(BusinessAreaCategorySelectColumn2) {
  BusinessAreaCategorySelectColumn2["ARCHIVED"] = "archived";
  BusinessAreaCategorySelectColumn2["BUSINESS_AREA_ID"] = "business_area_id";
  BusinessAreaCategorySelectColumn2["CREATED_AT"] = "created_at";
  BusinessAreaCategorySelectColumn2["ID"] = "id";
  BusinessAreaCategorySelectColumn2["NAME"] = "name";
  BusinessAreaCategorySelectColumn2["UPDATED_AT"] = "updated_at";
  return BusinessAreaCategorySelectColumn2;
})({});
var BusinessAreaCategorySelectColumnBusinessAreaCategoryAggregateBoolExpBoolAndArgumentsColumns = /* @__PURE__ */ (function(BusinessAreaCategorySelectColumnBusinessAreaCategoryAggregateBoolExpBoolAndArgumentsColumns2) {
  BusinessAreaCategorySelectColumnBusinessAreaCategoryAggregateBoolExpBoolAndArgumentsColumns2["ARCHIVED"] = "archived";
  return BusinessAreaCategorySelectColumnBusinessAreaCategoryAggregateBoolExpBoolAndArgumentsColumns2;
})({});
var BusinessAreaCategorySelectColumnBusinessAreaCategoryAggregateBoolExpBoolOrArgumentsColumns = /* @__PURE__ */ (function(BusinessAreaCategorySelectColumnBusinessAreaCategoryAggregateBoolExpBoolOrArgumentsColumns2) {
  BusinessAreaCategorySelectColumnBusinessAreaCategoryAggregateBoolExpBoolOrArgumentsColumns2["ARCHIVED"] = "archived";
  return BusinessAreaCategorySelectColumnBusinessAreaCategoryAggregateBoolExpBoolOrArgumentsColumns2;
})({});
var BusinessAreaCategoryUpdateColumn = /* @__PURE__ */ (function(BusinessAreaCategoryUpdateColumn2) {
  BusinessAreaCategoryUpdateColumn2["ARCHIVED"] = "archived";
  BusinessAreaCategoryUpdateColumn2["BUSINESS_AREA_ID"] = "business_area_id";
  BusinessAreaCategoryUpdateColumn2["CREATED_AT"] = "created_at";
  BusinessAreaCategoryUpdateColumn2["ID"] = "id";
  BusinessAreaCategoryUpdateColumn2["NAME"] = "name";
  BusinessAreaCategoryUpdateColumn2["UPDATED_AT"] = "updated_at";
  return BusinessAreaCategoryUpdateColumn2;
})({});
var BusinessAreaConstraint = /* @__PURE__ */ (function(BusinessAreaConstraint2) {
  BusinessAreaConstraint2["BUSINESS_AREA_PKEY"] = "business_area_pkey";
  return BusinessAreaConstraint2;
})({});
var BusinessAreaSelectColumn = /* @__PURE__ */ (function(BusinessAreaSelectColumn2) {
  BusinessAreaSelectColumn2["ARCHIVED"] = "archived";
  BusinessAreaSelectColumn2["CREATED_AT"] = "created_at";
  BusinessAreaSelectColumn2["FIXED_COSTS_RATE"] = "fixed_costs_rate";
  BusinessAreaSelectColumn2["ID"] = "id";
  BusinessAreaSelectColumn2["NAME"] = "name";
  BusinessAreaSelectColumn2["PROFIT_TRESHOLD_RATE"] = "profit_treshold_rate";
  BusinessAreaSelectColumn2["UPDATED_AT"] = "updated_at";
  return BusinessAreaSelectColumn2;
})({});
var BusinessAreaUpdateColumn = /* @__PURE__ */ (function(BusinessAreaUpdateColumn2) {
  BusinessAreaUpdateColumn2["ARCHIVED"] = "archived";
  BusinessAreaUpdateColumn2["CREATED_AT"] = "created_at";
  BusinessAreaUpdateColumn2["FIXED_COSTS_RATE"] = "fixed_costs_rate";
  BusinessAreaUpdateColumn2["ID"] = "id";
  BusinessAreaUpdateColumn2["NAME"] = "name";
  BusinessAreaUpdateColumn2["PROFIT_TRESHOLD_RATE"] = "profit_treshold_rate";
  BusinessAreaUpdateColumn2["UPDATED_AT"] = "updated_at";
  return BusinessAreaUpdateColumn2;
})({});
var CompanyAddressConstraint = /* @__PURE__ */ (function(CompanyAddressConstraint2) {
  CompanyAddressConstraint2["COMPANY_ADDRESS_PKEY"] = "company_address_pkey";
  return CompanyAddressConstraint2;
})({});
var CompanyAddressSelectColumn = /* @__PURE__ */ (function(CompanyAddressSelectColumn2) {
  CompanyAddressSelectColumn2["ADDITIONAL"] = "additional";
  CompanyAddressSelectColumn2["CITY"] = "city";
  CompanyAddressSelectColumn2["COMPANY_ID"] = "company_id";
  CompanyAddressSelectColumn2["COUNTRY_ID"] = "country_id";
  CompanyAddressSelectColumn2["CREATED_AT"] = "created_at";
  CompanyAddressSelectColumn2["EMAIL"] = "email";
  CompanyAddressSelectColumn2["ID"] = "id";
  CompanyAddressSelectColumn2["STREET"] = "street";
  CompanyAddressSelectColumn2["TYPE"] = "type";
  CompanyAddressSelectColumn2["UPDATED_AT"] = "updated_at";
  CompanyAddressSelectColumn2["ZIP"] = "zip";
  return CompanyAddressSelectColumn2;
})({});
var CompanyAddressUpdateColumn = /* @__PURE__ */ (function(CompanyAddressUpdateColumn2) {
  CompanyAddressUpdateColumn2["ADDITIONAL"] = "additional";
  CompanyAddressUpdateColumn2["CITY"] = "city";
  CompanyAddressUpdateColumn2["COMPANY_ID"] = "company_id";
  CompanyAddressUpdateColumn2["COUNTRY_ID"] = "country_id";
  CompanyAddressUpdateColumn2["CREATED_AT"] = "created_at";
  CompanyAddressUpdateColumn2["EMAIL"] = "email";
  CompanyAddressUpdateColumn2["ID"] = "id";
  CompanyAddressUpdateColumn2["STREET"] = "street";
  CompanyAddressUpdateColumn2["TYPE"] = "type";
  CompanyAddressUpdateColumn2["UPDATED_AT"] = "updated_at";
  CompanyAddressUpdateColumn2["ZIP"] = "zip";
  return CompanyAddressUpdateColumn2;
})({});
var CompanyBankAccountConstraint = /* @__PURE__ */ (function(CompanyBankAccountConstraint2) {
  CompanyBankAccountConstraint2["COMPANY_BANK_ACCOUNT_PKEY"] = "company_bank_account_pkey";
  return CompanyBankAccountConstraint2;
})({});
var CompanyBankAccountSelectColumn = /* @__PURE__ */ (function(CompanyBankAccountSelectColumn2) {
  CompanyBankAccountSelectColumn2["ACCOUNT_HOLDER"] = "account_holder";
  CompanyBankAccountSelectColumn2["BANK_NAME"] = "bank_name";
  CompanyBankAccountSelectColumn2["BIC"] = "bic";
  CompanyBankAccountSelectColumn2["COMPANY_ID"] = "company_id";
  CompanyBankAccountSelectColumn2["CREATED_AT"] = "created_at";
  CompanyBankAccountSelectColumn2["IBAN"] = "iban";
  CompanyBankAccountSelectColumn2["ID"] = "id";
  CompanyBankAccountSelectColumn2["NAME"] = "name";
  CompanyBankAccountSelectColumn2["UPDATED_AT"] = "updated_at";
  return CompanyBankAccountSelectColumn2;
})({});
var CompanyBankAccountUpdateColumn = /* @__PURE__ */ (function(CompanyBankAccountUpdateColumn2) {
  CompanyBankAccountUpdateColumn2["ACCOUNT_HOLDER"] = "account_holder";
  CompanyBankAccountUpdateColumn2["BANK_NAME"] = "bank_name";
  CompanyBankAccountUpdateColumn2["BIC"] = "bic";
  CompanyBankAccountUpdateColumn2["COMPANY_ID"] = "company_id";
  CompanyBankAccountUpdateColumn2["CREATED_AT"] = "created_at";
  CompanyBankAccountUpdateColumn2["IBAN"] = "iban";
  CompanyBankAccountUpdateColumn2["ID"] = "id";
  CompanyBankAccountUpdateColumn2["NAME"] = "name";
  CompanyBankAccountUpdateColumn2["UPDATED_AT"] = "updated_at";
  return CompanyBankAccountUpdateColumn2;
})({});
var CompanyConstraint = /* @__PURE__ */ (function(CompanyConstraint2) {
  CompanyConstraint2["COMPANY_NAME_UNIQUE"] = "company_name_unique";
  CompanyConstraint2["COMPANY_PKEY"] = "company_pkey";
  return CompanyConstraint2;
})({});
var CompanyManagerConstraint = /* @__PURE__ */ (function(CompanyManagerConstraint2) {
  CompanyManagerConstraint2["COMPANY_MANAGER_PKEY"] = "company_manager_pkey";
  return CompanyManagerConstraint2;
})({});
var CompanyManagerSelectColumn = /* @__PURE__ */ (function(CompanyManagerSelectColumn2) {
  CompanyManagerSelectColumn2["COMPANY_ID"] = "company_id";
  CompanyManagerSelectColumn2["CREATED_AT"] = "created_at";
  CompanyManagerSelectColumn2["ID"] = "id";
  CompanyManagerSelectColumn2["UPDATED_AT"] = "updated_at";
  CompanyManagerSelectColumn2["USER_ID"] = "user_id";
  return CompanyManagerSelectColumn2;
})({});
var CompanyManagerUpdateColumn = /* @__PURE__ */ (function(CompanyManagerUpdateColumn2) {
  CompanyManagerUpdateColumn2["COMPANY_ID"] = "company_id";
  CompanyManagerUpdateColumn2["CREATED_AT"] = "created_at";
  CompanyManagerUpdateColumn2["ID"] = "id";
  CompanyManagerUpdateColumn2["UPDATED_AT"] = "updated_at";
  CompanyManagerUpdateColumn2["USER_ID"] = "user_id";
  return CompanyManagerUpdateColumn2;
})({});
var CompanyRelationConstraint = /* @__PURE__ */ (function(CompanyRelationConstraint2) {
  CompanyRelationConstraint2["COMPANY_RELATION_COMPANY_ID_TARGET_ID_RELATION_KEY"] = "company_relation_company_id_target_id_relation_key";
  CompanyRelationConstraint2["COMPANY_RELATION_PKEY"] = "company_relation_pkey";
  return CompanyRelationConstraint2;
})({});
var CompanyRelationSelectColumn = /* @__PURE__ */ (function(CompanyRelationSelectColumn2) {
  CompanyRelationSelectColumn2["COMPANY_ID"] = "company_id";
  CompanyRelationSelectColumn2["CREATED_AT"] = "created_at";
  CompanyRelationSelectColumn2["ID"] = "id";
  CompanyRelationSelectColumn2["RELATION"] = "relation";
  CompanyRelationSelectColumn2["TARGET_ID"] = "target_id";
  CompanyRelationSelectColumn2["UPDATED_AT"] = "updated_at";
  CompanyRelationSelectColumn2["VALUE"] = "value";
  return CompanyRelationSelectColumn2;
})({});
var CompanyRelationUpdateColumn = /* @__PURE__ */ (function(CompanyRelationUpdateColumn2) {
  CompanyRelationUpdateColumn2["COMPANY_ID"] = "company_id";
  CompanyRelationUpdateColumn2["CREATED_AT"] = "created_at";
  CompanyRelationUpdateColumn2["ID"] = "id";
  CompanyRelationUpdateColumn2["RELATION"] = "relation";
  CompanyRelationUpdateColumn2["TARGET_ID"] = "target_id";
  CompanyRelationUpdateColumn2["UPDATED_AT"] = "updated_at";
  CompanyRelationUpdateColumn2["VALUE"] = "value";
  return CompanyRelationUpdateColumn2;
})({});
var CompanySelectColumn = /* @__PURE__ */ (function(CompanySelectColumn2) {
  CompanySelectColumn2["ACCOUNTING_CLIENT_ID"] = "accounting_client_id";
  CompanySelectColumn2["ACCOUNTING_CURRENCY_ID"] = "accounting_currency_id";
  CompanySelectColumn2["ADDITIONAL_DOCUMENT_RECIPIENT"] = "additional_document_recipient";
  CompanySelectColumn2["BRAND_NAME"] = "brand_name";
  CompanySelectColumn2["COUNTRY_ID"] = "country_id";
  CompanySelectColumn2["CREATED_AT"] = "created_at";
  CompanySelectColumn2["HUBSPOT_ID"] = "hubspot_id";
  CompanySelectColumn2["ID"] = "id";
  CompanySelectColumn2["INVOICE_COUNTER"] = "invoice_counter";
  CompanySelectColumn2["INVOICE_DUE_ADDITIONAL_MONTHS"] = "invoice_due_additional_months";
  CompanySelectColumn2["INVOICE_DUE_DAY_OF_MONTH"] = "invoice_due_day_of_month";
  CompanySelectColumn2["INVOICE_NUMBER_PREFIX"] = "invoice_number_prefix";
  CompanySelectColumn2["INVOICE_REVIEWER_ADDRESSES"] = "invoice_reviewer_addresses";
  CompanySelectColumn2["LANGUAGE"] = "language";
  CompanySelectColumn2["LOGO_URL"] = "logo_url";
  CompanySelectColumn2["MAIN_BANK_ACCOUNT_ID"] = "main_bank_account_id";
  CompanySelectColumn2["MAIN_VAT_NUMBER_ID"] = "main_vat_number_id";
  CompanySelectColumn2["NAME"] = "name";
  CompanySelectColumn2["PHONE"] = "phone";
  CompanySelectColumn2["PRIMARY"] = "primary";
  CompanySelectColumn2["PRIMARY_TEXT"] = "primary_text";
  CompanySelectColumn2["SECONDARY"] = "secondary";
  CompanySelectColumn2["SECONDARY_TEXT"] = "secondary_text";
  CompanySelectColumn2["TYPE"] = "type";
  CompanySelectColumn2["UPDATED_AT"] = "updated_at";
  CompanySelectColumn2["WEBSITE"] = "website";
  return CompanySelectColumn2;
})({});
var CompanyUpdateColumn = /* @__PURE__ */ (function(CompanyUpdateColumn2) {
  CompanyUpdateColumn2["ACCOUNTING_CLIENT_ID"] = "accounting_client_id";
  CompanyUpdateColumn2["ACCOUNTING_CURRENCY_ID"] = "accounting_currency_id";
  CompanyUpdateColumn2["ADDITIONAL_DOCUMENT_RECIPIENT"] = "additional_document_recipient";
  CompanyUpdateColumn2["BRAND_NAME"] = "brand_name";
  CompanyUpdateColumn2["COUNTRY_ID"] = "country_id";
  CompanyUpdateColumn2["CREATED_AT"] = "created_at";
  CompanyUpdateColumn2["HUBSPOT_ID"] = "hubspot_id";
  CompanyUpdateColumn2["ID"] = "id";
  CompanyUpdateColumn2["INVOICE_COUNTER"] = "invoice_counter";
  CompanyUpdateColumn2["INVOICE_DUE_ADDITIONAL_MONTHS"] = "invoice_due_additional_months";
  CompanyUpdateColumn2["INVOICE_DUE_DAY_OF_MONTH"] = "invoice_due_day_of_month";
  CompanyUpdateColumn2["INVOICE_NUMBER_PREFIX"] = "invoice_number_prefix";
  CompanyUpdateColumn2["INVOICE_REVIEWER_ADDRESSES"] = "invoice_reviewer_addresses";
  CompanyUpdateColumn2["LANGUAGE"] = "language";
  CompanyUpdateColumn2["LOGO_URL"] = "logo_url";
  CompanyUpdateColumn2["MAIN_BANK_ACCOUNT_ID"] = "main_bank_account_id";
  CompanyUpdateColumn2["MAIN_VAT_NUMBER_ID"] = "main_vat_number_id";
  CompanyUpdateColumn2["NAME"] = "name";
  CompanyUpdateColumn2["PHONE"] = "phone";
  CompanyUpdateColumn2["PRIMARY"] = "primary";
  CompanyUpdateColumn2["PRIMARY_TEXT"] = "primary_text";
  CompanyUpdateColumn2["SECONDARY"] = "secondary";
  CompanyUpdateColumn2["SECONDARY_TEXT"] = "secondary_text";
  CompanyUpdateColumn2["TYPE"] = "type";
  CompanyUpdateColumn2["UPDATED_AT"] = "updated_at";
  CompanyUpdateColumn2["WEBSITE"] = "website";
  return CompanyUpdateColumn2;
})({});
var CompanyVatNumberConstraint = /* @__PURE__ */ (function(CompanyVatNumberConstraint2) {
  CompanyVatNumberConstraint2["COMPANY_VAT_NUMBER_PKEY"] = "company_vat_number_pkey";
  CompanyVatNumberConstraint2["COMPANY_VAT_NUMBER_VALUE_KEY"] = "company_vat_number_value_key";
  return CompanyVatNumberConstraint2;
})({});
var CompanyVatNumberSelectColumn = /* @__PURE__ */ (function(CompanyVatNumberSelectColumn2) {
  CompanyVatNumberSelectColumn2["ACTIVE"] = "active";
  CompanyVatNumberSelectColumn2["COMPANY_ID"] = "company_id";
  CompanyVatNumberSelectColumn2["CREATED_AT"] = "created_at";
  CompanyVatNumberSelectColumn2["DESCRIPTION"] = "description";
  CompanyVatNumberSelectColumn2["ID"] = "id";
  CompanyVatNumberSelectColumn2["UPDATED_AT"] = "updated_at";
  CompanyVatNumberSelectColumn2["VALIDATION"] = "validation";
  CompanyVatNumberSelectColumn2["VALUE"] = "value";
  return CompanyVatNumberSelectColumn2;
})({});
var CompanyVatNumberSelectColumnCompanyVatNumberAggregateBoolExpBoolAndArgumentsColumns = /* @__PURE__ */ (function(CompanyVatNumberSelectColumnCompanyVatNumberAggregateBoolExpBoolAndArgumentsColumns2) {
  CompanyVatNumberSelectColumnCompanyVatNumberAggregateBoolExpBoolAndArgumentsColumns2["ACTIVE"] = "active";
  return CompanyVatNumberSelectColumnCompanyVatNumberAggregateBoolExpBoolAndArgumentsColumns2;
})({});
var CompanyVatNumberSelectColumnCompanyVatNumberAggregateBoolExpBoolOrArgumentsColumns = /* @__PURE__ */ (function(CompanyVatNumberSelectColumnCompanyVatNumberAggregateBoolExpBoolOrArgumentsColumns2) {
  CompanyVatNumberSelectColumnCompanyVatNumberAggregateBoolExpBoolOrArgumentsColumns2["ACTIVE"] = "active";
  return CompanyVatNumberSelectColumnCompanyVatNumberAggregateBoolExpBoolOrArgumentsColumns2;
})({});
var CompanyVatNumberUpdateColumn = /* @__PURE__ */ (function(CompanyVatNumberUpdateColumn2) {
  CompanyVatNumberUpdateColumn2["ACTIVE"] = "active";
  CompanyVatNumberUpdateColumn2["COMPANY_ID"] = "company_id";
  CompanyVatNumberUpdateColumn2["CREATED_AT"] = "created_at";
  CompanyVatNumberUpdateColumn2["DESCRIPTION"] = "description";
  CompanyVatNumberUpdateColumn2["ID"] = "id";
  CompanyVatNumberUpdateColumn2["UPDATED_AT"] = "updated_at";
  CompanyVatNumberUpdateColumn2["VALIDATION"] = "validation";
  CompanyVatNumberUpdateColumn2["VALUE"] = "value";
  return CompanyVatNumberUpdateColumn2;
})({});
var ContentArticleConstraint = /* @__PURE__ */ (function(ContentArticleConstraint2) {
  ContentArticleConstraint2["CONTENT_ARTICLE_PKEY"] = "content_article_pkey";
  ContentArticleConstraint2["CONTENT_ARTICLE_SLUG_UNIQUE"] = "content_article_slug_unique";
  return ContentArticleConstraint2;
})({});
var ContentArticleSelectColumn = /* @__PURE__ */ (function(ContentArticleSelectColumn2) {
  ContentArticleSelectColumn2["CATEGORY_ID"] = "category_id";
  ContentArticleSelectColumn2["CONTENT"] = "content";
  ContentArticleSelectColumn2["CREATED_AT"] = "created_at";
  ContentArticleSelectColumn2["ID"] = "id";
  ContentArticleSelectColumn2["SLUG"] = "slug";
  ContentArticleSelectColumn2["TEASER"] = "teaser";
  ContentArticleSelectColumn2["TITLE"] = "title";
  ContentArticleSelectColumn2["UPDATED_AT"] = "updated_at";
  return ContentArticleSelectColumn2;
})({});
var ContentArticleUpdateColumn = /* @__PURE__ */ (function(ContentArticleUpdateColumn2) {
  ContentArticleUpdateColumn2["CATEGORY_ID"] = "category_id";
  ContentArticleUpdateColumn2["CONTENT"] = "content";
  ContentArticleUpdateColumn2["CREATED_AT"] = "created_at";
  ContentArticleUpdateColumn2["ID"] = "id";
  ContentArticleUpdateColumn2["SLUG"] = "slug";
  ContentArticleUpdateColumn2["TEASER"] = "teaser";
  ContentArticleUpdateColumn2["TITLE"] = "title";
  ContentArticleUpdateColumn2["UPDATED_AT"] = "updated_at";
  return ContentArticleUpdateColumn2;
})({});
var ContentCategoryConstraint = /* @__PURE__ */ (function(ContentCategoryConstraint2) {
  ContentCategoryConstraint2["CONTENT_CATEGORY_PKEY"] = "content_category_pkey";
  ContentCategoryConstraint2["CONTENT_CATEGORY_SLUG_UNIQUE"] = "content_category_slug_unique";
  return ContentCategoryConstraint2;
})({});
var ContentCategorySelectColumn = /* @__PURE__ */ (function(ContentCategorySelectColumn2) {
  ContentCategorySelectColumn2["CONTENT"] = "content";
  ContentCategorySelectColumn2["CREATED_AT"] = "created_at";
  ContentCategorySelectColumn2["ID"] = "id";
  ContentCategorySelectColumn2["SLUG"] = "slug";
  ContentCategorySelectColumn2["TEASER"] = "teaser";
  ContentCategorySelectColumn2["TITLE"] = "title";
  ContentCategorySelectColumn2["UPDATED_AT"] = "updated_at";
  return ContentCategorySelectColumn2;
})({});
var ContentCategoryUpdateColumn = /* @__PURE__ */ (function(ContentCategoryUpdateColumn2) {
  ContentCategoryUpdateColumn2["CONTENT"] = "content";
  ContentCategoryUpdateColumn2["CREATED_AT"] = "created_at";
  ContentCategoryUpdateColumn2["ID"] = "id";
  ContentCategoryUpdateColumn2["SLUG"] = "slug";
  ContentCategoryUpdateColumn2["TEASER"] = "teaser";
  ContentCategoryUpdateColumn2["TITLE"] = "title";
  ContentCategoryUpdateColumn2["UPDATED_AT"] = "updated_at";
  return ContentCategoryUpdateColumn2;
})({});
var ContentPageConstraint = /* @__PURE__ */ (function(ContentPageConstraint2) {
  ContentPageConstraint2["CONTENT_PAGE_PKEY"] = "content_page_pkey";
  ContentPageConstraint2["CONTENT_PAGE_SLUG_UNIQUE"] = "content_page_slug_unique";
  return ContentPageConstraint2;
})({});
var ContentPageSelectColumn = /* @__PURE__ */ (function(ContentPageSelectColumn2) {
  ContentPageSelectColumn2["CONTENT"] = "content";
  ContentPageSelectColumn2["CREATED_AT"] = "created_at";
  ContentPageSelectColumn2["ID"] = "id";
  ContentPageSelectColumn2["PARENT_ID"] = "parent_id";
  ContentPageSelectColumn2["SLUG"] = "slug";
  ContentPageSelectColumn2["TEASER"] = "teaser";
  ContentPageSelectColumn2["TITLE"] = "title";
  ContentPageSelectColumn2["UPDATED_AT"] = "updated_at";
  return ContentPageSelectColumn2;
})({});
var ContentPageUpdateColumn = /* @__PURE__ */ (function(ContentPageUpdateColumn2) {
  ContentPageUpdateColumn2["CONTENT"] = "content";
  ContentPageUpdateColumn2["CREATED_AT"] = "created_at";
  ContentPageUpdateColumn2["ID"] = "id";
  ContentPageUpdateColumn2["PARENT_ID"] = "parent_id";
  ContentPageUpdateColumn2["SLUG"] = "slug";
  ContentPageUpdateColumn2["TEASER"] = "teaser";
  ContentPageUpdateColumn2["TITLE"] = "title";
  ContentPageUpdateColumn2["UPDATED_AT"] = "updated_at";
  return ContentPageUpdateColumn2;
})({});
var ContractConstraint = /* @__PURE__ */ (function(ContractConstraint2) {
  ContractConstraint2["CONTRACT_ENVELOPE_ID_KEY"] = "contract_envelope_id_key";
  ContractConstraint2["CONTRACT_PKEY"] = "contract_pkey";
  return ContractConstraint2;
})({});
var ContractSelectColumn = /* @__PURE__ */ (function(ContractSelectColumn2) {
  ContractSelectColumn2["BUDGET_ID"] = "budget_id";
  ContractSelectColumn2["CANCELATION_REASON"] = "cancelation_reason";
  ContractSelectColumn2["CREATED_AT"] = "created_at";
  ContractSelectColumn2["ENVELOPE_ID"] = "envelope_id";
  ContractSelectColumn2["FIXED_DATA"] = "fixed_data";
  ContractSelectColumn2["ID"] = "id";
  ContractSelectColumn2["ISSUE_DATE"] = "issue_date";
  ContractSelectColumn2["ISSUER_ADDRESS"] = "issuer_address";
  ContractSelectColumn2["ISSUER_ID"] = "issuer_id";
  ContractSelectColumn2["NAME"] = "name";
  ContractSelectColumn2["OFFER_VALIDITY_DATE"] = "offer_validity_date";
  ContractSelectColumn2["PAYMENTS"] = "payments";
  ContractSelectColumn2["PROJECT_ID"] = "project_id";
  ContractSelectColumn2["RECIPIENT_ADDRESS"] = "recipient_address";
  ContractSelectColumn2["RECIPIENT_EMAIL"] = "recipient_email";
  ContractSelectColumn2["RECIPIENT_ID"] = "recipient_id";
  ContractSelectColumn2["RECIPIENT_NAME"] = "recipient_name";
  ContractSelectColumn2["STATUS"] = "status";
  ContractSelectColumn2["UPDATED_AT"] = "updated_at";
  return ContractSelectColumn2;
})({});
var ContractUpdateColumn = /* @__PURE__ */ (function(ContractUpdateColumn2) {
  ContractUpdateColumn2["BUDGET_ID"] = "budget_id";
  ContractUpdateColumn2["CANCELATION_REASON"] = "cancelation_reason";
  ContractUpdateColumn2["CREATED_AT"] = "created_at";
  ContractUpdateColumn2["ENVELOPE_ID"] = "envelope_id";
  ContractUpdateColumn2["FIXED_DATA"] = "fixed_data";
  ContractUpdateColumn2["ID"] = "id";
  ContractUpdateColumn2["ISSUE_DATE"] = "issue_date";
  ContractUpdateColumn2["ISSUER_ADDRESS"] = "issuer_address";
  ContractUpdateColumn2["ISSUER_ID"] = "issuer_id";
  ContractUpdateColumn2["NAME"] = "name";
  ContractUpdateColumn2["OFFER_VALIDITY_DATE"] = "offer_validity_date";
  ContractUpdateColumn2["PAYMENTS"] = "payments";
  ContractUpdateColumn2["PROJECT_ID"] = "project_id";
  ContractUpdateColumn2["RECIPIENT_ADDRESS"] = "recipient_address";
  ContractUpdateColumn2["RECIPIENT_EMAIL"] = "recipient_email";
  ContractUpdateColumn2["RECIPIENT_ID"] = "recipient_id";
  ContractUpdateColumn2["RECIPIENT_NAME"] = "recipient_name";
  ContractUpdateColumn2["STATUS"] = "status";
  ContractUpdateColumn2["UPDATED_AT"] = "updated_at";
  return ContractUpdateColumn2;
})({});
var CountryConstraint = /* @__PURE__ */ (function(CountryConstraint2) {
  CountryConstraint2["COUNTRY_CODE_UNIQUE"] = "country_code_unique";
  CountryConstraint2["COUNTRY_NAME_UNIQUE"] = "country_name_unique";
  CountryConstraint2["COUNTRY_PKEY"] = "country_pkey";
  return CountryConstraint2;
})({});
var CountrySelectColumn = /* @__PURE__ */ (function(CountrySelectColumn2) {
  CountrySelectColumn2["CODE"] = "code";
  CountrySelectColumn2["CREATED_AT"] = "created_at";
  CountrySelectColumn2["CURRENCY_ID"] = "currency_id";
  CountrySelectColumn2["ID"] = "id";
  CountrySelectColumn2["NAME"] = "name";
  CountrySelectColumn2["STANDARD_TAX_RATE_ID"] = "standard_tax_rate_id";
  CountrySelectColumn2["TAX_FEDERATION_ID"] = "tax_federation_id";
  CountrySelectColumn2["UPDATED_AT"] = "updated_at";
  return CountrySelectColumn2;
})({});
var CountryUpdateColumn = /* @__PURE__ */ (function(CountryUpdateColumn2) {
  CountryUpdateColumn2["CODE"] = "code";
  CountryUpdateColumn2["CREATED_AT"] = "created_at";
  CountryUpdateColumn2["CURRENCY_ID"] = "currency_id";
  CountryUpdateColumn2["ID"] = "id";
  CountryUpdateColumn2["NAME"] = "name";
  CountryUpdateColumn2["STANDARD_TAX_RATE_ID"] = "standard_tax_rate_id";
  CountryUpdateColumn2["TAX_FEDERATION_ID"] = "tax_federation_id";
  CountryUpdateColumn2["UPDATED_AT"] = "updated_at";
  return CountryUpdateColumn2;
})({});
var CurrencyConstraint = /* @__PURE__ */ (function(CurrencyConstraint2) {
  CurrencyConstraint2["CURRENCY_CODE_UNIQUE"] = "currency_code_unique";
  CurrencyConstraint2["CURRENCY_NAME_UNIQUE"] = "currency_name_unique";
  CurrencyConstraint2["CURRENCY_PKEY"] = "currency_pkey";
  return CurrencyConstraint2;
})({});
var CurrencyRateConstraint = /* @__PURE__ */ (function(CurrencyRateConstraint2) {
  CurrencyRateConstraint2["CURRENCY_RATE_CURRENCY_ID_DATE_RATE_UNIQUE"] = "currency_rate_currency_id_date_rate_unique";
  CurrencyRateConstraint2["CURRENCY_RATE_PKEY"] = "currency_rate_pkey";
  return CurrencyRateConstraint2;
})({});
var CurrencyRateSelectColumn = /* @__PURE__ */ (function(CurrencyRateSelectColumn2) {
  CurrencyRateSelectColumn2["CREATED_AT"] = "created_at";
  CurrencyRateSelectColumn2["CURRENCY_ID"] = "currency_id";
  CurrencyRateSelectColumn2["DATE"] = "date";
  CurrencyRateSelectColumn2["ID"] = "id";
  CurrencyRateSelectColumn2["RATE"] = "rate";
  CurrencyRateSelectColumn2["UPDATED_AT"] = "updated_at";
  return CurrencyRateSelectColumn2;
})({});
var CurrencyRateUpdateColumn = /* @__PURE__ */ (function(CurrencyRateUpdateColumn2) {
  CurrencyRateUpdateColumn2["CREATED_AT"] = "created_at";
  CurrencyRateUpdateColumn2["CURRENCY_ID"] = "currency_id";
  CurrencyRateUpdateColumn2["DATE"] = "date";
  CurrencyRateUpdateColumn2["ID"] = "id";
  CurrencyRateUpdateColumn2["RATE"] = "rate";
  CurrencyRateUpdateColumn2["UPDATED_AT"] = "updated_at";
  return CurrencyRateUpdateColumn2;
})({});
var CurrencySelectColumn = /* @__PURE__ */ (function(CurrencySelectColumn2) {
  CurrencySelectColumn2["CODE"] = "code";
  CurrencySelectColumn2["CREATED_AT"] = "created_at";
  CurrencySelectColumn2["ID"] = "id";
  CurrencySelectColumn2["NAME"] = "name";
  CurrencySelectColumn2["UPDATED_AT"] = "updated_at";
  return CurrencySelectColumn2;
})({});
var CurrencyUpdateColumn = /* @__PURE__ */ (function(CurrencyUpdateColumn2) {
  CurrencyUpdateColumn2["CODE"] = "code";
  CurrencyUpdateColumn2["CREATED_AT"] = "created_at";
  CurrencyUpdateColumn2["ID"] = "id";
  CurrencyUpdateColumn2["NAME"] = "name";
  CurrencyUpdateColumn2["UPDATED_AT"] = "updated_at";
  return CurrencyUpdateColumn2;
})({});
var CursorOrdering = /* @__PURE__ */ (function(CursorOrdering2) {
  CursorOrdering2["ASC"] = "ASC";
  CursorOrdering2["DESC"] = "DESC";
  return CursorOrdering2;
})({});
var InvoiceConstraint = /* @__PURE__ */ (function(InvoiceConstraint2) {
  InvoiceConstraint2["INVOICE_INVOICE_NUMBER_UNIQUE"] = "invoice_invoice_number_unique";
  InvoiceConstraint2["INVOICE_PKEY"] = "invoice_pkey";
  InvoiceConstraint2["INVOICE_REFERENCE_UNIQUE"] = "invoice_reference_unique";
  return InvoiceConstraint2;
})({});
var InvoiceDepositConstraint = /* @__PURE__ */ (function(InvoiceDepositConstraint2) {
  InvoiceDepositConstraint2["INVOICE_DEPOSIT_PKEY"] = "invoice_deposit_pkey";
  return InvoiceDepositConstraint2;
})({});
var InvoiceDepositSelectColumn = /* @__PURE__ */ (function(InvoiceDepositSelectColumn2) {
  InvoiceDepositSelectColumn2["CREATED_AT"] = "created_at";
  InvoiceDepositSelectColumn2["DEPOSIT_INVOICE_ID"] = "deposit_invoice_id";
  InvoiceDepositSelectColumn2["ID"] = "id";
  InvoiceDepositSelectColumn2["INVOICE_ID"] = "invoice_id";
  InvoiceDepositSelectColumn2["UPDATED_AT"] = "updated_at";
  return InvoiceDepositSelectColumn2;
})({});
var InvoiceDepositUpdateColumn = /* @__PURE__ */ (function(InvoiceDepositUpdateColumn2) {
  InvoiceDepositUpdateColumn2["CREATED_AT"] = "created_at";
  InvoiceDepositUpdateColumn2["DEPOSIT_INVOICE_ID"] = "deposit_invoice_id";
  InvoiceDepositUpdateColumn2["ID"] = "id";
  InvoiceDepositUpdateColumn2["INVOICE_ID"] = "invoice_id";
  InvoiceDepositUpdateColumn2["UPDATED_AT"] = "updated_at";
  return InvoiceDepositUpdateColumn2;
})({});
var InvoiceSelectColumn = /* @__PURE__ */ (function(InvoiceSelectColumn2) {
  InvoiceSelectColumn2["BANK_ACCOUNT_ID"] = "bank_account_id";
  InvoiceSelectColumn2["BILLING_ADDRESS"] = "billing_address";
  InvoiceSelectColumn2["BOOKED_AT"] = "booked_at";
  InvoiceSelectColumn2["BUDGET_ID"] = "budget_id";
  InvoiceSelectColumn2["CANCELATION_ID"] = "cancelation_id";
  InvoiceSelectColumn2["CANCELATION_REASON"] = "cancelation_reason";
  InvoiceSelectColumn2["CREATED_AT"] = "created_at";
  InvoiceSelectColumn2["CURRENCY_ID"] = "currency_id";
  InvoiceSelectColumn2["DUE_DATE"] = "due_date";
  InvoiceSelectColumn2["DUE_IN"] = "due_in";
  InvoiceSelectColumn2["EXTERNAL"] = "external";
  InvoiceSelectColumn2["FEES"] = "fees";
  InvoiceSelectColumn2["FINAL_INVOICE_ID"] = "final_invoice_id";
  InvoiceSelectColumn2["FIXED_DATA"] = "fixed_data";
  InvoiceSelectColumn2["ID"] = "id";
  InvoiceSelectColumn2["INVOICE_NUMBER"] = "invoice_number";
  InvoiceSelectColumn2["ISSUE_DATE"] = "issue_date";
  InvoiceSelectColumn2["ISSUER_ADDRESS"] = "issuer_address";
  InvoiceSelectColumn2["ISSUER_ID"] = "issuer_id";
  InvoiceSelectColumn2["ISSUER_VAT_NUMBER_ID"] = "issuer_vat_number_id";
  InvoiceSelectColumn2["PAYMENT_AMOUNT"] = "payment_amount";
  InvoiceSelectColumn2["PAYMENT_DATE"] = "payment_date";
  InvoiceSelectColumn2["PERIOD_END"] = "period_end";
  InvoiceSelectColumn2["PERIOD_START"] = "period_start";
  InvoiceSelectColumn2["POSITIONS"] = "positions";
  InvoiceSelectColumn2["PROJECT_ID"] = "project_id";
  InvoiceSelectColumn2["PURCHASE_NUMBER"] = "purchase_number";
  InvoiceSelectColumn2["RECIPIENT_ADDRESS"] = "recipient_address";
  InvoiceSelectColumn2["RECIPIENT_ID"] = "recipient_id";
  InvoiceSelectColumn2["REFERENCE"] = "reference";
  InvoiceSelectColumn2["REQUEST_DEPOSITS"] = "request_deposits";
  InvoiceSelectColumn2["REQUESTED_BY_ID"] = "requested_by_id";
  InvoiceSelectColumn2["SEND_HISTORY"] = "send_history";
  InvoiceSelectColumn2["STATUS"] = "status";
  InvoiceSelectColumn2["TAX_ADDRESS"] = "tax_address";
  InvoiceSelectColumn2["TOMS_TAX_AMOUNT"] = "toms_tax_amount";
  InvoiceSelectColumn2["TOTAL_DISCOUNT"] = "total_discount";
  InvoiceSelectColumn2["TOTAL_FEES"] = "total_fees";
  InvoiceSelectColumn2["TOTAL_GROSS"] = "total_gross";
  InvoiceSelectColumn2["TOTAL_NET"] = "total_net";
  InvoiceSelectColumn2["TOTAL_TAX"] = "total_tax";
  InvoiceSelectColumn2["TYPE"] = "type";
  InvoiceSelectColumn2["UPDATED_AT"] = "updated_at";
  InvoiceSelectColumn2["VAT_ID"] = "vat_id";
  return InvoiceSelectColumn2;
})({});
var InvoiceSelectColumnInvoiceAggregateBoolExpBoolAndArgumentsColumns = /* @__PURE__ */ (function(InvoiceSelectColumnInvoiceAggregateBoolExpBoolAndArgumentsColumns2) {
  InvoiceSelectColumnInvoiceAggregateBoolExpBoolAndArgumentsColumns2["EXTERNAL"] = "external";
  return InvoiceSelectColumnInvoiceAggregateBoolExpBoolAndArgumentsColumns2;
})({});
var InvoiceSelectColumnInvoiceAggregateBoolExpBoolOrArgumentsColumns = /* @__PURE__ */ (function(InvoiceSelectColumnInvoiceAggregateBoolExpBoolOrArgumentsColumns2) {
  InvoiceSelectColumnInvoiceAggregateBoolExpBoolOrArgumentsColumns2["EXTERNAL"] = "external";
  return InvoiceSelectColumnInvoiceAggregateBoolExpBoolOrArgumentsColumns2;
})({});
var InvoiceUpdateColumn = /* @__PURE__ */ (function(InvoiceUpdateColumn2) {
  InvoiceUpdateColumn2["BANK_ACCOUNT_ID"] = "bank_account_id";
  InvoiceUpdateColumn2["BILLING_ADDRESS"] = "billing_address";
  InvoiceUpdateColumn2["BOOKED_AT"] = "booked_at";
  InvoiceUpdateColumn2["BUDGET_ID"] = "budget_id";
  InvoiceUpdateColumn2["CANCELATION_ID"] = "cancelation_id";
  InvoiceUpdateColumn2["CANCELATION_REASON"] = "cancelation_reason";
  InvoiceUpdateColumn2["CREATED_AT"] = "created_at";
  InvoiceUpdateColumn2["CURRENCY_ID"] = "currency_id";
  InvoiceUpdateColumn2["DUE_DATE"] = "due_date";
  InvoiceUpdateColumn2["DUE_IN"] = "due_in";
  InvoiceUpdateColumn2["EXTERNAL"] = "external";
  InvoiceUpdateColumn2["FEES"] = "fees";
  InvoiceUpdateColumn2["FINAL_INVOICE_ID"] = "final_invoice_id";
  InvoiceUpdateColumn2["FIXED_DATA"] = "fixed_data";
  InvoiceUpdateColumn2["ID"] = "id";
  InvoiceUpdateColumn2["INVOICE_NUMBER"] = "invoice_number";
  InvoiceUpdateColumn2["ISSUE_DATE"] = "issue_date";
  InvoiceUpdateColumn2["ISSUER_ADDRESS"] = "issuer_address";
  InvoiceUpdateColumn2["ISSUER_ID"] = "issuer_id";
  InvoiceUpdateColumn2["ISSUER_VAT_NUMBER_ID"] = "issuer_vat_number_id";
  InvoiceUpdateColumn2["PAYMENT_AMOUNT"] = "payment_amount";
  InvoiceUpdateColumn2["PAYMENT_DATE"] = "payment_date";
  InvoiceUpdateColumn2["PERIOD_END"] = "period_end";
  InvoiceUpdateColumn2["PERIOD_START"] = "period_start";
  InvoiceUpdateColumn2["POSITIONS"] = "positions";
  InvoiceUpdateColumn2["PROJECT_ID"] = "project_id";
  InvoiceUpdateColumn2["PURCHASE_NUMBER"] = "purchase_number";
  InvoiceUpdateColumn2["RECIPIENT_ADDRESS"] = "recipient_address";
  InvoiceUpdateColumn2["RECIPIENT_ID"] = "recipient_id";
  InvoiceUpdateColumn2["REFERENCE"] = "reference";
  InvoiceUpdateColumn2["REQUEST_DEPOSITS"] = "request_deposits";
  InvoiceUpdateColumn2["REQUESTED_BY_ID"] = "requested_by_id";
  InvoiceUpdateColumn2["SEND_HISTORY"] = "send_history";
  InvoiceUpdateColumn2["STATUS"] = "status";
  InvoiceUpdateColumn2["TAX_ADDRESS"] = "tax_address";
  InvoiceUpdateColumn2["TOMS_TAX_AMOUNT"] = "toms_tax_amount";
  InvoiceUpdateColumn2["TOTAL_DISCOUNT"] = "total_discount";
  InvoiceUpdateColumn2["TOTAL_FEES"] = "total_fees";
  InvoiceUpdateColumn2["TOTAL_GROSS"] = "total_gross";
  InvoiceUpdateColumn2["TOTAL_NET"] = "total_net";
  InvoiceUpdateColumn2["TOTAL_TAX"] = "total_tax";
  InvoiceUpdateColumn2["TYPE"] = "type";
  InvoiceUpdateColumn2["UPDATED_AT"] = "updated_at";
  InvoiceUpdateColumn2["VAT_ID"] = "vat_id";
  return InvoiceUpdateColumn2;
})({});
var OfficeConstraint = /* @__PURE__ */ (function(OfficeConstraint2) {
  OfficeConstraint2["OFFICE_PKEY"] = "office_pkey";
  return OfficeConstraint2;
})({});
var OfficeManagerConstraint = /* @__PURE__ */ (function(OfficeManagerConstraint2) {
  OfficeManagerConstraint2["OFFICE_MANAGER_PKEY"] = "office_manager_pkey";
  return OfficeManagerConstraint2;
})({});
var OfficeManagerSelectColumn = /* @__PURE__ */ (function(OfficeManagerSelectColumn2) {
  OfficeManagerSelectColumn2["CREATED_AT"] = "created_at";
  OfficeManagerSelectColumn2["ID"] = "id";
  OfficeManagerSelectColumn2["OFFICE_ID"] = "office_id";
  OfficeManagerSelectColumn2["UPDATED_AT"] = "updated_at";
  OfficeManagerSelectColumn2["USER_ID"] = "user_id";
  return OfficeManagerSelectColumn2;
})({});
var OfficeManagerUpdateColumn = /* @__PURE__ */ (function(OfficeManagerUpdateColumn2) {
  OfficeManagerUpdateColumn2["CREATED_AT"] = "created_at";
  OfficeManagerUpdateColumn2["ID"] = "id";
  OfficeManagerUpdateColumn2["OFFICE_ID"] = "office_id";
  OfficeManagerUpdateColumn2["UPDATED_AT"] = "updated_at";
  OfficeManagerUpdateColumn2["USER_ID"] = "user_id";
  return OfficeManagerUpdateColumn2;
})({});
var OfficeSelectColumn = /* @__PURE__ */ (function(OfficeSelectColumn2) {
  OfficeSelectColumn2["ADDRESS_ID"] = "address_id";
  OfficeSelectColumn2["CODE"] = "code";
  OfficeSelectColumn2["COMPANY_ID"] = "company_id";
  OfficeSelectColumn2["COUNTRY_ID"] = "country_id";
  OfficeSelectColumn2["CREATED_AT"] = "created_at";
  OfficeSelectColumn2["CURRENCY_ID"] = "currency_id";
  OfficeSelectColumn2["ID"] = "id";
  OfficeSelectColumn2["INVOICE_ADDRESS"] = "invoice_address";
  OfficeSelectColumn2["INVOICE_FOOTER_LEGAL"] = "invoice_footer_legal";
  OfficeSelectColumn2["INVOICE_FOOTER_TAX"] = "invoice_footer_tax";
  OfficeSelectColumn2["NAME"] = "name";
  OfficeSelectColumn2["UPDATED_AT"] = "updated_at";
  return OfficeSelectColumn2;
})({});
var OfficeUpdateColumn = /* @__PURE__ */ (function(OfficeUpdateColumn2) {
  OfficeUpdateColumn2["ADDRESS_ID"] = "address_id";
  OfficeUpdateColumn2["CODE"] = "code";
  OfficeUpdateColumn2["COMPANY_ID"] = "company_id";
  OfficeUpdateColumn2["COUNTRY_ID"] = "country_id";
  OfficeUpdateColumn2["CREATED_AT"] = "created_at";
  OfficeUpdateColumn2["CURRENCY_ID"] = "currency_id";
  OfficeUpdateColumn2["ID"] = "id";
  OfficeUpdateColumn2["INVOICE_ADDRESS"] = "invoice_address";
  OfficeUpdateColumn2["INVOICE_FOOTER_LEGAL"] = "invoice_footer_legal";
  OfficeUpdateColumn2["INVOICE_FOOTER_TAX"] = "invoice_footer_tax";
  OfficeUpdateColumn2["NAME"] = "name";
  OfficeUpdateColumn2["UPDATED_AT"] = "updated_at";
  return OfficeUpdateColumn2;
})({});
var OrderBy = /* @__PURE__ */ (function(OrderBy2) {
  OrderBy2["ASC"] = "asc";
  OrderBy2["ASC_NULLS_FIRST"] = "asc_nulls_first";
  OrderBy2["ASC_NULLS_LAST"] = "asc_nulls_last";
  OrderBy2["DESC"] = "desc";
  OrderBy2["DESC_NULLS_FIRST"] = "desc_nulls_first";
  OrderBy2["DESC_NULLS_LAST"] = "desc_nulls_last";
  return OrderBy2;
})({});
var PresetConstraint = /* @__PURE__ */ (function(PresetConstraint2) {
  PresetConstraint2["PRESET_NAME_UNIQUE"] = "preset_name_unique";
  PresetConstraint2["PRESET_PKEY"] = "preset_pkey";
  PresetConstraint2["PRESET_TYPE_UNIQUE"] = "preset_type_unique";
  return PresetConstraint2;
})({});
var PresetSelectColumn = /* @__PURE__ */ (function(PresetSelectColumn2) {
  PresetSelectColumn2["CREATED_AT"] = "created_at";
  PresetSelectColumn2["ID"] = "id";
  PresetSelectColumn2["NAME"] = "name";
  PresetSelectColumn2["SCHEMA"] = "schema";
  PresetSelectColumn2["TYPE"] = "type";
  PresetSelectColumn2["UPDATED_AT"] = "updated_at";
  PresetSelectColumn2["VALUE"] = "value";
  return PresetSelectColumn2;
})({});
var PresetUpdateColumn = /* @__PURE__ */ (function(PresetUpdateColumn2) {
  PresetUpdateColumn2["CREATED_AT"] = "created_at";
  PresetUpdateColumn2["ID"] = "id";
  PresetUpdateColumn2["NAME"] = "name";
  PresetUpdateColumn2["SCHEMA"] = "schema";
  PresetUpdateColumn2["TYPE"] = "type";
  PresetUpdateColumn2["UPDATED_AT"] = "updated_at";
  PresetUpdateColumn2["VALUE"] = "value";
  return PresetUpdateColumn2;
})({});
var ProjectConstraint = /* @__PURE__ */ (function(ProjectConstraint2) {
  ProjectConstraint2["PROJECT_PKEY"] = "project_pkey";
  ProjectConstraint2["PROJECT_REFERENCE_UNIQUE"] = "project_reference_unique";
  return ProjectConstraint2;
})({});
var ProjectGroupConstraint = /* @__PURE__ */ (function(ProjectGroupConstraint2) {
  ProjectGroupConstraint2["PROJECT_GROUP_PKEY"] = "project_group_pkey";
  return ProjectGroupConstraint2;
})({});
var ProjectGroupManagerConstraint = /* @__PURE__ */ (function(ProjectGroupManagerConstraint2) {
  ProjectGroupManagerConstraint2["PROJECT_GROUP_MANAGER_PKEY"] = "project_group_manager_pkey";
  return ProjectGroupManagerConstraint2;
})({});
var ProjectGroupManagerSelectColumn = /* @__PURE__ */ (function(ProjectGroupManagerSelectColumn2) {
  ProjectGroupManagerSelectColumn2["CREATED_AT"] = "created_at";
  ProjectGroupManagerSelectColumn2["GROUP_ID"] = "group_id";
  ProjectGroupManagerSelectColumn2["ID"] = "id";
  ProjectGroupManagerSelectColumn2["UPDATED_AT"] = "updated_at";
  ProjectGroupManagerSelectColumn2["USER_ID"] = "user_id";
  return ProjectGroupManagerSelectColumn2;
})({});
var ProjectGroupManagerUpdateColumn = /* @__PURE__ */ (function(ProjectGroupManagerUpdateColumn2) {
  ProjectGroupManagerUpdateColumn2["CREATED_AT"] = "created_at";
  ProjectGroupManagerUpdateColumn2["GROUP_ID"] = "group_id";
  ProjectGroupManagerUpdateColumn2["ID"] = "id";
  ProjectGroupManagerUpdateColumn2["UPDATED_AT"] = "updated_at";
  ProjectGroupManagerUpdateColumn2["USER_ID"] = "user_id";
  return ProjectGroupManagerUpdateColumn2;
})({});
var ProjectGroupSelectColumn = /* @__PURE__ */ (function(ProjectGroupSelectColumn2) {
  ProjectGroupSelectColumn2["CREATED_AT"] = "created_at";
  ProjectGroupSelectColumn2["DESCRIPTION"] = "description";
  ProjectGroupSelectColumn2["ID"] = "id";
  ProjectGroupSelectColumn2["INVOICE_USER_CONFIRMABLE"] = "invoice_user_confirmable";
  ProjectGroupSelectColumn2["NAME"] = "name";
  ProjectGroupSelectColumn2["UPDATED_AT"] = "updated_at";
  return ProjectGroupSelectColumn2;
})({});
var ProjectGroupUpdateColumn = /* @__PURE__ */ (function(ProjectGroupUpdateColumn2) {
  ProjectGroupUpdateColumn2["CREATED_AT"] = "created_at";
  ProjectGroupUpdateColumn2["DESCRIPTION"] = "description";
  ProjectGroupUpdateColumn2["ID"] = "id";
  ProjectGroupUpdateColumn2["INVOICE_USER_CONFIRMABLE"] = "invoice_user_confirmable";
  ProjectGroupUpdateColumn2["NAME"] = "name";
  ProjectGroupUpdateColumn2["UPDATED_AT"] = "updated_at";
  return ProjectGroupUpdateColumn2;
})({});
var ProjectManagerConstraint = /* @__PURE__ */ (function(ProjectManagerConstraint2) {
  ProjectManagerConstraint2["PROJECT_MANAGER_PKEY"] = "project_manager_pkey";
  return ProjectManagerConstraint2;
})({});
var ProjectManagerSelectColumn = /* @__PURE__ */ (function(ProjectManagerSelectColumn2) {
  ProjectManagerSelectColumn2["CREATED_AT"] = "created_at";
  ProjectManagerSelectColumn2["ID"] = "id";
  ProjectManagerSelectColumn2["PROJECT_ID"] = "project_id";
  ProjectManagerSelectColumn2["UPDATED_AT"] = "updated_at";
  ProjectManagerSelectColumn2["USER_ID"] = "user_id";
  return ProjectManagerSelectColumn2;
})({});
var ProjectManagerUpdateColumn = /* @__PURE__ */ (function(ProjectManagerUpdateColumn2) {
  ProjectManagerUpdateColumn2["CREATED_AT"] = "created_at";
  ProjectManagerUpdateColumn2["ID"] = "id";
  ProjectManagerUpdateColumn2["PROJECT_ID"] = "project_id";
  ProjectManagerUpdateColumn2["UPDATED_AT"] = "updated_at";
  ProjectManagerUpdateColumn2["USER_ID"] = "user_id";
  return ProjectManagerUpdateColumn2;
})({});
var ProjectSelectColumn = /* @__PURE__ */ (function(ProjectSelectColumn2) {
  ProjectSelectColumn2["AGENCY_ID"] = "agency_id";
  ProjectSelectColumn2["BANK_ACCOUNT_ID"] = "bank_account_id";
  ProjectSelectColumn2["BROKER_ID"] = "broker_id";
  ProjectSelectColumn2["BUSINESS_AREA_CATEGORY_ID"] = "business_area_category_id";
  ProjectSelectColumn2["BUSINESS_AREA_ID"] = "business_area_id";
  ProjectSelectColumn2["CANCELATION_REASON"] = "cancelation_reason";
  ProjectSelectColumn2["CITY"] = "city";
  ProjectSelectColumn2["CLIENT_ID"] = "client_id";
  ProjectSelectColumn2["COMMENT"] = "comment";
  ProjectSelectColumn2["COUNTRY_ID"] = "country_id";
  ProjectSelectColumn2["CREATED_AT"] = "created_at";
  ProjectSelectColumn2["CURRENCY_ID"] = "currency_id";
  ProjectSelectColumn2["END_DATE"] = "end_date";
  ProjectSelectColumn2["ESTIMATED_COSTS"] = "estimated_costs";
  ProjectSelectColumn2["ESTIMATED_TURNOVER"] = "estimated_turnover";
  ProjectSelectColumn2["GROUP_ID"] = "group_id";
  ProjectSelectColumn2["ID"] = "id";
  ProjectSelectColumn2["ISSUER_ADDRESS"] = "issuer_address";
  ProjectSelectColumn2["MANAGER_ID"] = "manager_id";
  ProjectSelectColumn2["NAME"] = "name";
  ProjectSelectColumn2["OFFICE_ID"] = "office_id";
  ProjectSelectColumn2["PARTICIPANT_COUNT"] = "participant_count";
  ProjectSelectColumn2["REFERENCE"] = "reference";
  ProjectSelectColumn2["SEND_INVOICE_TEXT"] = "send_invoice_text";
  ProjectSelectColumn2["START_DATE"] = "start_date";
  ProjectSelectColumn2["STATUS"] = "status";
  ProjectSelectColumn2["UPDATED_AT"] = "updated_at";
  ProjectSelectColumn2["VAT_NUMBER_ID"] = "vat_number_id";
  return ProjectSelectColumn2;
})({});
var ProjectUpdateColumn = /* @__PURE__ */ (function(ProjectUpdateColumn2) {
  ProjectUpdateColumn2["AGENCY_ID"] = "agency_id";
  ProjectUpdateColumn2["BANK_ACCOUNT_ID"] = "bank_account_id";
  ProjectUpdateColumn2["BROKER_ID"] = "broker_id";
  ProjectUpdateColumn2["BUSINESS_AREA_CATEGORY_ID"] = "business_area_category_id";
  ProjectUpdateColumn2["BUSINESS_AREA_ID"] = "business_area_id";
  ProjectUpdateColumn2["CANCELATION_REASON"] = "cancelation_reason";
  ProjectUpdateColumn2["CITY"] = "city";
  ProjectUpdateColumn2["CLIENT_ID"] = "client_id";
  ProjectUpdateColumn2["COMMENT"] = "comment";
  ProjectUpdateColumn2["COUNTRY_ID"] = "country_id";
  ProjectUpdateColumn2["CREATED_AT"] = "created_at";
  ProjectUpdateColumn2["CURRENCY_ID"] = "currency_id";
  ProjectUpdateColumn2["END_DATE"] = "end_date";
  ProjectUpdateColumn2["ESTIMATED_COSTS"] = "estimated_costs";
  ProjectUpdateColumn2["ESTIMATED_TURNOVER"] = "estimated_turnover";
  ProjectUpdateColumn2["GROUP_ID"] = "group_id";
  ProjectUpdateColumn2["ID"] = "id";
  ProjectUpdateColumn2["ISSUER_ADDRESS"] = "issuer_address";
  ProjectUpdateColumn2["MANAGER_ID"] = "manager_id";
  ProjectUpdateColumn2["NAME"] = "name";
  ProjectUpdateColumn2["OFFICE_ID"] = "office_id";
  ProjectUpdateColumn2["PARTICIPANT_COUNT"] = "participant_count";
  ProjectUpdateColumn2["REFERENCE"] = "reference";
  ProjectUpdateColumn2["SEND_INVOICE_TEXT"] = "send_invoice_text";
  ProjectUpdateColumn2["START_DATE"] = "start_date";
  ProjectUpdateColumn2["STATUS"] = "status";
  ProjectUpdateColumn2["UPDATED_AT"] = "updated_at";
  ProjectUpdateColumn2["VAT_NUMBER_ID"] = "vat_number_id";
  return ProjectUpdateColumn2;
})({});
var ServiceConstraint = /* @__PURE__ */ (function(ServiceConstraint2) {
  ServiceConstraint2["SERVICE_PKEY"] = "service_pkey";
  return ServiceConstraint2;
})({});
var ServiceGroupConstraint = /* @__PURE__ */ (function(ServiceGroupConstraint2) {
  ServiceGroupConstraint2["SERVICE_GROUP_PKEY"] = "service_group_pkey";
  return ServiceGroupConstraint2;
})({});
var ServiceGroupSelectColumn = /* @__PURE__ */ (function(ServiceGroupSelectColumn2) {
  ServiceGroupSelectColumn2["BUDGET_ID"] = "budget_id";
  ServiceGroupSelectColumn2["CREATED_AT"] = "created_at";
  ServiceGroupSelectColumn2["DESCRIPTION"] = "description";
  ServiceGroupSelectColumn2["ID"] = "id";
  ServiceGroupSelectColumn2["INTERNAL"] = "internal";
  ServiceGroupSelectColumn2["INTERNAL_REMARKS"] = "internal_remarks";
  ServiceGroupSelectColumn2["LABELS"] = "labels";
  ServiceGroupSelectColumn2["NAME"] = "name";
  ServiceGroupSelectColumn2["SORT_INDEX"] = "sort_index";
  ServiceGroupSelectColumn2["UPDATED_AT"] = "updated_at";
  return ServiceGroupSelectColumn2;
})({});
var ServiceGroupSelectColumnServiceGroupAggregateBoolExpBoolAndArgumentsColumns = /* @__PURE__ */ (function(ServiceGroupSelectColumnServiceGroupAggregateBoolExpBoolAndArgumentsColumns2) {
  ServiceGroupSelectColumnServiceGroupAggregateBoolExpBoolAndArgumentsColumns2["INTERNAL"] = "internal";
  return ServiceGroupSelectColumnServiceGroupAggregateBoolExpBoolAndArgumentsColumns2;
})({});
var ServiceGroupSelectColumnServiceGroupAggregateBoolExpBoolOrArgumentsColumns = /* @__PURE__ */ (function(ServiceGroupSelectColumnServiceGroupAggregateBoolExpBoolOrArgumentsColumns2) {
  ServiceGroupSelectColumnServiceGroupAggregateBoolExpBoolOrArgumentsColumns2["INTERNAL"] = "internal";
  return ServiceGroupSelectColumnServiceGroupAggregateBoolExpBoolOrArgumentsColumns2;
})({});
var ServiceGroupUpdateColumn = /* @__PURE__ */ (function(ServiceGroupUpdateColumn2) {
  ServiceGroupUpdateColumn2["BUDGET_ID"] = "budget_id";
  ServiceGroupUpdateColumn2["CREATED_AT"] = "created_at";
  ServiceGroupUpdateColumn2["DESCRIPTION"] = "description";
  ServiceGroupUpdateColumn2["ID"] = "id";
  ServiceGroupUpdateColumn2["INTERNAL"] = "internal";
  ServiceGroupUpdateColumn2["INTERNAL_REMARKS"] = "internal_remarks";
  ServiceGroupUpdateColumn2["LABELS"] = "labels";
  ServiceGroupUpdateColumn2["NAME"] = "name";
  ServiceGroupUpdateColumn2["SORT_INDEX"] = "sort_index";
  ServiceGroupUpdateColumn2["UPDATED_AT"] = "updated_at";
  return ServiceGroupUpdateColumn2;
})({});
var ServiceInvoiceConstraint = /* @__PURE__ */ (function(ServiceInvoiceConstraint2) {
  ServiceInvoiceConstraint2["SERVICE_INVOICE_PKEY"] = "service_invoice_pkey";
  return ServiceInvoiceConstraint2;
})({});
var ServiceInvoiceSelectColumn = /* @__PURE__ */ (function(ServiceInvoiceSelectColumn2) {
  ServiceInvoiceSelectColumn2["AMOUNT"] = "amount";
  ServiceInvoiceSelectColumn2["CREATED_AT"] = "created_at";
  ServiceInvoiceSelectColumn2["ID"] = "id";
  ServiceInvoiceSelectColumn2["INVOICE_ID"] = "invoice_id";
  ServiceInvoiceSelectColumn2["SERVICE_ID"] = "service_id";
  ServiceInvoiceSelectColumn2["UPDATED_AT"] = "updated_at";
  return ServiceInvoiceSelectColumn2;
})({});
var ServiceInvoiceUpdateColumn = /* @__PURE__ */ (function(ServiceInvoiceUpdateColumn2) {
  ServiceInvoiceUpdateColumn2["AMOUNT"] = "amount";
  ServiceInvoiceUpdateColumn2["CREATED_AT"] = "created_at";
  ServiceInvoiceUpdateColumn2["ID"] = "id";
  ServiceInvoiceUpdateColumn2["INVOICE_ID"] = "invoice_id";
  ServiceInvoiceUpdateColumn2["SERVICE_ID"] = "service_id";
  ServiceInvoiceUpdateColumn2["UPDATED_AT"] = "updated_at";
  return ServiceInvoiceUpdateColumn2;
})({});
var ServiceSelectColumn = /* @__PURE__ */ (function(ServiceSelectColumn2) {
  ServiceSelectColumn2["BUDGET_ID"] = "budget_id";
  ServiceSelectColumn2["BUY_FACTOR"] = "buy_factor";
  ServiceSelectColumn2["BUY_PRICE"] = "buy_price";
  ServiceSelectColumn2["BUY_PRICE_DISPLAY_GROSS"] = "buy_price_display_gross";
  ServiceSelectColumn2["BUY_QUANTITY"] = "buy_quantity";
  ServiceSelectColumn2["BUY_TAX_RATE"] = "buy_tax_rate";
  ServiceSelectColumn2["BUY_TAX_TYPE"] = "buy_tax_type";
  ServiceSelectColumn2["CATEGORY"] = "category";
  ServiceSelectColumn2["COMMISSION_RATE"] = "commission_rate";
  ServiceSelectColumn2["COMMISSION_TYPE"] = "commission_type";
  ServiceSelectColumn2["CREATED_AT"] = "created_at";
  ServiceSelectColumn2["DESCRIPTION"] = "description";
  ServiceSelectColumn2["END_DATE"] = "end_date";
  ServiceSelectColumn2["END_TIME"] = "end_time";
  ServiceSelectColumn2["GROUP_ID"] = "group_id";
  ServiceSelectColumn2["ID"] = "id";
  ServiceSelectColumn2["INCOMING_INVOICE_RECEIVED_AT"] = "incoming_invoice_received_at";
  ServiceSelectColumn2["INCOMING_INVOICE_RECEIVED_BY"] = "incoming_invoice_received_by";
  ServiceSelectColumn2["INTERNAL_REMARKS"] = "internal_remarks";
  ServiceSelectColumn2["INVOICE_ID"] = "invoice_id";
  ServiceSelectColumn2["LABELS"] = "labels";
  ServiceSelectColumn2["NAME"] = "name";
  ServiceSelectColumn2["PROVISION_INVOICE_ID"] = "provision_invoice_id";
  ServiceSelectColumn2["PROVISION_RATE"] = "provision_rate";
  ServiceSelectColumn2["PROVISION_TYPE"] = "provision_type";
  ServiceSelectColumn2["REMOTE_ID"] = "remote_id";
  ServiceSelectColumn2["SELL_FACTOR"] = "sell_factor";
  ServiceSelectColumn2["SELL_PRICE"] = "sell_price";
  ServiceSelectColumn2["SELL_PRICE_DISPLAY_GROSS"] = "sell_price_display_gross";
  ServiceSelectColumn2["SELL_QUANTITY"] = "sell_quantity";
  ServiceSelectColumn2["SELL_TAX_RATE"] = "sell_tax_rate";
  ServiceSelectColumn2["SELL_TAX_TYPE"] = "sell_tax_type";
  ServiceSelectColumn2["SORT_INDEX"] = "sort_index";
  ServiceSelectColumn2["START_DATE"] = "start_date";
  ServiceSelectColumn2["START_TIME"] = "start_time";
  ServiceSelectColumn2["SUPPLIER_ID"] = "supplier_id";
  ServiceSelectColumn2["UPDATED_AT"] = "updated_at";
  return ServiceSelectColumn2;
})({});
var ServiceSelectColumnServiceAggregateBoolExpBoolAndArgumentsColumns = /* @__PURE__ */ (function(ServiceSelectColumnServiceAggregateBoolExpBoolAndArgumentsColumns2) {
  ServiceSelectColumnServiceAggregateBoolExpBoolAndArgumentsColumns2["BUY_PRICE_DISPLAY_GROSS"] = "buy_price_display_gross";
  ServiceSelectColumnServiceAggregateBoolExpBoolAndArgumentsColumns2["SELL_PRICE_DISPLAY_GROSS"] = "sell_price_display_gross";
  return ServiceSelectColumnServiceAggregateBoolExpBoolAndArgumentsColumns2;
})({});
var ServiceSelectColumnServiceAggregateBoolExpBoolOrArgumentsColumns = /* @__PURE__ */ (function(ServiceSelectColumnServiceAggregateBoolExpBoolOrArgumentsColumns2) {
  ServiceSelectColumnServiceAggregateBoolExpBoolOrArgumentsColumns2["BUY_PRICE_DISPLAY_GROSS"] = "buy_price_display_gross";
  ServiceSelectColumnServiceAggregateBoolExpBoolOrArgumentsColumns2["SELL_PRICE_DISPLAY_GROSS"] = "sell_price_display_gross";
  return ServiceSelectColumnServiceAggregateBoolExpBoolOrArgumentsColumns2;
})({});
var ServiceUpdateColumn = /* @__PURE__ */ (function(ServiceUpdateColumn2) {
  ServiceUpdateColumn2["BUDGET_ID"] = "budget_id";
  ServiceUpdateColumn2["BUY_FACTOR"] = "buy_factor";
  ServiceUpdateColumn2["BUY_PRICE"] = "buy_price";
  ServiceUpdateColumn2["BUY_PRICE_DISPLAY_GROSS"] = "buy_price_display_gross";
  ServiceUpdateColumn2["BUY_QUANTITY"] = "buy_quantity";
  ServiceUpdateColumn2["BUY_TAX_RATE"] = "buy_tax_rate";
  ServiceUpdateColumn2["BUY_TAX_TYPE"] = "buy_tax_type";
  ServiceUpdateColumn2["CATEGORY"] = "category";
  ServiceUpdateColumn2["COMMISSION_RATE"] = "commission_rate";
  ServiceUpdateColumn2["COMMISSION_TYPE"] = "commission_type";
  ServiceUpdateColumn2["CREATED_AT"] = "created_at";
  ServiceUpdateColumn2["DESCRIPTION"] = "description";
  ServiceUpdateColumn2["END_DATE"] = "end_date";
  ServiceUpdateColumn2["END_TIME"] = "end_time";
  ServiceUpdateColumn2["GROUP_ID"] = "group_id";
  ServiceUpdateColumn2["ID"] = "id";
  ServiceUpdateColumn2["INCOMING_INVOICE_RECEIVED_AT"] = "incoming_invoice_received_at";
  ServiceUpdateColumn2["INCOMING_INVOICE_RECEIVED_BY"] = "incoming_invoice_received_by";
  ServiceUpdateColumn2["INTERNAL_REMARKS"] = "internal_remarks";
  ServiceUpdateColumn2["INVOICE_ID"] = "invoice_id";
  ServiceUpdateColumn2["LABELS"] = "labels";
  ServiceUpdateColumn2["NAME"] = "name";
  ServiceUpdateColumn2["PROVISION_INVOICE_ID"] = "provision_invoice_id";
  ServiceUpdateColumn2["PROVISION_RATE"] = "provision_rate";
  ServiceUpdateColumn2["PROVISION_TYPE"] = "provision_type";
  ServiceUpdateColumn2["REMOTE_ID"] = "remote_id";
  ServiceUpdateColumn2["SELL_FACTOR"] = "sell_factor";
  ServiceUpdateColumn2["SELL_PRICE"] = "sell_price";
  ServiceUpdateColumn2["SELL_PRICE_DISPLAY_GROSS"] = "sell_price_display_gross";
  ServiceUpdateColumn2["SELL_QUANTITY"] = "sell_quantity";
  ServiceUpdateColumn2["SELL_TAX_RATE"] = "sell_tax_rate";
  ServiceUpdateColumn2["SELL_TAX_TYPE"] = "sell_tax_type";
  ServiceUpdateColumn2["SORT_INDEX"] = "sort_index";
  ServiceUpdateColumn2["START_DATE"] = "start_date";
  ServiceUpdateColumn2["START_TIME"] = "start_time";
  ServiceUpdateColumn2["SUPPLIER_ID"] = "supplier_id";
  ServiceUpdateColumn2["UPDATED_AT"] = "updated_at";
  return ServiceUpdateColumn2;
})({});
var SystemActivityConstraint = /* @__PURE__ */ (function(SystemActivityConstraint2) {
  SystemActivityConstraint2["ACTIVITY_PKEY"] = "activity_pkey";
  return SystemActivityConstraint2;
})({});
var SystemActivitySelectColumn = /* @__PURE__ */ (function(SystemActivitySelectColumn2) {
  SystemActivitySelectColumn2["ACCOUNT_ID"] = "account_id";
  SystemActivitySelectColumn2["ACCOUNT_TYPE"] = "account_type";
  SystemActivitySelectColumn2["ACTION"] = "action";
  SystemActivitySelectColumn2["CHANGES"] = "changes";
  SystemActivitySelectColumn2["CLIENT_ADDR"] = "client_addr";
  SystemActivitySelectColumn2["CREATED_AT"] = "created_at";
  SystemActivitySelectColumn2["DATA"] = "data";
  SystemActivitySelectColumn2["ID"] = "id";
  SystemActivitySelectColumn2["TARGET_ID"] = "target_id";
  SystemActivitySelectColumn2["TARGET_SCHEMA"] = "target_schema";
  SystemActivitySelectColumn2["TARGET_TYPE"] = "target_type";
  SystemActivitySelectColumn2["TRANSACTION_ID"] = "transaction_id";
  return SystemActivitySelectColumn2;
})({});
var SystemActivityUpdateColumn = /* @__PURE__ */ (function(SystemActivityUpdateColumn2) {
  SystemActivityUpdateColumn2["ACCOUNT_ID"] = "account_id";
  SystemActivityUpdateColumn2["ACCOUNT_TYPE"] = "account_type";
  SystemActivityUpdateColumn2["ACTION"] = "action";
  SystemActivityUpdateColumn2["CHANGES"] = "changes";
  SystemActivityUpdateColumn2["CLIENT_ADDR"] = "client_addr";
  SystemActivityUpdateColumn2["CREATED_AT"] = "created_at";
  SystemActivityUpdateColumn2["DATA"] = "data";
  SystemActivityUpdateColumn2["ID"] = "id";
  SystemActivityUpdateColumn2["TARGET_ID"] = "target_id";
  SystemActivityUpdateColumn2["TARGET_SCHEMA"] = "target_schema";
  SystemActivityUpdateColumn2["TARGET_TYPE"] = "target_type";
  SystemActivityUpdateColumn2["TRANSACTION_ID"] = "transaction_id";
  return SystemActivityUpdateColumn2;
})({});
var SystemMigrationsConstraint = /* @__PURE__ */ (function(SystemMigrationsConstraint2) {
  SystemMigrationsConstraint2["MIGRATIONS_PKEY"] = "migrations_pkey";
  return SystemMigrationsConstraint2;
})({});
var SystemMigrationsLockConstraint = /* @__PURE__ */ (function(SystemMigrationsLockConstraint2) {
  SystemMigrationsLockConstraint2["MIGRATIONS_LOCK_PKEY"] = "migrations_lock_pkey";
  return SystemMigrationsLockConstraint2;
})({});
var SystemMigrationsLockSelectColumn = /* @__PURE__ */ (function(SystemMigrationsLockSelectColumn2) {
  SystemMigrationsLockSelectColumn2["INDEX"] = "index";
  SystemMigrationsLockSelectColumn2["IS_LOCKED"] = "is_locked";
  return SystemMigrationsLockSelectColumn2;
})({});
var SystemMigrationsLockUpdateColumn = /* @__PURE__ */ (function(SystemMigrationsLockUpdateColumn2) {
  SystemMigrationsLockUpdateColumn2["INDEX"] = "index";
  SystemMigrationsLockUpdateColumn2["IS_LOCKED"] = "is_locked";
  return SystemMigrationsLockUpdateColumn2;
})({});
var SystemMigrationsSelectColumn = /* @__PURE__ */ (function(SystemMigrationsSelectColumn2) {
  SystemMigrationsSelectColumn2["BATCH"] = "batch";
  SystemMigrationsSelectColumn2["ID"] = "id";
  SystemMigrationsSelectColumn2["MIGRATION_TIME"] = "migration_time";
  SystemMigrationsSelectColumn2["NAME"] = "name";
  return SystemMigrationsSelectColumn2;
})({});
var SystemMigrationsUpdateColumn = /* @__PURE__ */ (function(SystemMigrationsUpdateColumn2) {
  SystemMigrationsUpdateColumn2["BATCH"] = "batch";
  SystemMigrationsUpdateColumn2["ID"] = "id";
  SystemMigrationsUpdateColumn2["MIGRATION_TIME"] = "migration_time";
  SystemMigrationsUpdateColumn2["NAME"] = "name";
  return SystemMigrationsUpdateColumn2;
})({});
var SystemWebhookConstraint = /* @__PURE__ */ (function(SystemWebhookConstraint2) {
  SystemWebhookConstraint2["WEBHOOK_PKEY"] = "webhook_pkey";
  return SystemWebhookConstraint2;
})({});
var SystemWebhookSelectColumn = /* @__PURE__ */ (function(SystemWebhookSelectColumn2) {
  SystemWebhookSelectColumn2["BODY"] = "body";
  SystemWebhookSelectColumn2["BUCKET"] = "bucket";
  SystemWebhookSelectColumn2["CREATED_AT"] = "created_at";
  SystemWebhookSelectColumn2["HEADERS"] = "headers";
  SystemWebhookSelectColumn2["ID"] = "id";
  SystemWebhookSelectColumn2["METHOD"] = "method";
  SystemWebhookSelectColumn2["NAME"] = "name";
  SystemWebhookSelectColumn2["QUERY"] = "query";
  SystemWebhookSelectColumn2["STATUS"] = "status";
  SystemWebhookSelectColumn2["UPDATED_AT"] = "updated_at";
  return SystemWebhookSelectColumn2;
})({});
var SystemWebhookUpdateColumn = /* @__PURE__ */ (function(SystemWebhookUpdateColumn2) {
  SystemWebhookUpdateColumn2["BODY"] = "body";
  SystemWebhookUpdateColumn2["BUCKET"] = "bucket";
  SystemWebhookUpdateColumn2["CREATED_AT"] = "created_at";
  SystemWebhookUpdateColumn2["HEADERS"] = "headers";
  SystemWebhookUpdateColumn2["ID"] = "id";
  SystemWebhookUpdateColumn2["METHOD"] = "method";
  SystemWebhookUpdateColumn2["NAME"] = "name";
  SystemWebhookUpdateColumn2["QUERY"] = "query";
  SystemWebhookUpdateColumn2["STATUS"] = "status";
  SystemWebhookUpdateColumn2["UPDATED_AT"] = "updated_at";
  return SystemWebhookUpdateColumn2;
})({});
var TaxConstraint = /* @__PURE__ */ (function(TaxConstraint2) {
  TaxConstraint2["TAX_PKEY"] = "tax_pkey";
  return TaxConstraint2;
})({});
var TaxFederationConstraint = /* @__PURE__ */ (function(TaxFederationConstraint2) {
  TaxFederationConstraint2["TAX_FEDERATION_PKEY"] = "tax_federation_pkey";
  return TaxFederationConstraint2;
})({});
var TaxFederationSelectColumn = /* @__PURE__ */ (function(TaxFederationSelectColumn2) {
  TaxFederationSelectColumn2["CODE"] = "code";
  TaxFederationSelectColumn2["CREATED_AT"] = "created_at";
  TaxFederationSelectColumn2["ID"] = "id";
  TaxFederationSelectColumn2["NAME"] = "name";
  TaxFederationSelectColumn2["UPDATED_AT"] = "updated_at";
  return TaxFederationSelectColumn2;
})({});
var TaxFederationUpdateColumn = /* @__PURE__ */ (function(TaxFederationUpdateColumn2) {
  TaxFederationUpdateColumn2["CODE"] = "code";
  TaxFederationUpdateColumn2["CREATED_AT"] = "created_at";
  TaxFederationUpdateColumn2["ID"] = "id";
  TaxFederationUpdateColumn2["NAME"] = "name";
  TaxFederationUpdateColumn2["UPDATED_AT"] = "updated_at";
  return TaxFederationUpdateColumn2;
})({});
var TaxSelectColumn = /* @__PURE__ */ (function(TaxSelectColumn2) {
  TaxSelectColumn2["COUNTRY_ID"] = "country_id";
  TaxSelectColumn2["CREATED_AT"] = "created_at";
  TaxSelectColumn2["ID"] = "id";
  TaxSelectColumn2["PERCENT"] = "percent";
  TaxSelectColumn2["UPDATED_AT"] = "updated_at";
  TaxSelectColumn2["VALID_FROM"] = "valid_from";
  TaxSelectColumn2["VALID_UNTIL"] = "valid_until";
  return TaxSelectColumn2;
})({});
var TaxUpdateColumn = /* @__PURE__ */ (function(TaxUpdateColumn2) {
  TaxUpdateColumn2["COUNTRY_ID"] = "country_id";
  TaxUpdateColumn2["CREATED_AT"] = "created_at";
  TaxUpdateColumn2["ID"] = "id";
  TaxUpdateColumn2["PERCENT"] = "percent";
  TaxUpdateColumn2["UPDATED_AT"] = "updated_at";
  TaxUpdateColumn2["VALID_FROM"] = "valid_from";
  TaxUpdateColumn2["VALID_UNTIL"] = "valid_until";
  return TaxUpdateColumn2;
})({});
var UserAccountConstraint = /* @__PURE__ */ (function(UserAccountConstraint2) {
  UserAccountConstraint2["USER_ACCOUNT_CODE_UNIQUE"] = "user_account_code_unique";
  UserAccountConstraint2["USER_ACCOUNT_EMAIL_UNIQUE"] = "user_account_email_unique";
  UserAccountConstraint2["USER_ACCOUNT_PKEY"] = "user_account_pkey";
  return UserAccountConstraint2;
})({});
var UserAccountGroupSelectColumn = /* @__PURE__ */ (function(UserAccountGroupSelectColumn2) {
  UserAccountGroupSelectColumn2["ACCOUNT_ID"] = "account_id";
  UserAccountGroupSelectColumn2["CREATED_AT"] = "created_at";
  UserAccountGroupSelectColumn2["GROUP_ID"] = "group_id";
  UserAccountGroupSelectColumn2["UPDATED_AT"] = "updated_at";
  return UserAccountGroupSelectColumn2;
})({});
var UserAccountSelectColumn = /* @__PURE__ */ (function(UserAccountSelectColumn2) {
  UserAccountSelectColumn2["CODE"] = "code";
  UserAccountSelectColumn2["CREATED_AT"] = "created_at";
  UserAccountSelectColumn2["EMAIL"] = "email";
  UserAccountSelectColumn2["FIRST_NAME"] = "first_name";
  UserAccountSelectColumn2["ID"] = "id";
  UserAccountSelectColumn2["LAST_NAME"] = "last_name";
  UserAccountSelectColumn2["PASSWORD_HASH"] = "password_hash";
  UserAccountSelectColumn2["ROLE"] = "role";
  UserAccountSelectColumn2["UPDATED_AT"] = "updated_at";
  return UserAccountSelectColumn2;
})({});
var UserAccountUpdateColumn = /* @__PURE__ */ (function(UserAccountUpdateColumn2) {
  UserAccountUpdateColumn2["CODE"] = "code";
  UserAccountUpdateColumn2["CREATED_AT"] = "created_at";
  UserAccountUpdateColumn2["EMAIL"] = "email";
  UserAccountUpdateColumn2["FIRST_NAME"] = "first_name";
  UserAccountUpdateColumn2["ID"] = "id";
  UserAccountUpdateColumn2["LAST_NAME"] = "last_name";
  UserAccountUpdateColumn2["PASSWORD_HASH"] = "password_hash";
  UserAccountUpdateColumn2["ROLE"] = "role";
  UserAccountUpdateColumn2["UPDATED_AT"] = "updated_at";
  return UserAccountUpdateColumn2;
})({});
var UserBookmarkConstraint = /* @__PURE__ */ (function(UserBookmarkConstraint2) {
  UserBookmarkConstraint2["ACCOUNT_BOOKMARK_PKEY"] = "account_bookmark_pkey";
  return UserBookmarkConstraint2;
})({});
var UserBookmarkSelectColumn = /* @__PURE__ */ (function(UserBookmarkSelectColumn2) {
  UserBookmarkSelectColumn2["CREATED_AT"] = "created_at";
  UserBookmarkSelectColumn2["ID"] = "id";
  UserBookmarkSelectColumn2["OBJECT_ID"] = "object_id";
  UserBookmarkSelectColumn2["OBJECT_TYPENAME"] = "object_typename";
  UserBookmarkSelectColumn2["UPDATED_AT"] = "updated_at";
  UserBookmarkSelectColumn2["USER_ID"] = "user_id";
  return UserBookmarkSelectColumn2;
})({});
var UserBookmarkUpdateColumn = /* @__PURE__ */ (function(UserBookmarkUpdateColumn2) {
  UserBookmarkUpdateColumn2["CREATED_AT"] = "created_at";
  UserBookmarkUpdateColumn2["ID"] = "id";
  UserBookmarkUpdateColumn2["OBJECT_ID"] = "object_id";
  UserBookmarkUpdateColumn2["OBJECT_TYPENAME"] = "object_typename";
  UserBookmarkUpdateColumn2["UPDATED_AT"] = "updated_at";
  UserBookmarkUpdateColumn2["USER_ID"] = "user_id";
  return UserBookmarkUpdateColumn2;
})({});
var UserGroupConstraint = /* @__PURE__ */ (function(UserGroupConstraint2) {
  UserGroupConstraint2["USER_GROUP_NAME_UNIQUE"] = "user_group_name_unique";
  UserGroupConstraint2["USER_GROUP_PKEY"] = "user_group_pkey";
  return UserGroupConstraint2;
})({});
var UserGroupSelectColumn = /* @__PURE__ */ (function(UserGroupSelectColumn2) {
  UserGroupSelectColumn2["CREATED_AT"] = "created_at";
  UserGroupSelectColumn2["GRANTS"] = "grants";
  UserGroupSelectColumn2["ID"] = "id";
  UserGroupSelectColumn2["NAME"] = "name";
  UserGroupSelectColumn2["UPDATED_AT"] = "updated_at";
  return UserGroupSelectColumn2;
})({});
var UserGroupUpdateColumn = /* @__PURE__ */ (function(UserGroupUpdateColumn2) {
  UserGroupUpdateColumn2["CREATED_AT"] = "created_at";
  UserGroupUpdateColumn2["GRANTS"] = "grants";
  UserGroupUpdateColumn2["ID"] = "id";
  UserGroupUpdateColumn2["NAME"] = "name";
  UserGroupUpdateColumn2["UPDATED_AT"] = "updated_at";
  return UserGroupUpdateColumn2;
})({});

// budget/fetch.ts
import { CrudFetch, CrudQuery } from "@hc/graphql";
var BudgetFetch = class extends CrudFetch {
  static {
    __name(this, "BudgetFetch");
  }
  params;
  constructor(params) {
    super(), this.params = params;
  }
  async fetch() {
    const query = new CrudQuery();
    const servicesFilter = this.params.invoiceId ? {
      service_invoices: {
        invoice_id: {
          _eq: this.params.invoiceId
        }
      }
    } : {
      budget_id: {
        _eq: this.params.id
      }
    };
    const joins = this.params.invoiceType === "provision" ? {
      "supplier": {}
    } : {};
    query.find("budget", this.params.id, {
      apiToken: this.params.apiToken
    });
    query.list("service", {
      skipJoins: true,
      filter: servicesFilter,
      includeJoins: joins
    });
    query.list("service_group", {
      skipJoins: true,
      filter: {
        budget_id: {
          _eq: this.params.id
        }
      }
    });
    query.list("budget_fee", {
      skipJoins: true,
      filter: {
        budget_id: {
          _eq: this.params.id
        }
      }
    });
    if (this.params.invoiceId) {
      query.list("service_invoice", {
        skipJoins: true,
        filter: {
          invoice_id: {
            _eq: this.params.invoiceId
          }
        }
      });
      const [budget2, services2, groups2, fees2, serviceInvoices] = await query.execute();
      return {
        budget: budget2,
        services: services2,
        groups: groups2,
        fees: fees2,
        serviceInvoices
      };
    }
    const [budget, services, groups, fees] = await query.execute();
    return {
      budget,
      services,
      groups,
      fees
    };
  }
  async fetchProvision() {
    const query = new CrudQuery();
    query.find("budget", this.params.id);
    query.list("service", {
      filter: {
        budget_id: {
          _eq: this.params.id
        }
      },
      includeJoins: {
        "supplier": {}
      },
      skipJoins: true
    });
    const [budget, services] = await query.execute();
    return {
      budget,
      services
    };
  }
};

// invoice/address.ts
var InvoiceAddress = class {
  static {
    __name(this, "InvoiceAddress");
  }
  static format(address, company) {
    const components = [];
    components.push(company.name);
    if (address.street) components.push(address.street);
    if (address.additional) components.push(address.additional);
    if (address.zip || address.city) components.push(`${address.zip} ${address.city}`);
    if (address.country) components.push(address.country.name);
    return components.join("\n");
  }
};

// budget/computer.ts
var BudgetComputer = class {
  static {
    __name(this, "BudgetComputer");
  }
  budget;
  constructor(budget) {
    this.budget = budget;
  }
  get project() {
    return this.budget.project;
  }
  get logoUrl() {
    const customLogo = this.office.company.logo_url;
    return customLogo && customLogo.startsWith("http") ? customLogo : "https://wonderland.etool.biz/logo/time-change-2025.png";
  }
  get country() {
    return this.budget.country || this.budget.project.country;
  }
  get city() {
    return this.budget.city || this.budget.project.city;
  }
  get office() {
    return this.budget?.office || this.budget.project.office;
  }
  get ownerCompany() {
    return this.office.company;
  }
  get locale() {
    return this.budget?.project?.client?.language?.toLowerCase();
  }
  get currency() {
    return this.budget?.project?.currency;
  }
  get issuerAddress() {
    if (this.budget.issuer_address) return this.budget.issuer_address;
    if (this.budget.office) return InvoiceAddress.format(this.budget.office.address, this.budget.office.company);
    if (this.project.issuer_address) return this.project.issuer_address;
    if (this.project.office.address) return InvoiceAddress.format(this.project.office.address, this.project.office.company);
    return null;
  }
  get issuerVatNumberId() {
    if (this.budget.vat_number_id) return this.budget.vat_number_id;
    if (this.budget.office) return this.budget.office.company.main_vat_number_id;
    if (this.project.vat_number_id) return this.project.vat_number_id;
    return this.project.office.company.main_vat_number_id;
  }
  get issuerBankAccountId() {
    if (this.budget.bank_account_id) return this.budget.bank_account_id;
    if (this.budget.office) return this.budget.office.company.main_bank_account_id;
    if (this.project.bank_account_id) return this.project.bank_account_id;
    return this.project.office.company.main_bank_account_id;
  }
};

// budget/export_group_services.ts
import * as _ from "lodash";

// budget/export_calculations.ts
var BudgetExportCalculations = class {
  static {
    __name(this, "BudgetExportCalculations");
  }
  _data;
  _config;
  constructor(data, config = {}) {
    this._data = data;
    this._config = config;
  }
  servicesSums(prev, next, ignoreTomsHide) {
    const sums = {
      sell_gross: prev.sell_gross + next.sell_gross,
      depositAmount: prev.depositAmount + next.depositAmount,
      provision_amount: prev.provision_amount + next.provision_amount,
      buy_gross: prev.buy_gross + next.buy_gross,
      buy_net: prev.buy_net + next.buy_net,
      buy_tax_amount: prev.buy_tax_amount + next.buy_tax_amount
    };
    if (this._config.show_toms_tax || ignoreTomsHide) {
      return {
        ...sums,
        sell_net: prev.sell_net + next.sell_net,
        sell_tax_amount: prev.sell_tax_amount + next.sell_tax_amount
      };
    } else {
      return {
        ...sums,
        sell_net: prev.sell_net + +(next.sell_tax_type == "toms" && next.sell_gross || next.sell_net),
        sell_tax_amount: prev.sell_tax_amount + (next.sell_tax_type != "toms" && next.sell_tax_amount || 0)
      };
    }
  }
  subtotals(services, ignoreTomsHide = false) {
    return services.reduce((prev, next) => {
      return this.servicesSums(prev, next, ignoreTomsHide);
    }, {
      sell_gross: 0,
      sell_net: 0,
      sell_tax_amount: 0,
      depositAmount: 0,
      provision_amount: 0,
      buy_gross: 0,
      buy_net: 0,
      buy_tax_amount: 0
    });
  }
  depositAmountTotal = /* @__PURE__ */ __name(() => {
    if (this._data.serviceInvoices) {
      return this._data.serviceInvoices.reduce((sum, service) => sum + service.amount, 0);
    }
  }, "depositAmountTotal");
  grandtotals(ignoreTomsHide = false) {
    return this._data.services.reduce((prev, next) => {
      return this.servicesSums(prev, next, ignoreTomsHide);
    }, {
      sell_gross: 0,
      sell_net: 0,
      sell_tax_amount: 0,
      provision_amount: 0,
      buy_gross: 0,
      buy_net: 0,
      buy_tax_amount: 0
    });
  }
  feeCalculation(grandTotalNet) {
    let feesNet = 0;
    let feesTax = 0;
    let feesGross = 0;
    if (!this._data.fees) return;
    for (const fee of this._data.fees) {
      const net = fee.absolute ? fee.value : grandTotalNet / 100 * fee.value;
      const tax = net / 100 * fee.tax_rate;
      feesNet += net;
      feesTax += tax;
      feesGross += net + tax;
    }
    return {
      net: feesNet,
      tax: feesTax,
      gross: feesGross
    };
  }
  calculations() {
    if (this._config.template === "provision") {
      this._data.services = this._data.services.filter((service) => service.provision_amount !== 0);
      return {
        grandTotal: this.grandtotals(true)
      };
    }
    const grandTotal = {
      ...this.grandtotals(),
      ...{
        depositAmount: this.depositAmountTotal()
      }
    };
    const fees = this.feeCalculation(this.grandtotals(true).sell_net);
    return {
      grandTotal,
      fees
    };
  }
};

// budget/export_group_services.ts
var BudgetExportGroupServices = class {
  static {
    __name(this, "BudgetExportGroupServices");
  }
  _data;
  _config;
  _groups = [];
  constructor(data, config = {}) {
    this._data = data;
    this._config = config;
  }
  groupServicesByCategory() {
    const ungrouped = this._data.services.filter((service) => !service.group_id);
    return _.groupBy(ungrouped, (service) => {
      return service.category;
    });
  }
  getServicesWithoutSell(services) {
    if (this._config.hide_services_without_sell) return services.filter((s) => s.sell_gross != 0);
    else return services;
  }
  getGroupSubtotals(group, ignoreTomsHide = false) {
    return new BudgetExportCalculations(this._data, this._config).subtotals(group, ignoreTomsHide);
  }
  groupServicesBySupplier() {
    const groupbySupplier = _.groupBy(this.supplierServices, (service) => service.supplier.name);
    Object.keys(groupbySupplier).forEach((supplier) => {
      const groupSubtotals2 = this.getGroupSubtotals(groupbySupplier[supplier], true);
      this._groups.push({
        name: supplier,
        key: supplier,
        labels: [],
        services: groupbySupplier[supplier],
        subtotals: groupSubtotals2
      });
    });
    const groupSubtotals = this.getGroupSubtotals(this.servicesWithoutSupplier, true);
    if (this.servicesWithoutSupplier.length > 0) {
      this._groups.push({
        key: "without-supplier",
        name: "Services Without Supplier",
        labels: [],
        services: this.servicesWithoutSupplier,
        subtotals: groupSubtotals
      });
    }
    return this._groups;
  }
  groupServices() {
    if (this._config.template === "provision") return this.groupServicesBySupplier();
    this._data.groups?.forEach((group) => {
      let services = this._data.services.filter((service) => {
        return service.group_id && service.group_id === group.id;
      });
      services = this.getServicesWithoutSell(services);
      const groupSubtotals = this.getGroupSubtotals(services);
      this._groups.push({
        name: group.name,
        key: group.id + "-" + group.name,
        description: group.description,
        services,
        labels: group.labels || [],
        subtotals: groupSubtotals
      });
    });
    const groupedbyCategory = this.groupServicesByCategory();
    Object.keys(groupedbyCategory).forEach((category) => {
      let services = groupedbyCategory[category];
      services = this.getServicesWithoutSell(services);
      const groupSubtotals = this.getGroupSubtotals(services);
      this._groups.push({
        name: category,
        key: category,
        labels: [],
        services,
        subtotals: groupSubtotals
      });
    });
    return this._groups;
  }
  get provisionServices() {
    return this._data.services.filter((service) => service.provision_amount !== 0);
  }
  get supplierServices() {
    return this.provisionServices.filter((service) => service.supplier_id);
  }
  get servicesWithoutSupplier() {
    return this.provisionServices.filter((service) => !service.supplier_id);
  }
};

// budget/export_sort_services.ts
import moment from "moment";
var BudgetExportSortServices = class {
  static {
    __name(this, "BudgetExportSortServices");
  }
  _groupedServices;
  constructor(groupedServices) {
    this._groupedServices = groupedServices;
  }
  getServiceDateTime(service) {
    return moment(`${service.start_date} ${service.start_time || "00:00:00"}`);
  }
  sortGroupsAndServices() {
    this._groupedServices.forEach(({ services }) => {
      services.sort((a, b) => {
        const serviceA = this.getServiceDateTime(a);
        const serviceB = this.getServiceDateTime(b);
        return serviceA.diff(serviceB);
      });
    });
    this._groupedServices.sort((a, b) => {
      const serviceA = this.getServiceDateTime(a.services[0] || {});
      const serviceB = this.getServiceDateTime(b.services[0] || {});
      return serviceA.diff(serviceB);
    });
  }
};

// service/calculator.ts
import _3 from "lodash";

// math.ts
import * as _2 from "lodash";
var Math2 = class {
  static {
    __name(this, "Math");
  }
  static getPercentage(groundValue, percentageValue) {
    return percentageValue / groundValue * 100;
  }
  static getGroundValue(percentage, percentageValue) {
    return percentageValue / percentage * 100;
  }
  static getPercentageValue(percentage, groundValue) {
    return percentage / 100 * groundValue;
  }
  static mixColors(colorAHexCode) {
  }
};
var Color = class {
  static {
    __name(this, "Color");
  }
  colorHex;
  a;
  constructor(colorHexCode, alpha = 1) {
    this.colorHex = colorHexCode;
    this.a = _2.min([
      alpha,
      1
    ]);
  }
  get alpha() {
    return this.a;
  }
  addColor(colorToAdd) {
    const primaryColorsToAdd = colorToAdd.getPrimaryColors();
    this.colorHex = _2.map(this.getPrimaryColors(), (selfPrimaryColor, index) => {
      const newPrimaryColor = selfPrimaryColor * (1 - colorToAdd.alpha) + primaryColorsToAdd[index] * colorToAdd.alpha;
      return Number(newPrimaryColor.toFixed()).toString(16);
    }).join("");
    return this;
  }
  getCssColor() {
    return "#" + this.colorHex;
  }
  getPrimaryColors() {
    return _2.map(this.colorHex.match(/.{1,2}/g), (color) => parseInt(color, 16));
  }
};

// service/calculator.ts
var ServiceCalculator = class _ServiceCalculator {
  static {
    __name(this, "ServiceCalculator");
  }
  static applyDefaults(service) {
    if (_3.isNil(service.category)) service.category = "other";
    if (_3.isNil(service.sell_price)) service.sell_price = 2;
    if (_3.isNil(service.sell_tax_type)) service.sell_tax_type = "vat";
    if (_3.isNil(service.sell_tax_rate)) service.sell_tax_rate = 0;
    if (_3.isNil(service.sell_quantity)) service.sell_quantity = 1;
    if (_3.isNil(service.sell_factor)) service.sell_factor = 1;
    if (_3.isNil(service.buy_price)) service.buy_price = 1;
    if (_3.isNil(service.buy_tax_type)) service.buy_tax_type = "vat";
    if (_3.isNil(service.buy_tax_rate)) service.buy_tax_rate = 0;
    if (_3.isNil(service.buy_quantity)) service.buy_quantity = 1;
    if (_3.isNil(service.buy_factor)) service.buy_factor = 1;
    if (_3.isNil(service.commission_rate) || _3.isNaN(service.commission_rate)) service.commission_rate = 0;
    if (_3.isNil(service.provision_rate) || _3.isNaN(service.provision_rate)) service.provision_rate = 0;
    if (_3.isNil(service.margin_rate)) service.margin_rate = 50;
    if (_3.isNil(service.buy_price_display_gross)) service.buy_price_display_gross = false;
    if (_3.isNil(service.sell_price_display_gross)) service.sell_price_display_gross = false;
  }
  static calculate(service) {
    service.buy_net = _ServiceCalculator.buyNet(service);
    service.sell_net = _ServiceCalculator.sellNet(service);
    service.buy_gross = _ServiceCalculator.buyGross(service);
    service.sell_gross = _ServiceCalculator.sellGross(service);
    service.margin_amount = _ServiceCalculator.marginAmount(service);
    service.buy_tax_amount = _ServiceCalculator.buyTaxAmount(service);
    service.sell_tax_amount = _ServiceCalculator.sellTaxAmount(service);
    service.provision_amount = _ServiceCalculator.provisionAmount(service);
    service.commission_amount = _ServiceCalculator.commissionAmount(service);
    service.earning_amount = _ServiceCalculator.earningAmount(service);
    service.fixed_costs_amount = _ServiceCalculator.fixedCostsAmount(service);
  }
  static marginRate(service) {
    if (service.sell_price) {
      if (service.sell_factor == 0 || service.sell_quantity == 0 || service.sell_net == service.buy_net) {
        return 0;
      } else if (service.buy_price == 0 || service.buy_factor == 0 || service.buy_quantity == 0) {
        return 100;
      } else {
        const buy = _ServiceCalculator.buyNet(service);
        const sell = _ServiceCalculator.sellNet(service);
        return parseFloat((100 / sell * (sell - buy)).toFixed(4));
      }
    }
    return 0;
  }
  static marginAmount(service) {
    return service.sell_net - service.buy_net;
  }
  static earningAmount(service) {
    return _ServiceCalculator.marginAmount(service) - _ServiceCalculator.fixedCostsAmount(service) + _ServiceCalculator.commissionAmount(service) - _ServiceCalculator.provisionAmount(service);
  }
  static fixedCostsAmount(service) {
    if (service.budget) return Math2.getPercentageValue(service.budget.project.business_area.fixed_costs_rate, _ServiceCalculator.sellNet(service));
    return 0;
  }
  static provisionAmount(service) {
    switch (service.provision_type) {
      case "item":
        return service.provision_rate * service.sell_quantity * service.sell_factor;
      case "fixed":
        return service.provision_rate;
      default:
        return service.sell_price * service.sell_quantity * service.sell_factor / 100 * service.provision_rate;
    }
  }
  static commissionAmount(service) {
    switch (service.commission_type) {
      case "item":
        return service.commission_rate * service.buy_quantity * service.buy_factor;
      case "fixed":
        return service.commission_rate;
      default:
        return service.buy_price * service.buy_quantity * service.buy_factor / 100 * service.commission_rate;
    }
  }
  static buyNet(service) {
    return service.buy_price * service.buy_quantity * service.buy_factor;
  }
  static sellPrice(service) {
    const totalSellPrice = _ServiceCalculator.buyNet(service) / (100 - service.margin_rate) * 100;
    if (service.sell_factor === 0 || service.sell_quantity === 0) return service.sell_price;
    return totalSellPrice / service.sell_factor / service.sell_quantity;
  }
  static sellNet(service) {
    return service.sell_price * service.sell_quantity * service.sell_factor;
  }
  static buyGross(service) {
    return this.buyNet(service) + this.buyTaxAmount(service);
  }
  static sellGross(service) {
    return this.sellNet(service) + this.sellTaxAmount(service);
  }
  static sellTaxAmount(service) {
    if (service.sell_tax_type == "toms") {
      const margin = this.marginAmount(service);
      return Math2.getPercentageValue(service.sell_tax_rate, margin);
    }
    return Math2.getPercentageValue(service.sell_tax_rate, this.sellNet(service));
  }
  static buyTaxAmount(service) {
    if (service.buy_tax_type == "toms") {
      return 0;
    }
    return Math2.getPercentageValue(service.buy_tax_rate, this.buyNet(service));
  }
  static marginPerPos(service, sellPrice) {
    const sell_multiplier = service.sell_factor * service.sell_quantity;
    if (sell_multiplier == 0) return 0;
    return (sellPrice * sell_multiplier - service.buy_price * service.buy_factor * service.buy_quantity) / sell_multiplier;
  }
  static netToGross(service, positionType, net) {
    if (positionType == "sell" && service.sell_tax_type == "toms") {
      const netMargin = this.marginPerPos(service, net);
      return net + netMargin * service.sell_tax_rate / 100;
    } else if (positionType == "buy" && service.buy_tax_type == "toms") {
      return net;
    }
    return net * (Number(service[positionType + "_tax_rate"]) + 100) / 100;
  }
  static grossToNet(service, positionType, gross) {
    if (positionType == "sell" && service.sell_tax_type == "toms") {
      const grossMargin = this.marginPerPos(service, gross);
      return gross - grossMargin + grossMargin / (service.sell_tax_rate / 100 + 1);
    }
    return gross / (Number(service[positionType + "_tax_rate"]) + 100) * 100;
  }
};

// contract/fetch.ts
import { CrudFetch as CrudFetch2, CrudQuery as CrudQuery2 } from "@hc/graphql";
var ContractFetch = class extends CrudFetch2 {
  static {
    __name(this, "ContractFetch");
  }
  params;
  constructor(params) {
    super(), this.params = params;
  }
  async fetch() {
    const query = new CrudQuery2();
    query.find("contract", this.params.id);
    const [contract] = await query.execute();
    const { budget, services, groups, fees } = await new BudgetFetch({
      id: contract.budget_id
    }).fetch();
    return {
      contract,
      budget,
      services,
      groups,
      fees
    };
  }
};

// contract/computer.ts
import _4 from "lodash";
import { formatDate } from "@hc/graphql";
var ContractComputer = class {
  static {
    __name(this, "ContractComputer");
  }
  contract;
  budgetComputer;
  constructor(contract) {
    this.contract = contract;
    this.budgetComputer = new BudgetComputer(contract.budget);
  }
  get budget() {
    return this.contract.budget;
  }
  get project() {
    return this.contract.budget.project;
  }
  get office() {
    return this.budgetComputer.office;
  }
  get locale() {
    return (this.contract.fixed_data?.recipient_language || this.budgetComputer.locale).toLowerCase();
  }
  get country() {
    return this.budgetComputer.country;
  }
  get city() {
    return this.budgetComputer.city;
  }
  get ownerCompany() {
    return this.budgetComputer.ownerCompany;
  }
  get issuerAddress() {
    return this.budgetComputer.issuerAddress;
  }
  get logoUrl() {
    const customLogo = this.office.company.logo_url;
    return customLogo && customLogo.startsWith("http") ? customLogo : "https://wonderland.etool.biz/logo/time-change-2025.png";
  }
  get offerValidityDate() {
    return formatDate(this.contract.offer_validity_date, {
      short: true,
      locale: this.locale
    });
  }
};
var ContractFixedDataComputer = class extends ContractComputer {
  static {
    __name(this, "ContractFixedDataComputer");
  }
  data;
  constructor(data) {
    super(data.contract), this.data = data;
  }
  get fixedData() {
    if (this.contract.fixed_data) {
      return this.contract.fixed_data;
    }
    const { issuer, recipient } = this.contract;
    const groups = _4.sortBy(this.data.groups, "sort_index");
    const services = _4.sortBy(this.data.services, "sort_index");
    return {
      budget: {
        ...this.budget,
        services,
        groups,
        fees: this.data.fees
      },
      issuer: {
        first_name: issuer.first_name,
        last_name: issuer.last_name
      },
      recipient: {
        name: recipient.name,
        language: recipient.language
      }
    };
  }
};

// invoice/fetch.ts
import { CrudFetch as CrudFetch3, CrudQuery as CrudQuery3 } from "@hc/graphql";
var InvoiceFetch = class extends CrudFetch3 {
  static {
    __name(this, "InvoiceFetch");
  }
  params;
  constructor(params) {
    super(), this.params = params;
  }
  async fetchInvoice() {
    const query = new CrudQuery3();
    query.find("invoice", this.params.id);
    const [invoice] = await query.execute();
    return invoice;
  }
  async fetchCanceledInvoice(invoice) {
    const query = new CrudQuery3();
    if (invoice.type !== "cancelation") return null;
    query.list("invoice", {
      filter: {
        cancelation_id: {
          _eq: this.params.id
        }
      },
      limit: 1
    });
    const [canceledInvoices] = await query.execute();
    if (canceledInvoices.length > 0) return canceledInvoices[0];
  }
  async fetchDepoInvoices(invoice) {
    if (invoice.type !== "final") return [];
    let depositInvoices = await this.fetchAssignedDepoInvoices(invoice);
    let unassignedDepoInvoices;
    if (invoice.status == "draft" || invoice.status == "requested") {
      unassignedDepoInvoices = await this.fetchUnassignedDepoInvoices(invoice);
    }
    if (unassignedDepoInvoices) {
      for (const depo of unassignedDepoInvoices) {
        if (depositInvoices.find((d) => d.id == depo.id)) continue;
        else depositInvoices.push(depo);
      }
    }
    return depositInvoices;
  }
  async fetchAssignedDepoInvoices(invoice) {
    const query = new CrudQuery3();
    const filter = {
      type: {
        _eq: "deposit"
      },
      status: {
        _eq: "confirmed"
      },
      project_id: {
        _eq: invoice.project_id
      },
      final_invoice_id: {
        _eq: invoice.id
      }
    };
    query.list("invoice", {
      filter
    });
    const [assignedDepoInvoices] = await query.execute();
    return assignedDepoInvoices;
  }
  async fetchUnassignedDepoInvoices(invoice) {
    const query = new CrudQuery3();
    const unasignedDepoFilter = {
      type: {
        _eq: "deposit"
      },
      status: {
        _eq: "confirmed"
      },
      payment_date: {
        _is_null: false
      },
      project_id: {
        _eq: invoice.project_id
      },
      final_invoice_id: {
        _is_null: true
      },
      issuer_id: {
        _eq: invoice.issuer_id
      },
      _or: [
        {
          budget_id: {
            _is_null: true
          }
        }
      ]
    };
    if (invoice.budget_id) unasignedDepoFilter["_or"].push({
      budget_id: {
        _eq: invoice.budget_id
      }
    });
    query.list("invoice", {
      filter: unasignedDepoFilter
    });
    const [unassignedDepoInvoices] = await query.execute();
    return unassignedDepoInvoices;
  }
  async fetchInvoicesWithRequestedDeposits(invoice) {
    const query = new CrudQuery3();
    const filter = {
      project_id: {
        _eq: invoice.project_id
      },
      type: {
        _eq: "final"
      },
      status: {
        _eq: "requested"
      }
    };
    query.list("invoice", {
      filter
    });
    const [invoicesWithRequestedDeposits] = await query.execute();
    return invoicesWithRequestedDeposits;
  }
  getPersistedData(invoice, budget, services, groups, fees, serviceInvoices) {
    return {
      budget: invoice.fixed_data?.budget || budget,
      services: invoice.fixed_data?.budget?.services || services,
      fees: invoice.fixed_data?.budget?.fees || fees,
      groups: invoice.fixed_data?.budget?.groups || groups,
      serviceInvoices: invoice.fixed_data?.budget?.serviceInvoices || serviceInvoices
    };
  }
  async fetch() {
    const invoice = await this.fetchInvoice();
    const depositInvoices = await this.fetchDepoInvoices(invoice);
    const canceledInvoice = await this.fetchCanceledInvoice(invoice);
    if (!invoice.budget_id) return {
      invoice,
      canceledInvoice,
      depositInvoices
    };
    const { budget, services, groups, fees, serviceInvoices } = await new BudgetFetch({
      id: invoice.budget_id,
      invoiceId: invoice.id,
      invoiceType: invoice.type
    }).fetch();
    const persistedData = this.getPersistedData(invoice, budget, services, groups, fees, serviceInvoices);
    return {
      invoice,
      budget: persistedData.budget,
      services: persistedData.services,
      groups: persistedData.groups,
      fees: persistedData.fees,
      serviceInvoices: persistedData.serviceInvoices,
      canceledInvoice,
      depositInvoices
    };
  }
};

// invoice/calculator.ts
var InvoiceCalculator = class {
  static {
    __name(this, "InvoiceCalculator");
  }
  static getAbsoluteTax(position) {
    if (position.tax_rate > 0) {
      if (position.net != null) return position.net / 100 * position.tax_rate;
      if (position.gross != null) return position.gross / (100 + position.tax_rate) * position.tax_rate;
    }
    return 0;
  }
  static calculateTotal(invoice, depos = []) {
    invoice.total_net = 0;
    invoice.total_tax = 0;
    invoice.total_gross = 0;
    invoice.total_fees = 0;
    const positions = (invoice.positions || []).concat(invoice.fees || []);
    for (const position of positions) {
      invoice.total_net += position.net * position.quantity;
      if (position.tax_rate > 0) {
        if (position.tax_type != "toms") {
          invoice.total_tax += this.getAbsoluteTax(position) * position.quantity;
        }
        invoice.total_gross += position.gross * position.quantity;
      } else {
        invoice.total_gross += position.gross * position.quantity;
      }
    }
    for (const position of invoice.fees) {
      invoice.total_fees += position.gross * position.quantity;
    }
    if (invoice.type == "final") {
      invoice.total_discount = 0;
      for (const depo of depos) {
        invoice.total_gross -= depo.payment_amount;
        invoice.total_tax -= depo.total_tax;
        invoice.toms_tax_amount -= depo.toms_tax_amount;
        invoice.total_discount += depo.payment_amount;
        invoice.total_net -= depo.total_net;
      }
      invoice.total_discount = Number(invoice.total_discount.toFixed(2));
    } else {
      invoice.total_discount = 0;
      invoice.fees = [];
    }
    invoice.total_net = Number(invoice.total_net.toFixed(2));
    invoice.total_tax = Number(invoice.total_tax.toFixed(2));
    invoice.total_gross = Number(invoice.total_gross.toFixed(2));
  }
  static calculateTaxShares(invoice) {
    return this.calculateTaxSharesFromPositions((invoice.positions || []).concat(invoice.fees || []));
  }
  static calculateTaxSharesFromPositions(positions) {
    const shares = {};
    for (const position of positions) {
      if (position.tax_type == "toms") continue;
      const key = position.tax_rate.toString();
      if (!shares[key]) shares[key] = 0;
      shares[key] += Number((this.getAbsoluteTax(position) * position.quantity).toFixed(2));
    }
    return shares;
  }
};

// invoice/computer.ts
var InvoiceComputer = class {
  static {
    __name(this, "InvoiceComputer");
  }
  invoice;
  constructor(invoice) {
    this.invoice = invoice;
  }
  get budget() {
    return this.invoice.budget;
  }
  get project() {
    return this.invoice.project;
  }
  get office() {
    return this.budget?.office || this.project.office;
  }
  get ownerCompany() {
    return this.office.company;
  }
  get logoUrl() {
    const customLogo = this.office.company.logo_url;
    return customLogo && customLogo.startsWith("http") ? customLogo : "https://wonderland.etool.biz/logo/time-change-2025.png";
  }
  get locale() {
    return (this.invoice?.fixed_data?.recipient_language || this.invoice.recipient.language).toLowerCase();
  }
  get issuerAddress() {
    if (this.invoice.issuer_address) return this.invoice.issuer_address;
    if (this?.budget?.issuer_address) return this.budget.issuer_address;
    if (this?.budget?.office) return InvoiceAddress.format(this.budget.office.address, this.budget.office.company);
    if (this.project.issuer_address) return this.project.issuer_address;
    return InvoiceAddress.format(this.project.office.address, this.project.office.company);
  }
  get issuerVatNumberId() {
    if (this?.budget?.vat_number_id) return this.budget.vat_number_id;
    if (this?.budget?.office) return this.budget.office.company.main_vat_number_id;
    if (this.project.vat_number_id) return this.project.vat_number_id;
    return this.project.office.company.main_vat_number_id;
  }
  get issuerBankAccountId() {
    if (this?.budget?.bank_account_id) return this.budget.bank_account_id;
    if (this?.budget?.office) return this.budget.office.company.main_bank_account_id;
    if (this.project.bank_account_id) return this.project.bank_account_id;
    return this.project.office.company.main_bank_account_id;
  }
  get fixedData() {
    if (this.invoice.fixed_data) {
      return this.invoice.fixed_data;
    }
    const project = this.invoice.project;
    const bank_account = this.invoice.bank_account;
    const office = this.invoice?.budget?.office || this.invoice.project.office;
    const fixedData = {
      logo_url: this.logoUrl,
      phone: office.company.phone,
      website: office.company.website,
      email: office.address.email,
      office_name: office.name,
      recipient_language: this.invoice.recipient.language,
      footer_tax: this.variableSubstitution(office.invoice_footer_tax),
      footer_legal: this.variableSubstitution(office.invoice_footer_legal),
      invoice_address: this.variableSubstitution(office.invoice_address),
      project_name: project.name,
      budget_name: this.invoice.budget?.name,
      issuer_name: this.invoice.issuer.name,
      city: this.invoice.budget?.city || project.city,
      country: project.country.name,
      bank_name: bank_account && bank_account.bank_name,
      bank_iban: bank_account && bank_account.iban,
      bank_bic: bank_account && bank_account.bic,
      primary: office.company.primary
    };
    return fixedData;
  }
  variableSubstitution(text) {
    if (!text) return text;
    text = text.replace(/%issuer-vat-number%/g, this.invoice.issuer_vat_number.value);
    return text;
  }
};

// invoice/misc.ts
var taxEnabledForDepositInvoice = /* @__PURE__ */ __name((company) => {
  return company.country.code == "ES";
}, "taxEnabledForDepositInvoice");

// index.ts
var constants = constants_exports;
Graphql.addValidations(forms_exports);
Graphql.addCollections(collections_exports);
Graphql.addQueries(query_exports);
var app = new AppContext(new WndlCrudSchema(Graphql));
app.i18n.messages = {
  de: de_default,
  en: en_default
};
var index_default = app;
var api = app;
var crud = app.crud;
export {
  ACTIONS,
  BUDGET_STATES,
  BudgetComputer,
  BudgetConstraint,
  BudgetExportCalculations,
  BudgetExportGroupServices,
  BudgetExportSortServices,
  BudgetFeeConstraint,
  BudgetFeeSelectColumn,
  BudgetFeeSelectColumnBudgetFeeAggregateBoolExpBoolAndArgumentsColumns,
  BudgetFeeSelectColumnBudgetFeeAggregateBoolExpBoolOrArgumentsColumns,
  BudgetFeeUpdateColumn,
  BudgetFetch,
  BudgetSelectColumn,
  BudgetUpdateColumn,
  BusinessAreaCategoryConstraint,
  BusinessAreaCategorySelectColumn,
  BusinessAreaCategorySelectColumnBusinessAreaCategoryAggregateBoolExpBoolAndArgumentsColumns,
  BusinessAreaCategorySelectColumnBusinessAreaCategoryAggregateBoolExpBoolOrArgumentsColumns,
  BusinessAreaCategoryUpdateColumn,
  BusinessAreaConstraint,
  BusinessAreaSelectColumn,
  BusinessAreaUpdateColumn,
  COMPANY_ADDRESSES,
  COMPANY_ADDRESS_FIELDS,
  COMPANY_ADDRESS_TYPES,
  COMPANY_FIELDS,
  COMPANY_TYPES,
  CONTENT_ARTICLE_CATEGORY_FIELDS,
  CONTENT_ARTICLE_FIELDS,
  CONTENT_CATEGORY_FIELDS,
  CONTENT_PAGE_FIELDS,
  CONTRACT_SECTION_TYPES,
  CONTRACT_STATES,
  ChangeStatusAction,
  Color,
  CompanyAddressConstraint,
  CompanyAddressSelectColumn,
  CompanyAddressUpdateColumn,
  CompanyBankAccountConstraint,
  CompanyBankAccountSelectColumn,
  CompanyBankAccountUpdateColumn,
  CompanyConstraint,
  CompanyManagerConstraint,
  CompanyManagerSelectColumn,
  CompanyManagerUpdateColumn,
  CompanyRelationConstraint,
  CompanyRelationSelectColumn,
  CompanyRelationUpdateColumn,
  CompanySelectColumn,
  CompanyUpdateColumn,
  CompanyVatNumberConstraint,
  CompanyVatNumberSelectColumn,
  CompanyVatNumberSelectColumnCompanyVatNumberAggregateBoolExpBoolAndArgumentsColumns,
  CompanyVatNumberSelectColumnCompanyVatNumberAggregateBoolExpBoolOrArgumentsColumns,
  CompanyVatNumberUpdateColumn,
  ContentArticleConstraint,
  ContentArticleSelectColumn,
  ContentArticleUpdateColumn,
  ContentCategoryConstraint,
  ContentCategorySelectColumn,
  ContentCategoryUpdateColumn,
  ContentPageConstraint,
  ContentPageSelectColumn,
  ContentPageUpdateColumn,
  ContractComputer,
  ContractConstraint,
  ContractFetch,
  ContractFixedDataComputer,
  ContractSelectColumn,
  ContractUpdateColumn,
  CountryConstraint,
  CountrySelectColumn,
  CountryUpdateColumn,
  CurrencyConstraint,
  CurrencyRateConstraint,
  CurrencyRateSelectColumn,
  CurrencyRateUpdateColumn,
  CurrencySelectColumn,
  CurrencyUpdateColumn,
  CursorOrdering,
  DIAMANT_ACCOUNT_FIELDS,
  DIAMANT_ACCOUNT_TAB_FIELDS,
  DIAMANT_CUSTOMER_FIELDS,
  DIAMANT_CUSTOMER_TAB_FIELDS,
  DIAMANT_INVOICE_OI_FIELDS,
  DIAMANT_INVOICE_POSTING_FIELDS,
  DIAMANT_INVOICE_STATUS_FIELDS,
  DIAMANT_PROOF_OF_SETTLEMENT,
  DISCOUNT_TYPES,
  DISCOUNT_TYPES_SHORT,
  GERMAN_COUNTRIES,
  GQL_COMPANIES,
  GQL_COMPANY,
  GQL_COMPANY_ADDRESSES,
  GQL_COMPANY_CREATE,
  GQL_COMPANY_DELETE,
  GQL_COMPANY_UPDATE,
  GQL_CONTENT_ARTICLE_CATEGORY,
  GQL_CONTENT_ARTICLE_LIST,
  GQL_CONTENT_CATEGORY_LIST,
  GQL_CONTENT_PAGE,
  GQL_CONTENT_PAGE_LIST,
  GQL_DIAMANT_ACCOUNTS,
  GQL_DIAMANT_CUSTOMERS,
  GQL_DIAMANT_INVOICE_STATUS,
  GQL_DIAMANT_INVOICE_STATUS_BATCH,
  GQL_DIAMANT_OIS,
  GQL_FACETS,
  GQL_INVOICE,
  GQL_INVOICE_LIST,
  GQL_OBJECT_BOOKMARK,
  GQL_PROJECT,
  GQL_PROJECT_CALENDAR,
  GQL_PROJECT_COUNT,
  GQL_PROJECT_COUNT_FEED,
  GQL_PROJECT_CREATE,
  GQL_PROJECT_FEED,
  GQL_PROJECT_LIST,
  GQL_PROJECT_UPDATE,
  GQL_PROJECT_VIEW,
  GQL_USER_ACCOUNTS_BY_EMAIL,
  GQL_USER_ACCOUNT_BY_ID,
  GQL_USER_BOOKMARK_CREATE,
  GQL_USER_BOOKMARK_DELETE,
  GQL_USER_BOOKMARK_LIST,
  INVOICE_ATTACHMENT_POLICY,
  INVOICE_FIELDS,
  INVOICE_STATES,
  INVOICE_TYPES,
  InvoiceAddress,
  InvoiceCalculator,
  InvoiceComputer,
  InvoiceConstraint,
  InvoiceDepositConstraint,
  InvoiceDepositSelectColumn,
  InvoiceDepositUpdateColumn,
  InvoiceFetch,
  InvoiceSelectColumn,
  InvoiceSelectColumnInvoiceAggregateBoolExpBoolAndArgumentsColumns,
  InvoiceSelectColumnInvoiceAggregateBoolExpBoolOrArgumentsColumns,
  InvoiceUpdateColumn,
  LANGUAGES,
  Math2 as Math,
  OfficeConstraint,
  OfficeManagerConstraint,
  OfficeManagerSelectColumn,
  OfficeManagerUpdateColumn,
  OfficeSelectColumn,
  OfficeUpdateColumn,
  OrderBy,
  PROJECT_BASE,
  PROJECT_BUDGETS,
  PROJECT_RELATIONS_LINE,
  PROJECT_SERVICES,
  PROJECT_STATES,
  PresetConstraint,
  PresetSelectColumn,
  PresetUpdateColumn,
  ProjectConstraint,
  ProjectGroupConstraint,
  ProjectGroupManagerConstraint,
  ProjectGroupManagerSelectColumn,
  ProjectGroupManagerUpdateColumn,
  ProjectGroupSelectColumn,
  ProjectGroupUpdateColumn,
  ProjectManagerConstraint,
  ProjectManagerSelectColumn,
  ProjectManagerUpdateColumn,
  ProjectSelectColumn,
  ProjectUpdateColumn,
  SERVICE_BUY_TAX_TYPES,
  SERVICE_CATEGORIES,
  SERVICE_CATEGORY_ICONS,
  SERVICE_LABELS,
  SERVICE_SELL_TAX_TYPES,
  SERVICE_TAX_TYPES,
  ServiceCalculator,
  ServiceConstraint,
  ServiceGroupConstraint,
  ServiceGroupSelectColumn,
  ServiceGroupSelectColumnServiceGroupAggregateBoolExpBoolAndArgumentsColumns,
  ServiceGroupSelectColumnServiceGroupAggregateBoolExpBoolOrArgumentsColumns,
  ServiceGroupUpdateColumn,
  ServiceInvoiceConstraint,
  ServiceInvoiceSelectColumn,
  ServiceInvoiceUpdateColumn,
  ServiceSelectColumn,
  ServiceSelectColumnServiceAggregateBoolExpBoolAndArgumentsColumns,
  ServiceSelectColumnServiceAggregateBoolExpBoolOrArgumentsColumns,
  ServiceUpdateColumn,
  SystemActivityConstraint,
  SystemActivitySelectColumn,
  SystemActivityUpdateColumn,
  SystemMigrationsConstraint,
  SystemMigrationsLockConstraint,
  SystemMigrationsLockSelectColumn,
  SystemMigrationsLockUpdateColumn,
  SystemMigrationsSelectColumn,
  SystemMigrationsUpdateColumn,
  SystemWebhookConstraint,
  SystemWebhookSelectColumn,
  SystemWebhookUpdateColumn,
  TaxConstraint,
  TaxFederationConstraint,
  TaxFederationSelectColumn,
  TaxFederationUpdateColumn,
  TaxSelectColumn,
  TaxUpdateColumn,
  USERGROUPS,
  USERPROFILE,
  USER_BOOKMARK_FIELDS,
  USER_ROLES,
  UserAccountConstraint,
  UserAccountGroupSelectColumn,
  UserAccountSelectColumn,
  UserAccountUpdateColumn,
  UserBookmarkConstraint,
  UserBookmarkSelectColumn,
  UserBookmarkUpdateColumn,
  UserGroupConstraint,
  UserGroupSelectColumn,
  UserGroupUpdateColumn,
  WndlCrudSchema,
  api,
  app,
  constants,
  crud,
  index_default as default,
  taxEnabledForDepositInvoice
};
//# sourceMappingURL=index.mjs.map